// AUTO-GENERATED CODE, DO NOT EDIT!
//
// These types are generated from the schema
// base types and should not be used
//
/* eslint-disable */

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Date: any
  DateTime: any
  JSON: any
}

export type AddContractDocumentInput = {
  companyID: Scalars['Int']
  contentType: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  key: Scalars['String']
}

export type AddProposalCommentInput = {
  body: Scalars['String']
  eventUuid: Scalars['String']
  proposalUuid: Scalars['String']
}

export type AddStaffVenueNoteInput = {
  body: Scalars['String']
  venueId: Scalars['Int']
}

export type AddUsersToTeamInput = {
  /**
   * The company the caller believes the team belongs to.
   *
   * Checked rather than trusted: team ids are global, so a mistyped one is
   * a valid team belonging to another customer. A disagreement fails the
   * whole call.
   */
  companyID: Scalars['Int']
  teamID: Scalars['Int']
  users: Array<TeamMemberInput>
}

export type AdditionalContact = {
  __typename?: 'AdditionalContact'
  email: Scalars['String']
  id: Scalars['Int']
  listingId: Scalars['Int']
  name: Scalars['String']
  phoneNumber: Scalars['String']
}

export type AdditionalContactInput = {
  email: Scalars['String']
  name: Scalars['String']
  phoneNumber: Scalars['String']
}

export type AdditionalContactUpdateInput = {
  email?: InputMaybe<Scalars['String']>
  id: Scalars['Int']
  name?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
}

/**
 * One entry in a user's admin history.
 *
 * Carries no personal data by construction: an action, the names of the
 * fields it touched, who did it and when. Never the values — an audit log
 * that duplicated them would be a second store of personal data, which a
 * GDPR erasure would then have to find and scrub.
 */
export type AdminAuditEntry = {
  __typename?: 'AdminAuditEntry'
  /** Dotted verb: user.update, user.lock, user.unlock, user.erase, user.password_reset. */
  action: Scalars['String']
  /** 0 is the shared backend token — a service holding ADMIN_TOKEN, not a user. */
  actorId: Scalars['Int']
  /** Null when the actor cannot be named: the backend token, or an actor since erased. */
  actorName?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  /** Field NAMES only, and only for actions that change fields. */
  fields?: Maybe<Array<Scalars['String']>>
  id: Scalars['Int']
}

export type AdminUser = {
  __typename?: 'AdminUser'
  anonymisedAt?: Maybe<Scalars['String']>
  anonymisedBy?: Maybe<Scalars['Int']>
  anonymisedByName?: Maybe<Scalars['String']>
  /**
   * The linked company (company_users -> companies). Null on the list, which
   * cannot join without multiplying rows; populated on the detail view.
   * Distinct from companyName, which is free text typed at sign-up.
   */
  companyId?: Maybe<Scalars['Int']>
  companyName?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  id: Scalars['Int']
  isDirectEnquiryEnabled?: Maybe<Scalars['Boolean']>
  isErased: Scalars['Boolean']
  /**
   * A listing HeadBox created rather than the venue, decided from the shape
   * of this account's email.
   *
   * ⚠️ The same rule as hb-host-listing-management-backend's Space.isGhost,
   * transcribed rather than tidied — including the fact that the headbox
   * match is unanchored and case-sensitive. Two implementations of one
   * definition is a debt recorded in the adapter, not a design.
   */
  isGhost: Scalars['Boolean']
  /**
   * Whether this account is a Power Host AS AT NOW: the stored flag set,
   * AND the expiry either absent or still in the future.
   *
   * RedBox's own definition is exactly this (app/models/user.rb), and the
   * expiry belongs in the question rather than being left to the column:
   * the job that clears the column runs daily, so for up to a day an
   * account reads true from the column alone and false to RedBox. Trusting
   * the column would make this service the one telling a different story.
   *
   * ⚠️ ONE EXPRESSION WITH THE powerHost FILTER, evaluated in the same
   * SELECT. That is what makes "only Power Hosts" incapable of returning a
   * row that renders without the badge, and it means the flag costs no
   * extra query and the filter runs before paging.
   */
  isLivePowerHost: Scalars['Boolean']
  isLocked: Scalars['Boolean']
  /**
   * The STORED Power Host flag and its stored expiry, exactly as RedBox
   * holds them. Honest read as a PAIR — "yes, until the 3rd" is what the
   * contracts panel prints from them — and misleading read alone: a daily
   * Clockwork job in RedBox clears the boolean some time AFTER the expiry
   * passes, so in between this says true for an account RedBox itself
   * already treats as lapsed.
   *
   * ⚠️ For "is this a Power Host right now", read isLivePowerHost. These
   * two are unchanged on purpose — the contracts panel wants the pair, and
   * other consumers already read isPowerHost — so the derived answer is a
   * THIRD field rather than a redefinition of these.
   */
  isPowerHost?: Maybe<Scalars['Boolean']>
  jobTitle?: Maybe<Scalars['String']>
  lastName: Scalars['String']
  lastSignInAt?: Maybe<Scalars['String']>
  linkedCompanyName?: Maybe<Scalars['String']>
  locale?: Maybe<Scalars['String']>
  lockedAt?: Maybe<Scalars['String']>
  /** Actor that locked the account. 0 means the shared backend token. */
  lockedBy?: Maybe<Scalars['Int']>
  /**
   * The actors' names, resolved for display. Null when the id is 0 — the
   * shared backend token, a service rather than a person — or when the
   * account behind it no longer exists, since an operator can themselves be
   * erased and an audit row must outlive them. Detail view only.
   */
  lockedByName?: Maybe<Scalars['String']>
  lockedReason?: Maybe<Scalars['String']>
  /**
   * Whether this account has opted IN to marketing EMAIL: true when ANY of
   * the five consent_* notification preferences carries an email yes, false
   * when none does and false for an account with no consent rows at all.
   *
   * ⚠️ EMAIL ONLY. The same rows carry a separate txt consent for SMS,
   * which this never reads and updateUser never writes: the admin screen
   * asks one question, and answering a second on the back of it would be
   * consent nobody gave.
   */
  marketingEmailConsent: Scalars['Boolean']
  /** Mobile if present, else landline. */
  phoneNumber?: Maybe<Scalars['String']>
  powerhostExpiresAt?: Maybe<Scalars['String']>
  regions: Array<Scalars['String']>
  roles: Array<Scalars['String']>
  signInCount?: Maybe<Scalars['Int']>
  tier?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['String']>
  /**
   * Whether the CALLER may act on this user — rank at or below their own,
   * and inside the countries they cover.
   *
   * Answered by the server rather than mirrored by each client. The rule
   * depends on both parties, so a client copy would be a second
   * implementation of an authorization decision, and the two would
   * eventually disagree. Editing and impersonation share one answer because
   * they are the same power over the same person.
   */
  viewerCanActOn: Scalars['Boolean']
}

export enum AdminUserAccountState {
  Active = 'ACTIVE',
  Erased = 'ERASED',
  Locked = 'LOCKED',
}

export type AdminUsersFilter = {
  accountState?: InputMaybe<AdminUserAccountState>
  countries?: InputMaybe<Array<Scalars['String']>>
  /** Hide ghost accounts, or show only them. Absent shows both. */
  ghost?: InputMaybe<AdminUsersGhostFilter>
  /**
   * These user ids, IN ADDITION TO whatever query matches.
   *
   * For a caller that has resolved WHO it wants somewhere else and needs
   * those people back through this query's gate — hb-admin's venue search
   * does it, turning the owners of a matching venue into host accounts.
   * The country scoping still applies on top, so an id outside your reach
   * is silently absent rather than an error, exactly as on the single-user
   * query.
   *
   * ⚠️ COMBINES WITH query BY OR, not by AND — the only pair here that
   * does. The two answer the same question from one search box: who is
   * this, whether the term matched them or something they own.
   * Intersecting them would ask for a user whose email contains the term
   * AND who owns a venue named after it, which is nobody. Every other
   * field still narrows whatever this predicate found.
   *
   * An EMPTY list contributes nothing, which means it is nobody when it
   * stands alone and harmless beside a query. A venue lookup that matched
   * nothing must not delete the email matches next to it.
   */
  ids?: InputMaybe<Array<Scalars['Int']>>
  /**
   * These user ids removed from whatever else matched — NOT IN.
   *
   * An EMPTY list excludes nobody and is a no-op. The empty-set rule above
   * governs which users a filter ADMITS; this one admits everybody it was
   * not given.
   */
  idsExclude?: InputMaybe<Array<Scalars['Int']>>
  /**
   * These user ids, INTERSECTED with everything else — the narrowing
   * counterpart to the field above.
   *
   * For a caller whose id set was resolved somewhere else and has to cut
   * the search down rather than widen it: hb-admin's venues screen gets
   * its contracted set from other services, and wants the users who are
   * both contracted AND matched by the term, not either.
   *
   * ⚠️ ANDs with every other field, INCLUDING the query/ids identity
   * predicate. Two id fields that look alike and combine oppositely is
   * deliberate rather than an oversight — one search box asking who this
   * is, and one externally-resolved set narrowing whoever it found, are
   * different questions and no single field answers both.
   *
   * An EMPTY list is nobody, never everybody. The same honest-empty-set
   * rule the ids field documents: a lookup that matched nothing narrows to
   * nothing.
   */
  idsIntersect?: InputMaybe<Array<Scalars['Int']>>
  /**
   * Hide live Power Hosts, or show only them. Absent shows both.
   *
   * ⚠️ ANSWERS isLivePowerHost, NOT the stored isPowerHost. The two
   * disagree for any account whose expiry has passed while RedBox's daily
   * job has yet to clear the column, and this filter is the SAME
   * expression the field is projected from — deliberately, so that ONLY
   * cannot return a row the list then renders without a Power Host badge.
   * A filter and a row disagreeing about one account is the Locked filter
   * bug; see the adapter for what that looked like.
   */
  powerHost?: InputMaybe<AdminUsersPowerHostFilter>
  /**
   * Substring across email, first name, last name and company name.
   * Ignored below three characters — a one-letter term scans the whole
   * table to return something nobody wanted.
   */
  query?: InputMaybe<Scalars['String']>
  /**
   * Filter by region rather than country. Resolved server-side through the
   * region taxonomy, so no client holds a copy of it. Combined with the
   * countries filter by intersection, not union.
   *
   * NOTE: no backticks in these descriptions — the schema is a gql tagged
   * template, and a backtick ends the literal.
   */
  regions?: InputMaybe<Array<Scalars['String']>>
  /** Users holding ANY of these roles, not exactly these roles. */
  roles?: InputMaybe<Array<Scalars['String']>>
}

/**
 * What to do about ghost accounts — listings HeadBox created rather than the
 * venue, identified by the shape of the account's email address.
 *
 * Absent means neither: they appear alongside everyone else. A narrowing an
 * operator did not ask for is one they cannot see, and this list has no
 * filter chips to show it in.
 */
export enum AdminUsersGhostFilter {
  Exclude = 'EXCLUDE',
  Only = 'ONLY',
}

export type AdminUsersPage = {
  __typename?: 'AdminUsersPage'
  /**
   * Whether a further page exists. Deliberately not a total: an exact count
   * re-runs the predicate across the table on every page load, and this
   * list exists so a few staff can find one person.
   */
  hasMore: Scalars['Boolean']
  items: Array<AdminUser>
}

export type AdminUsersPagination = {
  /**
   * Order the page by position in this list. ORDERING ONLY: it never
   * admits a row the filter excluded and it never removes one the filter
   * admitted. An id here that the filter did not admit is simply absent
   * from the result.
   *
   * The caller is expected to send the ids it put in filter.ids, in the
   * order it wants them back. The ranking is decided wherever those ids
   * were resolved; this field only carries it through.
   *
   * ⚠️ Rows the filter admitted but did NOT list sort BEFORE the listed
   * ones, by id descending, not after them. A row nobody ranked matched on
   * the account itself rather than on something it owns, and burying an
   * exact email hit under every fuzzily matched venue owner is the wrong
   * answer on every search that is not a venue search.
   *
   * An EMPTY list and an ABSENT one are the same no-op: id descending,
   * exactly as without this field.
   */
  idsOrder?: InputMaybe<Array<Scalars['Int']>>
  limit: Scalars['Int']
  offset: Scalars['Int']
}

/**
 * What to do about Power Host accounts, judged LIVE rather than stored — see
 * AdminUser.isLivePowerHost for why the expiry is part of the question and
 * the stored boolean is not the whole of it.
 *
 * Absent means neither: they appear alongside everyone else. The same
 * default as the ghost filter above, for the same reason — a narrowing an
 * operator did not ask for is one they cannot see, and this list has no
 * filter chips to show it in.
 */
export enum AdminUsersPowerHostFilter {
  Exclude = 'EXCLUDE',
  Only = 'ONLY',
}

export type AgentDecision = {
  __typename?: 'AgentDecision'
  ID: Scalars['Int']
  adjudicatedAt?: Maybe<Scalars['DateTime']>
  adjudication?: Maybe<Scalars['String']>
  adjudicationNote?: Maybe<Scalars['String']>
  adjudicationReasons?: Maybe<Array<Scalars['String']>>
  bookingId?: Maybe<Scalars['Int']>
  createdAt: Scalars['DateTime']
  decisionJson: Scalars['String']
  eventAttendees?: Maybe<Scalars['Int']>
  eventId: Scalars['Int']
  eventLocation?: Maybe<Scalars['String']>
  eventName?: Maybe<Scalars['String']>
  eventRegion?: Maybe<Scalars['String']>
  eventUUID?: Maybe<Scalars['String']>
  humanOutcomeJson?: Maybe<Scalars['String']>
  inputSnapshotJson: Scalars['String']
  outcomeComputedAt?: Maybe<Scalars['DateTime']>
  policyVersion: Scalars['String']
  reasoning?: Maybe<Scalars['String']>
  runId: Scalars['String']
  stage: Scalars['String']
  verdict: Scalars['String']
}

export type AgentPanelStatus = {
  __typename?: 'AgentPanelStatus'
  authorised: Scalars['Boolean']
  paused: Scalars['Boolean']
}

export enum AgreementType {
  Contra = 'CONTRA',
  Free = 'FREE',
  Standard = 'STANDARD',
  Trial = 'TRIAL',
}

export type AmLeadsFilter = {
  regions?: InputMaybe<Array<Scalars['String']>>
  status?: InputMaybe<Scalars['String']>
}

export type AssignUserToCompanyInput = {
  companyID: Scalars['Int']
  role: Scalars['String']
  status: CompanyUserStatus
  userID: Scalars['Int']
}

export type AssignUserToRoleInput = {
  role: BusinessRoles
  userID: Scalars['Int']
}

export enum Audience {
  Personal = 'personal',
  Professional = 'professional',
}

export type AuthenticateGuestInput = {
  email: Scalars['String']
  password: Scalars['String']
}

export type AuthenticateWithMagicLinkInput = {
  /**
   * The raw token from the emailed link's query string. Single use: it is
   * claimed by this mutation whether or not the sign-in then succeeds.
   */
  token: Scalars['String']
}

export type Avatar = {
  __typename?: 'Avatar'
  normal?: Maybe<Scalars['String']>
  small?: Maybe<Scalars['String']>
  thumb?: Maybe<Scalars['String']>
}

export type Avatars = {
  __typename?: 'Avatars'
  normal?: Maybe<Scalars['String']>
  small?: Maybe<Scalars['String']>
  thumb?: Maybe<Scalars['String']>
}

/** Type of collection / event_type. */
export type Bbbe_Collection = {
  __typename?: 'BBBE_Collection'
  features?: Maybe<Array<Feature>>
  id: Scalars['ID']
  layouts?: Maybe<Array<Scalars['String']>>
  name: Scalars['String']
}

export type BeginSsoLoginInput = {
  provider: Scalars['String']
  redirectTo?: InputMaybe<Scalars['String']>
}

export type BookerNote = {
  __typename?: 'BookerNote'
  ID: Scalars['Int']
  bookerId: Scalars['Int']
  canEdit: Scalars['Boolean']
  category?: Maybe<BookerNoteCategory>
  createdAt: Scalars['DateTime']
  createdByName: Scalars['String']
  eventId?: Maybe<Scalars['Int']>
  note: Scalars['String']
  updatedAt?: Maybe<Scalars['DateTime']>
  updatedByName?: Maybe<Scalars['String']>
}

export enum BookerNoteCategory {
  Logistics = 'logistics',
  Preference = 'preference',
  Relationship = 'relationship',
  Warning = 'warning',
}

export type BookerProfile = {
  __typename?: 'BookerProfile'
  bookerId: Scalars['Int']
  generatedAt?: Maybe<Scalars['DateTime']>
  isStale: Scalars['Boolean']
  recommendationHints?: Maybe<Scalars['String']>
  sourceStats?: Maybe<BookerProfileSourceStats>
  summary?: Maybe<Scalars['String']>
  traits?: Maybe<Array<BookerProfileTrait>>
}

export type BookerProfileSourceStats = {
  __typename?: 'BookerProfileSourceStats'
  acceptedEventsAnalysed: Scalars['Int']
  declinedEventsAnalysed: Scalars['Int']
  eventsAnalysed: Scalars['Int']
  lastEventAt?: Maybe<Scalars['DateTime']>
}

export type BookerProfileTrait = {
  __typename?: 'BookerProfileTrait'
  evidence: Scalars['String']
  source: BookerProfileTraitSource
  trait: Scalars['String']
}

export enum BookerProfileTraitSource {
  Events = 'events',
  Notes = 'notes',
}

export type Booking = EventAndBookingFields & {
  __typename?: 'Booking'
  additionalNotes?: Maybe<Scalars['String']>
  additionalSpends?: Maybe<Array<Booking>>
  attendees: Scalars['Int']
  /**
   * This could be replaced by a bookingFolder resolver, but recursive resolver querying isn't currently
   * possible in GraphQL, so folder-booking relationships are currently reconstructed in the frontend.
   */
  bookingFolderId?: Maybe<Scalars['Int']>
  /** any user that clicked request to book button */
  bookingRequestedAt?: Maybe<Scalars['DateTime']>
  bookingRequestedBy?: Maybe<User>
  budget: Scalars['Int']
  cateringNeeds?: Maybe<Scalars['String']>
  closedAmount?: Maybe<Scalars['Int']>
  closedAmountCompanyCurrency?: Maybe<Scalars['Int']>
  closedAt?: Maybe<Scalars['DateTime']>
  commissionPercentage?: Maybe<Scalars['Float']>
  commissionableAmount?: Maybe<Scalars['Int']>
  completedAt?: Maybe<Scalars['DateTime']>
  convertedBookingBudget: ConvertedBookingBudget
  country: Scalars['String']
  createdAt: Scalars['DateTime']
  currency: SupportedCurrencyCode
  /** The deadline for procurement information to be finalised. It defaults to one month after creation. */
  decisionDate: Scalars['String']
  event: Event
  /**
   * Optional, in case the booking event-type differs from the parent event's type. Used to stich in
   * the 'Collection' event type entity by the gateway.
   */
  eventType?: Maybe<Collection>
  fastTrackSupplierEmail?: Maybe<Scalars['String']>
  fastTrackSupplierName?: Maybe<Scalars['String']>
  fastTracked?: Maybe<Scalars['Boolean']>
  firstInvitationSentAt?: Maybe<Scalars['String']>
  firstProposalReceivedAt?: Maybe<Scalars['String']>
  firstProposalsSentToGuestAt?: Maybe<Scalars['String']>
  flexibleDatesNote?: Maybe<Scalars['String']>
  /** Event start time as 'zoneless' DateTime */
  fromDateTime: Scalars['DateTime']
  fxRate?: Maybe<Scalars['Float']>
  hubspotID?: Maybe<Scalars['String']>
  hubspotVenueName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  invitations: Array<Invitation>
  isAdditionalSpendBooking: Scalars['Boolean']
  isCommisionable?: Maybe<Scalars['Boolean']>
  isFlexibleWithDates: Scalars['Boolean']
  lat: Scalars['Float']
  layoutId: Scalars['String']
  /**
   * This tracks the different phases of bookings. It's updated automatically and used to belong to
   * events.
   */
  lifecycleStage: LifecycleStage
  location: Scalars['String']
  locationPolygon?: Maybe<Scalars['String']>
  lon: Scalars['Float']
  lostAt?: Maybe<Scalars['String']>
  lostReason?: Maybe<Scalars['String']>
  managementStatus: ManagementStatus
  marketPrice?: Maybe<Scalars['Int']>
  name: Scalars['String']
  /** The HeadBox staff member currently responsible for the event. */
  owner?: Maybe<User>
  parentBookingId?: Maybe<Scalars['Int']>
  paymentsInvoiceReference?: Maybe<Scalars['String']>
  /** Determines the booking's order within the current folder or event. */
  position: Scalars['Int']
  processingFeePercentage?: Maybe<Scalars['Float']>
  proposals: Array<Proposal>
  radius: Scalars['Float']
  region: Scalars['String']
  releaseReason?: Maybe<EventReleaseReason>
  requestedToBookAt?: Maybe<Scalars['DateTime']>
  requestedToBookProposal?: Maybe<Proposal>
  /**
   * Typed requirement object (registry-shaped; see requirementRegistry query).
   * Null on legacy bookings.
   */
  requirements?: Maybe<Scalars['JSON']>
  rtbRollbackReason?: Maybe<Scalars['String']>
  /** Set when an admin rolled an accidental request to book back to ProposalsSent */
  rtbRolledBackAt?: Maybe<Scalars['DateTime']>
  rtbRolledBackBy?: Maybe<User>
  solutionsInvoiceReference?: Maybe<Scalars['String']>
  source: Scalars['String']
  spaceFacilities: Array<SpaceFacility>
  styles: Array<Style>
  /**
   * The user who originally created the event (either the guest or a HeadBox staff member). It's
   * nullable as, for some reason, it wasn't being populated before the "2.0" overhaul work.
   */
  submitter?: Maybe<User>
  /**
   * Determines the kind of suppliers relevant for the booking, such as venues, catering,
   * etc.
   */
  supplierType: SupplierType
  supplierTypeEditable: Scalars['Boolean']
  takeOver: Scalars['Boolean']
  takeOverFee?: Maybe<Scalars['Int']>
  takeOverFeePercentage?: Maybe<Scalars['Float']>
  /** Event end time as 'zoneless' DateTime */
  toDateTime: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
  venueConfirmation?: Maybe<BookingVenueConfirmation>
  venueConfirmationMatch?: Maybe<VenueConfirmationMatch>
}

export type BookingConvertedBookingBudgetArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type BookingInvitationsArgs = {
  filter?: InputMaybe<InvitationsFilter>
}

export type BookingProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>
}

export enum BookingIntent {
  High = 'high',
  Low = 'low',
  Medium = 'medium',
}

export type BookingVenueConfirmation = {
  __typename?: 'BookingVenueConfirmation'
  ID: Scalars['Int']
  confidence: VenueConfirmationConfidence
  confirmedAt: Scalars['DateTime']
  confirmedBy?: Maybe<User>
  hubspotVenueName?: Maybe<Scalars['String']>
  isGhost: Scalars['Boolean']
  matchType: VenueConfirmationMatchType
  proposalID?: Maybe<Scalars['Int']>
  spaceID?: Maybe<Scalars['Int']>
  spaceName?: Maybe<Scalars['String']>
  swapReason?: Maybe<VenueConfirmationSwapReason>
  swapReasonNote?: Maybe<Scalars['String']>
  venueID?: Maybe<Scalars['Int']>
  venueName?: Maybe<Scalars['String']>
}

export type BookingsFilter = {
  archived?: InputMaybe<Scalars['Boolean']>
  confirmedBooking?: InputMaybe<Scalars['Boolean']>
  eventId?: InputMaybe<Scalars['Int']>
  eventUuid?: InputMaybe<Scalars['String']>
  excludedStatuses?: InputMaybe<Array<Scalars['String']>>
  id?: InputMaybe<Scalars['Int']>
  invitedServiceIds?: InputMaybe<Array<Scalars['Int']>>
  maxEventAgeInDays?: InputMaybe<Scalars['Int']>
  restrictToUser?: InputMaybe<Scalars['Boolean']>
  upcomingOnly?: InputMaybe<Scalars['Boolean']>
  uuid?: InputMaybe<Scalars['String']>
}

export type BookingsFolder = {
  __typename?: 'BookingsFolder'
  bookingsFolderBudget: ConvertedAmount
  budget?: Maybe<Scalars['Int']>
  event: Event
  /** Optional categorisation of the folder by the event type. */
  eventType?: Maybe<Collection>
  id: Scalars['Int']
  name: Scalars['String']
  /** The position of the folder within the current folder (if parentFolder defined) or event. */
  notes?: Maybe<Scalars['String']>
  /**
   * This could be replaced by parentFolder and childFolders resolvers, but recursive resolver querying
   * isn't currently possible in GraphQL, so folder hierarchies are currently reconstructed in the
   * frontend.
   */
  parentFolderId?: Maybe<Scalars['Int']>
  position: Scalars['Int']
}

export type BookingsPagination = {
  lastPaginatedBookingId?: InputMaybe<Scalars['Int']>
  pageSize: Scalars['Int']
}

export type BotCandidateJobResponse = {
  __typename?: 'BotCandidateJobResponse'
  candidateId: Scalars['String']
  jobId: Scalars['String']
}

export type BotResearchJobResponse = {
  __typename?: 'BotResearchJobResponse'
  jobId: Scalars['String']
}

/** Type of a normal brief. */
export type Brief = {
  __typename?: 'Brief'
  additionalNotes?: Maybe<Scalars['String']>
  /** Is this a personal or professional event? */
  audience?: Maybe<Audience>
  /** How likely is the guest to book? */
  bookingIntent?: Maybe<BookingIntent>
  budget: Scalars['Float']
  budgetGuidanceAverage?: Maybe<Scalars['Int']>
  budgetGuidanceBasic?: Maybe<Scalars['Int']>
  budgetGuidanceHighEnd?: Maybe<Scalars['Int']>
  budgetNotes?: Maybe<Scalars['String']>
  capacities: Scalars['Int']
  /** Archived */
  catering?: Maybe<Array<Scalars['String']>>
  cateringNeeds?: Maybe<Scalars['String']>
  collection: Scalars['JSON']
  collectionName: Scalars['String']
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  currency: Scalars['String']
  /** Deal ID on Hubspot */
  dealId?: Maybe<Scalars['String']>
  /** Event From (Full DateTime) */
  eventDateFrom: Scalars['String']
  /** Event To (Full DateTime) */
  eventDateTo: Scalars['String']
  eventName: Scalars['String']
  /** @deprecated Superceded by isFlexibleOnDate and isFlexibleOnTime in Lead Feed */
  flexibleDates: Scalars['Boolean']
  /** Additional notes on flexibility. Used with legacy flexible_dates and new flexible_on_date/time fields */
  flexibleDatesNote?: Maybe<Scalars['String']>
  fromDate: Scalars['String']
  fromTime: Scalars['String']
  guest: BriefGuest
  /** Guest (User) ID */
  guestId: Scalars['ID']
  /** Host (User) ID */
  hostId?: Maybe<Scalars['ID']>
  id: Scalars['ID']
  /** Date-specific flexibility field for Lead Feed */
  isFlexibleOnDate?: Maybe<Scalars['Boolean']>
  /** Time-specific flexibility field for Lead Feed */
  isFlexibleOnTime?: Maybe<Scalars['Boolean']>
  lat: Scalars['Float']
  layout: Scalars['String']
  leadFeedCity?: Maybe<Scalars['String']>
  location: Scalars['String']
  lon: Scalars['Float']
  /** The maximum number of undeclined messages this brief will be able to receive. The value comes from e-tenders */
  messageLimit?: Maybe<Scalars['Int']>
  numonce?: Maybe<Scalars['Int']>
  /** The space facilities considered desirable by the guest */
  optionalSpaceFacilities: Array<SpaceFacility>
  public: Scalars['Boolean']
  radius: Scalars['Float']
  /** The space facilities considered essential by the guest */
  requiredSpaceFacilities: Array<SpaceFacility>
  /**
   * List of all space facilities
   * @deprecated Lead Feed now distuinguishes between optional and required facilities
   */
  spaceFacilities: Array<SpaceFacility>
  spaceId?: Maybe<Scalars['ID']>
  status: Scalars['String']
  styleIds: Array<Scalars['String']>
  tier: Scalars['String']
  toDate: Scalars['String']
  toTime: Scalars['String']
  /** Guest (User) ID */
  userId: Scalars['ID']
  virtual: Scalars['Boolean']
}

/**
 * Attributes for creating or updating a brief.
 *     Also means what we get from BriefBuidler FrontEnd.
 */
export type BriefAttributes = {
  additionalNotes?: InputMaybe<Scalars['String']>
  /** Specify whether this is a personal or professional event */
  audience?: InputMaybe<Audience>
  /** An indication of how likely a guest is to book */
  bookingIntent?: InputMaybe<BookingIntent>
  budget: Scalars['Int']
  budgetGuidanceAverage?: InputMaybe<Scalars['Int']>
  budgetGuidanceBasic?: InputMaybe<Scalars['Int']>
  budgetGuidanceHighEnd?: InputMaybe<Scalars['Int']>
  budgetNotes?: InputMaybe<Scalars['String']>
  bypassAutomation?: InputMaybe<Scalars['Boolean']>
  capacities: Scalars['Int']
  catering?: InputMaybe<Array<Scalars['String']>>
  cateringNeeds?: InputMaybe<Scalars['String']>
  collection?: InputMaybe<Scalars['String']>
  collectionName?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  currency?: InputMaybe<Scalars['String']>
  /** A list of content pages visted prior to submitting brief */
  enquiryContentPageSources?: InputMaybe<Array<Scalars['String']>>
  eventName?: InputMaybe<Scalars['String']>
  /** Deprecated: use requiredSpaceFacilityIds and/or optionalSpaceFacilityIds instead. */
  facilities?: InputMaybe<Array<Scalars['String']>>
  /** Deprecated: this parameter is completely ignored. */
  facilitiesList?: InputMaybe<Array<Scalars['String']>>
  /** Deprecated: superceded by isFlexibleOnDate/Time fields for Lead Feed */
  flexibleDates?: InputMaybe<Scalars['Boolean']>
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDate?: InputMaybe<Scalars['String']>
  fromTime?: InputMaybe<Scalars['String']>
  hostId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['Int']>
  isFlexibleOnDate?: InputMaybe<Scalars['Boolean']>
  isFlexibleOnTime?: InputMaybe<Scalars['Boolean']>
  lat: Scalars['String']
  layouts?: InputMaybe<Scalars['String']>
  leadFeedCity?: InputMaybe<Scalars['String']>
  location: Scalars['String']
  lon: Scalars['String']
  numonce?: InputMaybe<Scalars['Int']>
  /** IDs for the facilities considered 'desirable' by the user */
  optionalSpaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  public?: InputMaybe<Scalars['Boolean']>
  qualifiesForConcierge?: InputMaybe<Scalars['Boolean']>
  radius?: InputMaybe<Scalars['Float']>
  /** IDs for the facilities considered 'essential' by the user */
  requiredSpaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  /** Deprecated: use requiredSpaceFacilityIds and/or optionalSpaceFacilityIds instead. */
  spaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  spaceId?: InputMaybe<Scalars['String']>
  styleIds?: InputMaybe<Array<Scalars['String']>>
  tier?: InputMaybe<Scalars['String']>
  toDate?: InputMaybe<Scalars['String']>
  toTime?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['Int']>
  virtual?: InputMaybe<Scalars['Boolean']>
}

/** Type of a guest user who created the brief. */
export type BriefGuest = {
  __typename?: 'BriefGuest'
  company: Scalars['String']
  country?: Maybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  id: Scalars['ID']
  isBusinessUser: Scalars['Boolean']
  lastName: Scalars['String']
  mobileNumber?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
}

export type BriefIsAutomatableResponse = {
  __typename?: 'BriefIsAutomatableResponse'
  /** Whether the brief is automatable. */
  isAutomatable: Scalars['Boolean']
}

export type BriefLatLon = {
  lat: Scalars['Float']
  lon: Scalars['Float']
}

export enum BusinessRoles {
  Administrator = 'administrator',
  Manager = 'manager',
  Member = 'member',
}

/** Full type merged into the schema in the gateway */
export type Collection = {
  __typename?: 'Collection'
  id: Scalars['Int']
  label: Scalars['String']
  name: Scalars['String']
}

export type CompaniesFilter = {
  countries?: InputMaybe<Array<HeadBoxCountry>>
  ids?: InputMaybe<Array<Scalars['Int']>>
  /**
   * Case-insensitive substring of the company name.
   *
   * Terms shorter than 3 characters are IGNORED rather than rejected — the
   * same floor the admin user search uses, so a half-typed query returns
   * the unfiltered list instead of an error.
   *
   * Combines with the other fields by AND, and with the caller's own region
   * scoping the same way: narrowing can never widen what you may see.
   */
  name?: InputMaybe<Scalars['String']>
  /**
   * Filter by region rather than country. Resolved HERE, through
   * auth-system, which owns the taxonomy — the same command that resolves
   * a regional manager's own regions.
   *
   * Deliberately not left to the caller. A client resolving regions itself
   * would need its own copy of the taxonomy, which is the defect this
   * service was fixed for in August 2026. It would also have to know which
   * codes this schema's HeadBoxCountry enum accepts: getCountriesByRegions
   * expands aliases, so a GB region resolves to a set containing both GB
   * and UK, and UK is NOT in that enum. Sent through countries it fails
   * GraphQL validation outright — a 400 that kills the whole query rather
   * than a filter matching nothing. Resolved here, the alias never meets
   * the enum and still reaches the WHERE clause, where stored UK values
   * live.
   *
   * Combines with countries by INTERSECTION, and with the caller's own
   * region scoping the same way: narrowing can never widen what you see.
   *
   * An EMPTY list is honoured as nobody, not as an absent filter — it is
   * what "these regions grant nothing" looks like.
   */
  regions?: InputMaybe<Array<Scalars['String']>>
}

export type CompaniesPagination = {
  limit: Scalars['Int']
  offset: Scalars['Int']
}

export type Company = {
  __typename?: 'Company'
  ID: Scalars['Int']
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  attributes: Array<CompanyAttribute>
  city?: Maybe<Scalars['String']>
  contract?: Maybe<CompanyContract>
  contractDocuments: Array<ContractDocument>
  country?: Maybe<HeadBoxCountry>
  currency: Scalars['String']
  domainTriageEnabled?: Maybe<Scalars['Boolean']>
  domains: Array<Scalars['String']>
  hideAdditionalSpendInGraphs: Scalars['Boolean']
  hideSoftSavings: Scalars['Boolean']
  id: Scalars['Int']
  isContracted?: Maybe<Scalars['Boolean']>
  logo?: Maybe<Scalars['String']>
  logo_curated?: Maybe<Scalars['String']>
  members: Array<CompanyUser>
  name: Scalars['String']
  postcode?: Maybe<Scalars['String']>
  teams: Array<CompanyTeam>
}

export type CompanyAttribute = {
  __typename?: 'CompanyAttribute'
  defaultValue?: Maybe<Scalars['String']>
  id: Scalars['Int']
  kind: CompanyAttributeKind
  name: Scalars['String']
}

export type CompanyAttributeInput = {
  defaultValue?: InputMaybe<Scalars['String']>
  kind: CompanyAttributeKind
  name: Scalars['String']
}

export enum CompanyAttributeKind {
  CompanyWide = 'company_wide',
  EventSpecific = 'event_specific',
}

export type CompanyContract = {
  __typename?: 'CompanyContract'
  agreementEndDate?: Maybe<Scalars['DateTime']>
  agreementStartDate?: Maybe<Scalars['DateTime']>
  agreementType: AgreementType
  company: Company
  contractEndDate?: Maybe<Scalars['DateTime']>
  contractStartDate?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  discountModel: Array<DiscountModelRow>
  discountModelNotes?: Maybe<Scalars['String']>
  feesNotes?: Maybe<Scalars['String']>
  id: Scalars['Int']
  implementationFee?: Maybe<Scalars['String']>
  internationalFee?: Maybe<Scalars['String']>
  managementFee?: Maybe<Scalars['Float']>
  nonCommissionableBookingFee?: Maybe<Scalars['String']>
  rebateModel: Array<RebateModelRow>
  rebateModelNotes?: Maybe<Scalars['String']>
  rebateThresholdSpendCountry?: Maybe<Scalars['String']>
  takeoverFee?: Maybe<Scalars['String']>
  thresholdSpendCountry?: Maybe<Scalars['String']>
}

export type CompanyReconciliationResult = {
  __typename?: 'CompanyReconciliationResult'
  aiSummary?: Maybe<Scalars['String']>
  amountDiff: Scalars['Float']
  commissionableAmountDiff: Scalars['Float']
  companyId: Scalars['Int']
  companyName: Scalars['String']
  country: Scalars['String']
  dbCommissionableAmount: Scalars['Float']
  dbDealCount: Scalars['Int']
  dbTakeoverCount: Scalars['Int']
  dbTotalAmount: Scalars['Float']
  dealCountDiff: Scalars['Int']
  dealsOnlyInDb: Array<DbOnlyDeal>
  dealsOnlyInHubspot: Array<HubSpotOnlyDeal>
  hasDiscrepancies: Scalars['Boolean']
  hubspotCommissionableAmount: Scalars['Float']
  hubspotDealCount: Scalars['Int']
  hubspotTakeoverCount: Scalars['Int']
  hubspotTotalAmount: Scalars['Float']
  periodEnd: Scalars['String']
  periodStart: Scalars['String']
  takeoverCountDiff: Scalars['Int']
}

export type CompanyTeam = {
  __typename?: 'CompanyTeam'
  ID: Scalars['Int']
  /** Who is in this team, and who runs it. */
  members: Array<TeamMember>
  name: Scalars['String']
}

export type CompanyUser = {
  __typename?: 'CompanyUser'
  ID: Scalars['Int']
  company: Company
  status: Scalars['String']
  user: User
}

export enum CompanyUserStatus {
  AccessRequest = 'access_request',
  Active = 'active',
  Pending = 'pending',
  Suspended = 'suspended',
}

/**
 * One confirmed booking a company has made at a venue (the booking's latest
 * venue confirmation names the venue).
 */
export type CompanyVenueBooking = {
  __typename?: 'CompanyVenueBooking'
  /**
   * The booker (event guest) who made this booking. Lets the client tell
   * "the company has booked here" from "this booker has booked here".
   */
  bookerUserId: Scalars['Int']
  bookingId: Scalars['Int']
  bookingName: Scalars['String']
  closedAmount?: Maybe<Scalars['Float']>
  closedAt?: Maybe<Scalars['DateTime']>
  confirmedAt: Scalars['DateTime']
  currency: Scalars['String']
  /** When the event happened / happens (the booking's from date). */
  eventDate: Scalars['DateTime']
  eventId: Scalars['Int']
  eventName: Scalars['String']
  eventUuid: Scalars['String']
  spaceName?: Maybe<Scalars['String']>
}

/**
 * A company's confirmed booking history at one venue. HeadBox staff only —
 * surfaces "booked before" on Event HQ recommendations.
 */
export type CompanyVenueBookings = {
  __typename?: 'CompanyVenueBookings'
  /** Newest event first. */
  bookings: Array<CompanyVenueBooking>
  count: Scalars['Int']
  /** The newest event date across `bookings`. Use this for "last booked" copy. */
  lastBookedAt: Scalars['DateTime']
  /**
   * Most recent confirmation across `bookings`. This is when the confirmation
   * was recorded (backfills cluster here), not when they booked.
   */
  lastConfirmedAt: Scalars['DateTime']
  venueId: Scalars['Int']
}

export type CompleteSsoLoginInput = {
  code: Scalars['String']
  /**
   * The state parameter Cognito returned to the callback URL. Single use:
   * it is claimed by this mutation whether or not the sign-in then
   * succeeds.
   */
  state: Scalars['String']
}

export type ConfirmBookingVenueInput = {
  bookingUuid: Scalars['ID']
  proposalID?: InputMaybe<Scalars['Int']>
  spaceID?: InputMaybe<Scalars['Int']>
  spaceName?: InputMaybe<Scalars['String']>
  swapReason?: InputMaybe<VenueConfirmationSwapReason>
  swapReasonNote?: InputMaybe<Scalars['String']>
  venueID?: InputMaybe<Scalars['Int']>
  venueName?: InputMaybe<Scalars['String']>
}

/**
 * A booking the team has confirmed took place at a venue: the booking's latest
 * venue confirmation names the venue, is Confirmed and is not a ghost. It can
 * still be cancelled after it closed: lifecycleStage says so.
 */
export type ConfirmedBooking = {
  __typename?: 'ConfirmedBooking'
  additionalNotes?: Maybe<Scalars['String']>
  attendees: Scalars['Int']
  /** The booker (event guest). */
  booker?: Maybe<User>
  bookerCompany?: Maybe<Scalars['String']>
  bookingID: Scalars['Int']
  bookingUUID: Scalars['ID']
  /** The booker's budget, in currency. */
  budget?: Maybe<Scalars['Float']>
  cateringNeeds?: Maybe<Scalars['String']>
  /** What the booking closed at, in currency. */
  closedAmount?: Maybe<Scalars['Float']>
  closedAt?: Maybe<Scalars['DateTime']>
  completedAt?: Maybe<Scalars['DateTime']>
  confirmedAt: Scalars['DateTime']
  /** The booking's own currency, never the HeadBox company currency. */
  currency: Scalars['String']
  eventID: Scalars['Int']
  eventName: Scalars['String']
  eventType?: Maybe<Collection>
  eventUUID: Scalars['ID']
  firstProposalsSentToGuestAt?: Maybe<Scalars['DateTime']>
  fromDateTime: Scalars['DateTime']
  isFlexibleWithDates: Scalars['Boolean']
  layoutID?: Maybe<Scalars['String']>
  lifecycleStage: Scalars['String']
  location?: Maybe<Scalars['String']>
  name: Scalars['String']
  /** The HeadBox person managing the event. */
  owner?: Maybe<User>
  /** The confirmed proposal, only when it was sent from the confirmed space. */
  proposalID?: Maybe<Scalars['Int']>
  proposalUUID?: Maybe<Scalars['ID']>
  requestedToBookAt?: Maybe<Scalars['DateTime']>
  /** Null when the booking was confirmed at the venue without a space. */
  spaceID?: Maybe<Scalars['Int']>
  spaceName?: Maybe<Scalars['String']>
  toDateTime?: Maybe<Scalars['DateTime']>
  venueID: Scalars['Int']
  venueName?: Maybe<Scalars['String']>
}

export type ContractDocument = {
  __typename?: 'ContractDocument'
  contentType: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  id: Scalars['Int']
  uploadedAt: Scalars['DateTime']
}

export type ContractDocumentUpload = {
  __typename?: 'ContractDocumentUpload'
  key: Scalars['String']
  uploadUrl: Scalars['String']
}

export type ContractInput = {
  agreementEndDate?: InputMaybe<Scalars['DateTime']>
  agreementStartDate?: InputMaybe<Scalars['DateTime']>
  agreementType?: InputMaybe<AgreementType>
  contractEndDate?: InputMaybe<Scalars['DateTime']>
  contractStartDate?: InputMaybe<Scalars['DateTime']>
  discountModel?: InputMaybe<Array<DiscountModelRowInput>>
  discountModelNotes?: InputMaybe<Scalars['String']>
  feesNotes?: InputMaybe<Scalars['String']>
  implementationFee?: InputMaybe<Scalars['String']>
  internationalFee?: InputMaybe<Scalars['String']>
  managementFee?: InputMaybe<Scalars['Float']>
  nonCommissionableBookingFee?: InputMaybe<Scalars['String']>
  rebateModel?: InputMaybe<Array<RebateModelRowInput>>
  rebateModelNotes?: InputMaybe<Scalars['String']>
  rebateThresholdSpendCountry?: InputMaybe<Scalars['String']>
  takeoverFee?: InputMaybe<Scalars['String']>
  thresholdSpendCountry?: InputMaybe<Scalars['String']>
}

export type ConvertedAmount = {
  __typename?: 'ConvertedAmount'
  currency: Currency
  value: Scalars['Float']
}

export type ConvertedBaseCostTotal = {
  __typename?: 'ConvertedBaseCostTotal'
  inBookingCurrency: ConvertedAmount
  inCompanyCurrency?: Maybe<ConvertedAmount>
  inEventCurrency?: Maybe<ConvertedAmount>
  inProposalCurrency: ConvertedAmount
  inTargetCurrency?: Maybe<ConvertedAmount>
}

export type ConvertedBookingBudget = {
  __typename?: 'ConvertedBookingBudget'
  inBookingCurrency: ConvertedAmount
  inCompanyCurrency?: Maybe<ConvertedAmount>
  inEventCurrency: ConvertedAmount
  inTargetCurrency?: Maybe<ConvertedAmount>
}

export type ConvertedEventBudget = {
  __typename?: 'ConvertedEventBudget'
  inCompanyCurrency?: Maybe<ConvertedAmount>
  inEventCurrency: ConvertedAmount
  inTargetCurrency?: Maybe<ConvertedAmount>
}

export type CostItemQtyIn = {
  ID: Scalars['Int']
  quantity: Scalars['Int']
}

export type CreateAccountUserDetailsInput = {
  contactNumber: Scalars['String']
  country?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  /**
   * Optional job title captured at sign-up. RedBox's sign_up_params never
   * permitted it (the users.job_title column existed but was dropped from
   * the request), so this is only persisted on the native create path.
   */
  jobTitle?: InputMaybe<Scalars['String']>
  lastName: Scalars['String']
  requestsExtraMarketingContent: Scalars['Boolean']
}

export type CreateAdditionalSpendInput = {
  budget: Scalars['Int']
  currency: Scalars['String']
  name: Scalars['String']
  parentBookingId: Scalars['Int']
}

export type CreateBookerNoteInput = {
  bookerId: Scalars['Int']
  category?: InputMaybe<BookerNoteCategory>
  eventId?: InputMaybe<Scalars['Int']>
  note: Scalars['String']
}

export type CreateBookingInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees: Scalars['Int']
  bookingFolderId?: InputMaybe<Scalars['Int']>
  bookingRequestedAt?: InputMaybe<Scalars['String']>
  bookingRequestedBy?: InputMaybe<Scalars['Int']>
  budget: Scalars['Int']
  cateringNeeds?: InputMaybe<Scalars['String']>
  closedAmount?: InputMaybe<Scalars['Int']>
  closedAmountCompanyCurrency?: InputMaybe<Scalars['Int']>
  closedAmountExTax?: InputMaybe<Scalars['Int']>
  closedAt?: InputMaybe<Scalars['String']>
  commissionPercentage?: InputMaybe<Scalars['Float']>
  commissionableAmount?: InputMaybe<Scalars['Int']>
  completedAt?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  currency: Scalars['String']
  eventId: Scalars['Int']
  eventTypeId?: InputMaybe<Scalars['Int']>
  fastTrackSupplierEmail?: InputMaybe<Scalars['String']>
  fastTrackSupplierName?: InputMaybe<Scalars['String']>
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDateTime: Scalars['String']
  fxRate?: InputMaybe<Scalars['Float']>
  hubspotID?: InputMaybe<Scalars['String']>
  isAdditionalSpendBooking?: InputMaybe<Scalars['Boolean']>
  isCommisionable?: InputMaybe<Scalars['Boolean']>
  isFlexibleWithDates: Scalars['Boolean']
  lat: Scalars['Float']
  layoutId: Scalars['String']
  location: Scalars['String']
  lon: Scalars['Float']
  lostReason?: InputMaybe<Scalars['String']>
  marketPrice?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
  parentBookingId?: InputMaybe<Scalars['Int']>
  paymentsInvoiceReference?: InputMaybe<Scalars['String']>
  processingFeePercentage?: InputMaybe<Scalars['Float']>
  radius: Scalars['Float']
  releaseReason?: InputMaybe<EventReleaseReason>
  requestedToBookAt?: InputMaybe<Scalars['String']>
  requirements?: InputMaybe<Scalars['JSON']>
  solutionsInvoiceReference?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIds: Array<Scalars['Int']>
  styleIds: Array<Scalars['String']>
  submittedBy?: InputMaybe<Scalars['Int']>
  supplierType: Scalars['String']
  takeOver?: InputMaybe<Scalars['Boolean']>
  takeOverFee?: InputMaybe<Scalars['Int']>
  takeOverFeePercentage?: InputMaybe<Scalars['Float']>
  toDateTime: Scalars['String']
}

export type CreateBookingsFolderInput = {
  budget?: InputMaybe<Scalars['Int']>
  eventId: Scalars['Int']
  eventTypeId?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
  notes?: InputMaybe<Scalars['String']>
  parentFolderId?: InputMaybe<Scalars['Int']>
  position: Scalars['Int']
}

export type CreateBusinessGuestAccountInput = {
  password: Scalars['String']
  userDetails: CreateAccountUserDetailsInput
}

export type CreateCompanyInput = {
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<ContractInput>
  country?: InputMaybe<HeadBoxCountry>
  currency: Scalars['String']
  domainTriageEnabled?: InputMaybe<Scalars['Boolean']>
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  hideAdditionalSpendInGraphs?: InputMaybe<Scalars['Boolean']>
  hideSoftSavings?: InputMaybe<Scalars['Boolean']>
  isContracted?: InputMaybe<Scalars['Boolean']>
  logo?: InputMaybe<Scalars['String']>
  logo_curated?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  postcode?: InputMaybe<Scalars['String']>
}

export type CreateContractDocumentUploadInput = {
  companyID: Scalars['Int']
  contentType: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
}

export type CreateEventInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees: Scalars['Int']
  automatedInvitationsBypassed?: InputMaybe<Scalars['Boolean']>
  automatedInvitationsQualified?: InputMaybe<Scalars['Boolean']>
  budget: Scalars['Int']
  cateringNeeds?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  currency: Scalars['String']
  eventTypeID: Scalars['Int']
  flexibleDatesNote: Scalars['String']
  fromDateTime: Scalars['String']
  guestCompany: Scalars['String']
  guestID: Scalars['Int']
  isFlexibleWithDates: Scalars['Boolean']
  lat: Scalars['String']
  layoutID: Scalars['String']
  location: Scalars['String']
  locationPolygon?: InputMaybe<Scalars['String']>
  lon: Scalars['String']
  name: Scalars['String']
  ownerId?: InputMaybe<Scalars['Int']>
  radius: Scalars['String']
  /** Typed requirement object, validated against the requirement registry */
  requirements?: InputMaybe<Scalars['JSON']>
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIDs: Array<Scalars['Int']>
  styleIDs?: InputMaybe<Array<Scalars['String']>>
  toDateTime: Scalars['String']
  venueRequests?: InputMaybe<Array<VenueRequestInput>>
}

export type CreateEventNoteInput = {
  eventID: Scalars['Int']
  note: Scalars['String']
}

export type CreateFullListingInput = {
  additionalContacts: Array<AdditionalContactInput>
  listing: CreateListingInput
}

export type CreateHostAccountInput = {
  password: Scalars['String']
  userDetails: CreateAccountUserDetailsInput
}

/**
 * A user created by the staff import. Mirrors the public sign-up input
 * without a password field, which is absent by design rather than optional.
 */
export type CreateInvitedGuestInput = {
  /**
   * Written to mobile_number, which is the column RedBox's own template
   * mislabels.
   *
   * Optional because the import file's cell may be empty, and a person
   * with no number on file is still a person to invite. Omitted, the
   * account is created with a NULL mobile number.
   *
   * ⚠️ Absent is not the same as blank. An empty cell has to arrive here
   * as an ABSENT field: any value that IS supplied, an empty string
   * included, runs the mobile-number validations and fails them.
   */
  contactNumber?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  jobTitle?: InputMaybe<Scalars['String']>
  lastName: Scalars['String']
}

export type CreateListingInput = {
  address: Scalars['String']
  commissionDetails?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  description: Scalars['String']
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: ListingSupplierType
  sustainabilityIds: Array<Scalars['Int']>
  userId: Scalars['Int']
  websiteUrl: Scalars['String']
}

export type CreateProposalInput = {
  attendees: Scalars['Int']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  bookingId: Scalars['Int']
  currency: Scalars['String']
  dateOffers?: InputMaybe<Array<DateOfferIn>>
  documentFilePaths?: InputMaybe<Array<Scalars['String']>>
  /** Documents attached at creation (venue library files carry their own URL) */
  documents?: InputMaybe<Array<ProposalDocumentInput>>
  eventId: Scalars['Int']
  extraCostItems?: InputMaybe<Array<ExtraCostItemInput>>
  fromDateTime: Scalars['String']
  invitationID: Scalars['Int']
  message?: InputMaybe<Scalars['String']>
  /** Structured pricing; validated server-side (sum, budget acknowledgement) */
  pricing?: InputMaybe<Scalars['JSON']>
  /** Required to cover every MUST when the booking has typed requirements */
  requirementResponses?: InputMaybe<Array<RequirementResponseIn>>
  selectedPhotos?: InputMaybe<Array<Scalars['Int']>>
  serviceId: Scalars['Int']
  serviceType: ServiceProviderType
  spaceID?: InputMaybe<Scalars['Int']>
  toDateTime: Scalars['String']
  tourCoverUrl?: InputMaybe<Scalars['String']>
  tourUrl?: InputMaybe<Scalars['String']>
  venueName?: InputMaybe<Scalars['String']>
}

export type CreateProposalOnBehalfInput = {
  attendees: Scalars['Int']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  bookingId: Scalars['Int']
  currency: Scalars['String']
  documentFilePaths?: InputMaybe<Array<Scalars['String']>>
  eventId: Scalars['Int']
  fromDateTime: Scalars['String']
  message?: InputMaybe<Scalars['String']>
  serviceId: Scalars['Int']
  serviceType: ServiceProviderType
  toDateTime: Scalars['String']
}

export type CreateStandardGuestAccountInput = {
  password?: InputMaybe<Scalars['String']>
  userDetails: CreateAccountUserDetailsInput
}

export type CreateSupplierAccountInput = {
  password: Scalars['String']
  userDetails: CreateAccountUserDetailsInput
}

export type CreateSupplierDealInput = {
  attachmentFilePaths?: InputMaybe<Array<Scalars['String']>>
  cost?: InputMaybe<Scalars['Int']>
  currency: Scalars['String']
  eventID: Scalars['Int']
  message?: InputMaybe<Scalars['String']>
  supplierID: Scalars['Int']
}

export type CreateSupplierInput = {
  email: Scalars['String']
  name: Scalars['String']
  type: SupplierType
}

export type CreateTeamInput = {
  companyID: Scalars['Int']
  /**
   * The team's first manager.
   *
   * ⚠️ REQUIRED, and not merely a convenience. RedBox validates
   * at_least_one_manager? and at_least_one_team_member? when a TEAM is
   * saved, so a team created without one is a record Rails refuses to save
   * from then on — and nothing surfaces until the customer next opens their
   * own team form and gets a validation error about members they never
   * touched. Naming a manager is what makes the row legal.
   *
   * Must be an active member of the company.
   */
  managerUserID: Scalars['Int']
  name: Scalars['String']
}

export type CreateUserInput = {
  /** Must sit inside the caller's own reach. */
  country: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  jobTitle?: InputMaybe<Scalars['String']>
  lastName: Scalars['String']
  /**
   * Optional ON THE TWO STAFF CREATES ONLY — this input and the P9
   * import's CreateInvitedGuestInput. Omitted, the account is created with
   * a NULL mobile number; every public sign-up input still declares the
   * field non-null, so no ordinary caller can reach the relaxation.
   *
   * ⚠️ Absent is not the same as blank. Any value that IS supplied, an
   * empty string included, runs the mobile-number validations and fails
   * them exactly as it did before.
   */
  phoneNumber?: InputMaybe<Scalars['String']>
  /**
   * Regions, which scope what a member of STAFF can see and do nothing on a
   * customer account. You may not grant reach you do not have yourself.
   */
  regions?: InputMaybe<Array<Scalars['String']>>
  /**
   * Role NAMES. The guest bit is added regardless — every account in the
   * estate carries it — so it is neither offered nor required here.
   */
  roles?: InputMaybe<Array<Scalars['String']>>
  /**
   * Email a sign-in link once the account is set up. The account cannot be
   * used until somebody redeems one, so omitting this leaves a real account
   * nobody has been told about — deliberate when onboarding ahead of time.
   */
  sendSignInLink?: InputMaybe<Scalars['Boolean']>
}

export type CreateVenueContractInput = {
  currency?: InputMaybe<Scalars['String']>
  ends: Scalars['Date']
  internalNotes?: InputMaybe<Scalars['String']>
  lines?: InputMaybe<Array<VenueContractLineInput>>
  market: VenueGroupMarket
  reference: Scalars['String']
  starts: Scalars['Date']
  /** Value of the whole term. */
  totalValue?: InputMaybe<Scalars['Float']>
}

export type CreateVenueGroupInput = {
  accountManagerUserId?: InputMaybe<Scalars['Int']>
  /** Required to take a venue out of a venue group that holds a contract. */
  confirmMoveVenues?: InputMaybe<Scalars['Boolean']>
  /** An owner invitation is sent to this address. */
  firstOwnerEmail?: InputMaybe<Scalars['String']>
  markets: Array<VenueGroupMarket>
  name: Scalars['String']
  /** Existing venues to move under the new venue group. */
  venueIds?: InputMaybe<Array<Scalars['Int']>>
}

export type CreatedListing = {
  __typename?: 'CreatedListing'
  additionalContacts: Array<AdditionalContact>
  address: Scalars['String']
  commissionDetails?: Maybe<Scalars['String']>
  country: Scalars['String']
  createdAt: Scalars['String']
  deletedAt?: Maybe<Scalars['String']>
  description: Scalars['String']
  id: Scalars['Int']
  latitude: Scalars['Float']
  listingDocuments: Array<UploadedDocumentResponse>
  listingImages: Array<UploadedImageResponse>
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: ListingSupplierType
  sustainabilityIds: Array<Scalars['Int']>
  updatedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  user: User
  userId: Scalars['Int']
  websiteUrl: Scalars['String']
}

export type Currency = {
  __typename?: 'Currency'
  code: SupportedCurrencyCode
  order: Scalars['Int']
  symbol: Scalars['String']
}

export type Dashboard = {
  __typename?: 'Dashboard'
  /** Null = every venue group. */
  accountManagerUserId?: Maybe<Scalars['Int']>
  asOf: Scalars['Date']
  attention: DashboardAttention
  /** Bookings through HeadBox across paying groups; null when self-serve is not configured or reachable */
  bookings?: Maybe<DashboardBookings>
  /** Today's ranked to-do list for the signed-in person, built by rules from the signals above. */
  briefing: DashboardBriefing
  headline: DashboardHeadline
  /** Venue groups the signed-in staff member manages, regardless of scope. */
  managedByMe: Scalars['Int']
  /** Null = every market. */
  market?: Maybe<VenueGroupMarket>
  /** Markets with at least one contract, for the filter. */
  markets: Array<VenueGroupMarket>
  /** Last twelve months. */
  momentum: Array<DashboardMonth>
  /** Amber and red accounts, soonest renewal first (up to ten). */
  needsCall: Array<DashboardAccountNeedingCall>
  /** Renewals due in 90 days by stage. */
  pipeline: Array<DashboardPipelineStage>
  /** Active contracts ending within 90 days, soonest first. */
  renewals: Array<DashboardContract>
  revenue: DashboardRevenue
  /** Contracts starting within 30 days or activated in the last 30. */
  starting: Array<DashboardContract>
  /** Top five venue groups by share of purchased seats left unassigned. */
  underUtilisedVenueGroups: Array<DashboardVenueGroupUtilisation>
  utilisationByCategory: Array<DashboardCategoryUtilisation>
}

export type DashboardAccountNeedingCall = {
  __typename?: 'DashboardAccountNeedingCall'
  health: VenueGroupHealth
  name: Scalars['String']
  nextRenewal?: Maybe<Scalars['Date']>
  venueGroupId: Scalars['Int']
}

export type DashboardAttention = {
  __typename?: 'DashboardAttention'
  activeWithNoAssignments: Scalars['Int']
  activeWithoutSignedPdf: Scalars['Int']
  expiredWithoutSuccessor90Days: Scalars['Int']
  invitationsPendingOver14Days: Scalars['Int']
  payingWithoutAccountManager: Scalars['Int']
  /** Renewals whose next action date has passed. */
  renewalActionsOverdue: Scalars['Int']
  /** Contracts ending within 30 days with the renewal not started. */
  renewalsNotStarted30: Scalars['Int']
}

/** Bookings through HeadBox at paying groups' venues (from self-serve). */
export type DashboardBookings = {
  __typename?: 'DashboardBookings'
  /** Their value per currency; currencies are never added together */
  booked: Array<DashboardMoney>
  /** Confirmed since each group's live contract started */
  count: Scalars['Int']
  /** Bookings confirmed each week, last 13 weeks (Monday starts), oldest first */
  weekly: DashboardSeries
}

export type DashboardBriefing = {
  __typename?: 'DashboardBriefing'
  items: Array<DashboardBriefingItem>
  lead: Scalars['String']
  /** Items hidden by today's skips. */
  skipped: Scalars['Int']
}

/** One thing worth doing today, with somewhere to go and do it. */
export type DashboardBriefingItem = {
  __typename?: 'DashboardBriefingItem'
  cta: Scalars['String']
  href: Scalars['String']
  /** Stable for the day; pass to SkipBriefingItem. */
  key: Scalars['String']
  kind: Scalars['String']
  text: Scalars['String']
  urgency: DashboardBriefingUrgency
  who: Scalars['String']
}

export enum DashboardBriefingUrgency {
  Amber = 'amber',
  Green = 'green',
  Red = 'red',
}

export type DashboardCategoryUtilisation = {
  __typename?: 'DashboardCategoryUtilisation'
  assigned: Scalars['Int']
  category: Scalars['String']
  categoryName: Scalars['String']
  purchased: Scalars['Int']
}

/** A contract row with the readiness flags the renewal and onboarding lists show. */
export type DashboardContract = {
  __typename?: 'DashboardContract'
  /** monthlyValue × 12. */
  annualValue?: Maybe<Scalars['Float']>
  currency?: Maybe<Scalars['String']>
  /** Negative once past the end date. */
  daysLeft: Scalars['Int']
  ends: Scalars['Date']
  hasSignedPdf: Scalars['Boolean']
  /** A draft or active contract for the same venue group and market starts on or after this one ends. */
  hasSuccessor: Scalars['Boolean']
  /** Health of the venue group this contract belongs to. */
  health?: Maybe<VenueGroupHealth>
  id: Scalars['Int']
  market: VenueGroupMarket
  /** totalValue spread evenly over the term. */
  monthlyValue?: Maybe<Scalars['Float']>
  /** At least one owner has accepted their invitation. */
  ownerAccepted: Scalars['Boolean']
  /** Names of the purchased packages. */
  packages: Array<Scalars['String']>
  reference: Scalars['String']
  renewalNextAction?: Maybe<Scalars['String']>
  renewalNextActionOn?: Maybe<Scalars['Date']>
  renewalStage: VenueContractRenewalStage
  seatsAssigned: Scalars['Int']
  seatsPurchased: Scalars['Int']
  starts: Scalars['Date']
  status: VenueContractStatus
  /** Monthly value of the renewal already drafted or active, when it has a value. Compare with monthlyValue for expansion or contraction. */
  successorMonthlyValue?: Maybe<Scalars['Float']>
  /** Value of the whole term, as recorded. */
  totalValue?: Maybe<Scalars['Float']>
  venueGroupId: Scalars['Int']
  venueGroupName: Scalars['String']
}

export type DashboardHeadline = {
  __typename?: 'DashboardHeadline'
  activeContracts: DashboardSeries
  /** Venue groups with an active contract. */
  payingVenueGroups: DashboardSeries
  seatsAssigned: DashboardSeries
  seatsPurchased: DashboardSeries
  /** Venues holding at least one live package assignment. */
  venuesWithFeatures: DashboardSeries
}

/** Money is only summed within a currency. */
export type DashboardMoney = {
  __typename?: 'DashboardMoney'
  currency: Scalars['String']
  total: Scalars['Float']
}

/** A money time series for one currency: weekly points, oldest first, the last one today. */
export type DashboardMoneySeries = {
  __typename?: 'DashboardMoneySeries'
  currency: Scalars['String']
  dates: Array<Scalars['Date']>
  values: Array<Scalars['Float']>
}

export type DashboardMonth = {
  __typename?: 'DashboardMonth'
  activated: Scalars['Int']
  ended: Scalars['Int']
  /** YYYY-MM */
  month: Scalars['String']
}

export type DashboardPipelineStage = {
  __typename?: 'DashboardPipelineStage'
  /** ARR sitting at this stage, by currency. */
  arr: Array<DashboardMoney>
  count: Scalars['Int']
  /** Venue group names at this stage, soonest renewal first, up to three. */
  names: Array<Scalars['String']>
  stage: VenueContractRenewalStage
}

/** All derived from each contract's total value spread evenly over its term. */
export type DashboardRevenue = {
  __typename?: 'DashboardRevenue'
  /** Annual recurring revenue: MRR × 12, today. */
  arr: Array<DashboardMoney>
  /** The part of arrRenewing90 with no renewal drafted yet. */
  arrAtRisk90: Array<DashboardMoney>
  /** ARR of live contracts ending within 90 days. */
  arrRenewing90: Array<DashboardMoney>
  contractsAtRisk90: Scalars['Int']
  /** How many contracts sit behind arrRenewing90 and arrAtRisk90, whether or not they have a value. */
  contractsRenewing90: Scalars['Int']
  /** Live contracts with no value recorded, so the figures above undercount. */
  contractsWithoutValue: Scalars['Int']
  /** Monthly recurring revenue: what live contracts are worth per month, over the last 13 weeks. */
  mrr: Array<DashboardMoneySeries>
}

/** Weekly points, oldest first; the last one is today. */
export type DashboardSeries = {
  __typename?: 'DashboardSeries'
  dates: Array<Scalars['Date']>
  values: Array<Scalars['Int']>
}

export type DashboardVenueGroupUtilisation = {
  __typename?: 'DashboardVenueGroupUtilisation'
  assigned: Scalars['Int']
  name: Scalars['String']
  purchased: Scalars['Int']
  venueGroupId: Scalars['Int']
}

/** A per-date availability answer, optionally with a venue-asserted hold */
export type DateOffer = {
  __typename?: 'DateOffer'
  date: Scalars['String']
  holdExpiresAt?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  /** Signed minor units relative to the quoted total, e.g. a cheaper night */
  priceDelta?: Maybe<Scalars['Int']>
  status: DateOfferStatus
}

export type DateOfferIn = {
  date: Scalars['String']
  holdExpiresAt?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  priceDelta?: InputMaybe<Scalars['Int']>
  status: DateOfferStatus
}

export enum DateOfferStatus {
  Offered = 'offered',
  OfferedWithHold = 'offeredWithHold',
  Unavailable = 'unavailable',
}

/** If either 'from' or 'to' are null, there will be no lower or upper bound respectively */
export type DateRangeFilter = {
  from?: InputMaybe<Scalars['DateTime']>
  to?: InputMaybe<Scalars['DateTime']>
}

export type DbOnlyDeal = {
  __typename?: 'DbOnlyDeal'
  bookingId: Scalars['Int']
  closedAmount?: Maybe<Scalars['Float']>
  hubspotId?: Maybe<Scalars['String']>
  lifecycleStage: Scalars['String']
}

export type DeclineProposalsInput = {
  declinedMessage?: InputMaybe<Scalars['String']>
  declinedReason: Array<ProposalDeclinedReason>
  proposalIds: Array<Scalars['Int']>
}

export type DeleteBookerNoteInput = {
  ID: Scalars['Int']
}

export type DeleteEventNoteInput = {
  ID: Scalars['Int']
}

export type DeleteListingsForUserResult = {
  __typename?: 'DeleteListingsForUserResult'
  spacesDeleted: Scalars['Int']
  venuesDeleted: Scalars['Int']
}

export type DeleteSupplierDealInput = {
  ID: Scalars['Int']
}

export type DeleteSupplierInput = {
  ID: Scalars['Int']
}

export enum DeliveryCommitmentType {
  Internal = 'Internal',
  Pitch = 'Pitch',
  Proposals = 'Proposals',
}

/** A point and radius, or a drawn area (polygon); an area wins when both are given. */
export type DemandGenBriefInput = {
  attendees?: InputMaybe<Scalars['Int']>
  /** The day the brief's first invite went out. */
  date: Scalars['Date']
  eventTypeId?: InputMaybe<Scalars['Int']>
  /** The caller's id for the brief, echoed back. */
  key: Scalars['String']
  lat?: InputMaybe<Scalars['Float']>
  lon?: InputMaybe<Scalars['Float']>
  /** The drawn area or isochrone, as EventHQ stores it. */
  polygon?: InputMaybe<Array<DemandGenPointInput>>
  radiusKm?: InputMaybe<Scalars['Float']>
}

export type DemandGenBriefMatch = {
  __typename?: 'DemandGenBriefMatch'
  /** DemandGen venues that could have met the brief that day. */
  demandGenVenues: Scalars['Int']
  key: Scalars['String']
}

/** Inclusive days. */
export type DemandGenPeriod = {
  __typename?: 'DemandGenPeriod'
  from: Scalars['Date']
  to: Scalars['Date']
}

export type DemandGenPointInput = {
  lat: Scalars['Float']
  lng: Scalars['Float']
}

export type DemandGenReport = {
  __typename?: 'DemandGenReport'
  briefs: Array<DemandGenReportBrief>
  months: Array<DemandGenReportMonth>
  team: Array<DemandGenReportTeamRow>
  venueInvites: Array<DemandGenReportVenueMonth>
}

/** Selected month: a brief whose first invite went out that month. */
export type DemandGenReportBrief = {
  __typename?: 'DemandGenReportBrief'
  attendees?: Maybe<Scalars['Int']>
  bookingID: Scalars['Int']
  /** The first invite's London day, YYYY-MM-DD. */
  date: Scalars['String']
  eventTypeID?: Maybe<Scalars['Int']>
  /** At least one invite went to a venue that was DemandGen that day. */
  invitedDemandGen: Scalars['Boolean']
  lat?: Maybe<Scalars['Float']>
  lon?: Maybe<Scalars['Float']>
  ownerID?: Maybe<Scalars['Int']>
  /** The drawn area or isochrone as EventHQ stores it: a JSON array of {lat, lng}. The booking's, else the event's. */
  polygon?: Maybe<Scalars['String']>
  radiusKm?: Maybe<Scalars['Float']>
}

export type DemandGenReportInput = {
  /** Countries in the market, for totals (the brief's country). Omit for every market. */
  countries?: InputMaybe<Array<Scalars['String']>>
  /** Start of the first month, ISO 8601. */
  from: Scalars['String']
  /** YYYY-MM: the month for team and briefs. */
  selectedMonth?: InputMaybe<Scalars['String']>
  /** Start of the month after the last, ISO 8601. */
  to: Scalars['String']
  venues: Array<DemandGenReportVenueInput>
}

export type DemandGenReportMonth = {
  __typename?: 'DemandGenReportMonth'
  /** ...closed that month without a pound value */
  bookingsWithoutValue: Scalars['Int']
  demandGenBookings: Scalars['Int']
  demandGenBookingsWithoutValue: Scalars['Int']
  /** Invites to venues that were DemandGen that day */
  demandGenInvites: Scalars['Int']
  /** Of those, closed at a venue that was DemandGen that day */
  demandGenRevenueGBP: Scalars['Int']
  /** Invites sent that month (market by the brief's country) */
  invites: Scalars['Int']
  /** YYYY-MM */
  month: Scalars['String']
  /** Bookings closed that month, not cancelled, in pounds (HubSpot's converted amount) */
  revenueGBP: Scalars['Int']
}

/** London days, inclusive, YYYY-MM-DD. */
export type DemandGenReportPeriodInput = {
  from: Scalars['String']
  to: Scalars['String']
}

/** Selected month, per enquiry owner (the HeadBox team member). */
export type DemandGenReportTeamRow = {
  __typename?: 'DemandGenReportTeamRow'
  demandGenInvites: Scalars['Int']
  invites: Scalars['Int']
  owner?: Maybe<User>
  ownerID?: Maybe<Scalars['Int']>
}

/** A venue that was DemandGen, with its spaces and when (from host-listing's demandGenVenues). */
export type DemandGenReportVenueInput = {
  periods: Array<DemandGenReportPeriodInput>
  /** Every space, deleted ones too. */
  spaceIDs: Array<Scalars['Int']>
  venueID: Scalars['Int']
}

/** A DemandGen venue's invites in a month, while it was DemandGen. Venues with none are left out. */
export type DemandGenReportVenueMonth = {
  __typename?: 'DemandGenReportVenueMonth'
  invites: Scalars['Int']
  month: Scalars['String']
  venueID: Scalars['Int']
}

/** A venue that was DemandGen (Search Boost assigned, contract in effect) at some point in the window. */
export type DemandGenVenue = {
  __typename?: 'DemandGenVenue'
  /** When Lead Feed was on, within the window. */
  leadFeedPeriods: Array<DemandGenPeriod>
  market?: Maybe<VenueGroupMarket>
  /** When it was DemandGen, within the window. */
  periods: Array<DemandGenPeriod>
  /** Every space, deleted ones too (their past requests still count). */
  spaceIds: Array<Scalars['Int']>
  venueGroupId?: Maybe<Scalars['Int']>
  venueGroupName?: Maybe<Scalars['String']>
  venueId: Scalars['Int']
  venueName: Scalars['String']
}

export type DiscountModelRow = {
  __typename?: 'DiscountModelRow'
  contract?: Maybe<CompanyContract>
  managementFeeDiscount?: Maybe<Scalars['Float']>
  maxSpend?: Maybe<Scalars['Int']>
  minSpend?: Maybe<Scalars['Int']>
}

export type DiscountModelRowInput = {
  managementFeeDiscount?: InputMaybe<Scalars['Float']>
  maxSpend?: InputMaybe<Scalars['Int']>
}

export type EditCompanyInput = {
  ID: Scalars['Int']
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  attributes?: InputMaybe<Array<CompanyAttributeInput>>
  city?: InputMaybe<Scalars['String']>
  contract?: InputMaybe<ContractInput>
  country?: InputMaybe<HeadBoxCountry>
  currency: Scalars['String']
  domainTriageEnabled?: InputMaybe<Scalars['Boolean']>
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  hideAdditionalSpendInGraphs?: InputMaybe<Scalars['Boolean']>
  hideSoftSavings?: InputMaybe<Scalars['Boolean']>
  isContracted?: InputMaybe<Scalars['Boolean']>
  logo?: InputMaybe<Scalars['String']>
  logo_curated?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  postcode?: InputMaybe<Scalars['String']>
}

export type EmissionsByPeriod = {
  __typename?: 'EmissionsByPeriod'
  date: Scalars['DateTime']
  totalAttendees: Scalars['Int']
  totalEmissions: Scalars['Float']
  totalEmissionsPerAttendee: Scalars['Float']
}

export type EmissionsFilter = {
  periodType?: InputMaybe<EmissionsPeriodType>
}

export enum EmissionsPeriodType {
  Day = 'DAY',
  Month = 'MONTH',
}

export enum EpcRating {
  A = 'A',
  APlus = 'A_PLUS',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
}

export type Event = EventAndBookingFields & {
  __typename?: 'Event'
  /** @deprecated Use id */
  ID: Scalars['Int']
  UUID: Scalars['ID']
  /** @deprecated Use `owner` instead */
  accountManager?: Maybe<User>
  actualEventMgmtFee?: Maybe<Scalars['Int']>
  additionalNotes?: Maybe<Scalars['String']>
  attendees: Scalars['Int']
  /** EventHQ qualification: typed, spine complete, no unconfirmed AI guesses */
  automatedInvitationsQualified?: Maybe<Scalars['Boolean']>
  backFromHoldAt?: Maybe<Scalars['DateTime']>
  /** @deprecated This value now resides on the associated bookings */
  bookingRequestedAt?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings */
  bookingRequestedBy?: Maybe<Scalars['Int']>
  bookings: Array<Booking>
  bookingsFolders: Array<BookingsFolder>
  budget: Scalars['Int']
  cateringNeeds?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  closedAmount?: Maybe<Scalars['Int']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  closedAt?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings */
  commissionPerc?: Maybe<Scalars['Float']>
  committedEventBudget: ConvertedEventBudget
  company: Company
  /** The company ID is used to stitch in a company resolver in the gateway */
  companyId: Scalars['Int']
  /** @deprecated This value now resides on the associated bookings */
  completedAt?: Maybe<Scalars['String']>
  convertedEventBudget: ConvertedEventBudget
  /** The brief location country, not the company country. Prior to 2024, the two were conflated. */
  country: Scalars['String']
  createdAt?: Maybe<Scalars['DateTime']>
  currency: SupportedCurrencyCode
  decisionDate: Scalars['String']
  deliveryDate?: Maybe<EventDeliveryDate>
  estimatedEventMgmtFee?: Maybe<Scalars['Int']>
  eventType: Collection
  /** @deprecated This can be derived from the invitations of each booking */
  firstInvitationSentAt?: Maybe<Scalars['String']>
  /** @deprecated This can be derived from the proposals of each booking */
  firstProposalReceivedAt?: Maybe<Scalars['String']>
  /** @deprecated This can be derived from the proposals of each booking */
  firstProposalsSentToGuestAt?: Maybe<Scalars['String']>
  flexibleDatesNote?: Maybe<Scalars['String']>
  /** @deprecated Use 'isFlexibleWithDates' */
  flexibleWithDates: Scalars['Boolean']
  /** @deprecated Use 'flexibleDatesNote' */
  flexibleWithDatesNote?: Maybe<Scalars['String']>
  fromDateTime: Scalars['String']
  guest: User
  heldSince?: Maybe<Scalars['DateTime']>
  holdNote?: Maybe<Scalars['String']>
  holdReason?: Maybe<HoldReason>
  holdRemindOn?: Maybe<Scalars['String']>
  holdResumedAt?: Maybe<Scalars['DateTime']>
  holdWakeUnseen: Scalars['Boolean']
  id: Scalars['Int']
  /** Returns the invitations for every associated booking */
  invitations: Array<Invitation>
  isFlexibleWithDates: Scalars['Boolean']
  isSimpleEvent: Scalars['Boolean']
  kanbanColumn: KanbanStatus
  lat: Scalars['String']
  layoutID: Scalars['String']
  location: Scalars['String']
  locationPolygon?: Maybe<Scalars['String']>
  lon: Scalars['String']
  /** @deprecated This value is no longer required. */
  lostAt?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  lostReason?: Maybe<Scalars['String']>
  /** A simple descriptive status derived from the combined statuses of the events bookings */
  managementStatus: ManagementStatus
  name: Scalars['String']
  notes?: Maybe<Array<EventNote>>
  onHold: Scalars['Boolean']
  /** The HeadBox staff member currently responsible for the event. */
  owner?: Maybe<User>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  paymentsInvoiceReference?: Maybe<Scalars['String']>
  /** @deprecated This value now resides on the associated bookings */
  processingFeePerc?: Maybe<Scalars['Float']>
  proposalCount: Scalars['Int']
  /** Returns the proposals for every associated booking's invitations */
  proposals: Array<Proposal>
  radius?: Maybe<Scalars['String']>
  region: Scalars['String']
  releaseReason?: Maybe<EventReleaseReason>
  /** @deprecated This value now resides on the associated bookings */
  requestedToBookAt?: Maybe<Scalars['String']>
  /**
   * Typed requirement object (registry-shaped; see requirementRegistry query).
   * Null on legacy events.
   */
  requirements?: Maybe<Scalars['JSON']>
  /** @deprecated This value now resides on the associated bookings. It used to come from hubspot. */
  solutionsInvoiceReference?: Maybe<Scalars['String']>
  source: Scalars['String']
  spaceFacilities: Array<SpaceFacility>
  /** @deprecated See the kanbanColumn or associated booking statuses instead */
  status: EventStatus
  styles: Array<Style>
  submittedAt: Scalars['String']
  /** @deprecated Suppliers have been completely overhauled */
  supplierDeals?: Maybe<Array<SupplierDeal>>
  /** The team ID to which costs are to be allocated. Consider renaming this field. */
  team?: Maybe<Team>
  toDateTime: Scalars['String']
  updatedAt?: Maybe<Scalars['String']>
  venueRequests: Array<VenueRequest>
}

export type EventCommittedEventBudgetArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type EventConvertedEventBudgetArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type EventProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>
}

export enum EventActiveArg {
  Active = 'Active',
  AllEvents = 'AllEvents',
  Inactive = 'Inactive',
}

export type EventAndBookingFields = {
  additionalNotes?: Maybe<Scalars['String']>
  attendees: Scalars['Int']
  cateringNeeds?: Maybe<Scalars['String']>
  country: Scalars['String']
  currency: SupportedCurrencyCode
  eventType?: Maybe<Collection>
  flexibleDatesNote?: Maybe<Scalars['String']>
  id: Scalars['Int']
  invitations: Array<Invitation>
  isFlexibleWithDates: Scalars['Boolean']
  location: Scalars['String']
  name: Scalars['String']
  owner?: Maybe<User>
  proposals: Array<Proposal>
  source: Scalars['String']
  spaceFacilities: Array<SpaceFacility>
  styles: Array<Style>
}

export type EventAndBookingFieldsProposalsArgs = {
  filter?: InputMaybe<ProposalsFilter>
}

export enum EventBucketFilterHost {
  Archived = 'Archived',
  Bookings = 'Bookings',
  Invitations = 'Invitations',
  Proposals = 'Proposals',
}

/** The event's conversation between the booker's team and HeadBox M&E. */
export type EventConversation = {
  __typename?: 'EventConversation'
  conciergeEmail: Scalars['String']
  /** The event's manager: staff-bound email goes to them (and the shared M&E mailbox). */
  conciergeName: Scalars['String']
  /** Email to the manager is bouncing. */
  conciergeUnreachable: Scalars['Boolean']
  eventUuid: Scalars['ID']
  /** Oldest first. */
  messages: Array<EventConversationMessage>
  /** Messages newer than the caller's read cursor, excluding their own. */
  unreadCount: Scalars['Int']
}

export type EventConversationAttachment = {
  __typename?: 'EventConversationAttachment'
  contentType?: Maybe<Scalars['String']>
  filename: Scalars['String']
  id: Scalars['ID']
  size?: Maybe<Scalars['Int']>
}

export type EventConversationAttachmentDownload = {
  __typename?: 'EventConversationAttachmentDownload'
  filename: Scalars['String']
  /** Presigned, valid for 60 seconds. */
  url: Scalars['String']
}

export type EventConversationAttachmentInput = {
  /** The file's bytes, base64-encoded. */
  base64: Scalars['String']
  contentType?: InputMaybe<Scalars['String']>
  filename: Scalars['String']
}

export enum EventConversationAuthorKind {
  /** The booker or someone they shared the event with. */
  Booker = 'BOOKER',
  External = 'EXTERNAL',
  /** HeadBox M&E — the event's manager by email, or any team member from Event HQ. */
  Staff = 'STAFF',
}

export type EventConversationMessage = {
  __typename?: 'EventConversationMessage'
  attachments: Array<EventConversationAttachment>
  authorKind: EventConversationAuthorKind
  authorName?: Maybe<Scalars['String']>
  body: Scalars['String']
  /** ISO 8601. */
  createdAt: Scalars['String']
  id: Scalars['ID']
  /**
   * Written by the calling staff member (from Event HQ, or by email when they
   * are the event's manager).
   */
  mine: Scalars['Boolean']
  source: EventConversationSource
}

export enum EventConversationSource {
  App = 'APP',
  Email = 'EMAIL',
}

export type EventDeliveryDate = {
  __typename?: 'EventDeliveryDate'
  ID: Scalars['Int']
  clientInformed: Scalars['Boolean']
  deliveryAt: Scalars['DateTime']
  deliveryType: DeliveryCommitmentType
  note?: Maybe<Scalars['String']>
  setAt: Scalars['DateTime']
  setBy?: Maybe<User>
}

export type EventNote = {
  __typename?: 'EventNote'
  ID: Scalars['Int']
  createdAt: Scalars['String']
  note: Scalars['String']
  /** Null until the note is first edited */
  updatedAt?: Maybe<Scalars['String']>
}

export type EventPendingInvite = {
  __typename?: 'EventPendingInvite'
  email: Scalars['String']
  expiresAt: Scalars['String']
  id: Scalars['ID']
  lastSentAt?: Maybe<Scalars['String']>
  role: EventPersonRole
  status: Scalars['String']
}

/** People on a booker event, for the Event HQ People tab. */
export type EventPeople = {
  __typename?: 'EventPeople'
  collaborators: Array<EventPerson>
  pendingInvites: Array<EventPendingInvite>
}

export type EventPerson = {
  __typename?: 'EventPerson'
  email?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  nudgedAt?: Maybe<Scalars['String']>
  role: EventPersonRole
  sharedAt: Scalars['String']
  userId: Scalars['Int']
}

export enum EventPersonRole {
  CoOrganiser = 'CO_ORGANISER',
  Viewer = 'VIEWER',
}

export enum EventReleaseReason {
  BookedDirectly = 'BookedDirectly',
  CancelledByBooker = 'CancelledByBooker',
  Duplicate = 'Duplicate',
  EventCancelled = 'EventCancelled',
  EventHeldInternally = 'EventHeldInternally',
  NoResponse = 'NoResponse',
  ScopingExercise = 'ScopingExercise',
}

export type EventSortArg = {
  fromDateTimeAscending?: InputMaybe<Scalars['Boolean']>
}

export enum EventStatus {
  AwaitingDecision = 'AwaitingDecision',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Completed = 'Completed',
  Created = 'Created',
  HostsInvited = 'HostsInvited',
  Lost = 'Lost',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoInvitations = 'NoInvitations',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponseChosen = 'NoResponseChosen',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponses = 'NoResponses',
  ProposalsReceived = 'ProposalsReceived',
  ProposalsSent = 'ProposalsSent',
  RequestedToBook = 'RequestedToBook',
}

export type EventsFilter = {
  activeForAdmin?: InputMaybe<Scalars['Boolean']>
  awaitingVenueConfirmation?: InputMaybe<Scalars['Boolean']>
  /** Events booked by the guest IDs */
  bookerIds?: InputMaybe<Array<Scalars['Int']>>
  /** Events closed between the provided range */
  closedAt?: InputMaybe<DateRangeFilter>
  companyIds?: InputMaybe<Array<Scalars['Int']>>
  /** Filters events by the associated companies' countries */
  countries?: InputMaybe<Array<HeadBoxCountry>>
  /** Events created between the provided range */
  createdAt?: InputMaybe<DateRangeFilter>
}

export type EventsPagination = {
  /**
   * For pages after the "first", specify the ID of the last event in the previous page - this is a
   * more reliable means of specifying the page offset.
   */
  lastPaginatedEventId?: InputMaybe<Scalars['Int']>
  order: PaginationOrder
  pageSize: Scalars['Int']
  sortColumn: EventsPaginationSortColumns
}

/**
 * The event column names by which to sort records within the page set. All options will be
 * secondarily sorted by ID (in case of duplicate values)
 */
export enum EventsPaginationSortColumns {
  CreatedAt = 'createdAt',
  FromDateTime = 'fromDateTime',
  UpdatedAt = 'updatedAt',
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate'
  currency: Currency
  rate: Scalars['Float']
}

export type ExtraCostItem = {
  __typename?: 'ExtraCostItem'
  ID: Scalars['Int']
  costPerUnit: Scalars['Int']
  description: Scalars['String']
  quantity?: Maybe<Scalars['Int']>
}

export type ExtraCostItemInput = {
  ID?: InputMaybe<Scalars['Int']>
  costPerUnit: Scalars['Int']
  description: Scalars['String']
  quantity?: InputMaybe<Scalars['Int']>
}

export type FacilityCategory = {
  __typename?: 'FacilityCategory'
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
  searchable?: Maybe<Scalars['Boolean']>
}

export type FastTrackResearchInput = {
  longDesc?: InputMaybe<Scalars['String']>
  researchData?: InputMaybe<Scalars['String']>
  shortDesc?: InputMaybe<Scalars['String']>
  vectorData?: InputMaybe<Scalars['String']>
}

export type FastTrackSpaceInput = {
  collections: Array<InputMaybe<Scalars['Int']>>
  configurations: Array<InputMaybe<SpaceSpatialConfigurationInput>>
  facilities: Array<InputMaybe<Scalars['Int']>>
  photos?: InputMaybe<Array<InputMaybe<SpacePhotoInput>>>
  summary: SpaceSummaryInput
}

export type FastTrackVenueInput = {
  host: HostInput
  /** Pre-computed research (from the candidate research job) persisted onto the venue; vectorData triggers Pinecone indexing */
  research?: InputMaybe<FastTrackResearchInput>
  /** Single space — kept for backwards compatibility; prefer 'spaces' */
  space?: InputMaybe<FastTrackSpaceInput>
  /** Create multiple spaces, all owned by the host account */
  spaces?: InputMaybe<Array<FastTrackSpaceInput>>
  venue: VenueInput
}

/** Type of features of collection. */
export type Feature = {
  __typename?: 'Feature'
  id: Scalars['ID']
  name: Scalars['String']
  position: Scalars['Int']
}

export type FeatureCategory = {
  __typename?: 'FeatureCategory'
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
  searchable?: Maybe<Scalars['Boolean']>
}

export type GeolocationFilterInput = {
  latitude: Scalars['Float']
  longitude: Scalars['Float']
  radiusMeters: Scalars['Int']
}

export type GetAllHostsInfoArgs = {
  eventTypeID?: InputMaybe<Scalars['Int']>
}

export type GetSustainabilityInitiativesForVenueInput = {
  /**
   * The order in which the Sustainability Initiatives should be sorted.
   *
   * Every item in the array must be a valid Sustainability Initative ID (as an integer). If the array is not provided,
   * the Sustainability Initatives will not be sorted.
   */
  orderOfSustainabilityInitatives: Array<Scalars['Int']>
  /** The ID of the venue for which the Sustainability Initiatives are requested. */
  venueId: Scalars['Int']
}

export type GoogleAddress = {
  __typename?: 'GoogleAddress'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  county?: Maybe<Scalars['String']>
  postCode?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  streetNumber?: Maybe<Scalars['String']>
}

export type GuestType = {
  __typename?: 'GuestType'
  companyID?: Maybe<Scalars['Int']>
  hasExistingAccount: Scalars['Boolean']
  isBusinessUser: Scalars['Boolean']
  isDomainValid: Scalars['Boolean']
  userId?: Maybe<Scalars['Int']>
}

export enum HeadBoxCountry {
  Ac = 'AC',
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cp = 'CP',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dg = 'DG',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ea = 'EA',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Eu = 'EU',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Fx = 'FX',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Ic = 'IC',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Su = 'SU',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Ta = 'TA',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW',
}

export enum HoldReason {
  BudgetFrozen = 'BudgetFrozen',
  ClientGoneQuiet = 'ClientGoneQuiet',
  DateToBeConfirmed = 'DateToBeConfirmed',
  PostponedToNextYear = 'PostponedToNextYear',
}

export type Host = {
  __typename?: 'Host'
  email: Scalars['String']
  id: Scalars['Int']
  isPowerHost: Scalars['Boolean']
  isSmartBookHost: Scalars['Boolean']
}

export type HostContact = {
  __typename?: 'HostContact'
  avatar?: Maybe<Avatar>
  email?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  phoneNumber?: Maybe<Scalars['String']>
}

export type HostInfo = {
  __typename?: 'HostInfo'
  eventTypes: Array<Scalars['Int']>
  hostID: Scalars['Int']
  isSelfServeHost: Scalars['Boolean']
  user: User
  venues: Array<SelfServeVenue>
}

export type HostInput = {
  email: Scalars['String']
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
}

/** A published Market Insights report as the venue's own people read it. */
export type HostMarketReport = {
  __typename?: 'HostMarketReport'
  /** The written story: short name, headlines, paragraphs, actions. */
  copy: Scalars['JSON']
  /** The report data the page computes from, without competitors' quotes brief by brief or the companies behind open briefs. */
  data?: Maybe<Scalars['JSON']>
  /** Whether the venue had DemandGen (Search Boost) in the period. */
  demandGen?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  /** Every published month, newest first. */
  issues: Array<MarketReportIssue>
  /** local or destination */
  mode?: Maybe<Scalars['String']>
  periodEnd: Scalars['Date']
  publishedAt?: Maybe<Scalars['DateTime']>
  venueId: Scalars['Int']
  venueName: Scalars['String']
}

export type HubSpotOnlyDeal = {
  __typename?: 'HubSpotOnlyDeal'
  amount?: Maybe<Scalars['Float']>
  bookingId?: Maybe<Scalars['String']>
  dealName: Scalars['String']
  hubspotId: Scalars['String']
}

export type HubSpotReconciliationReport = {
  __typename?: 'HubSpotReconciliationReport'
  aiSummary?: Maybe<Scalars['String']>
  companies: Array<CompanyReconciliationResult>
  emailSent: Scalars['Boolean']
  periodEnd: Scalars['String']
  periodStart: Scalars['String']
  runAt: Scalars['String']
}

/**
 * What became of a contact when staff asked for it to be synced.
 *
 * ⚠️ NOT A BOOLEAN, and the reason is a data-protection rule rather than
 * ergonomics. Staff accounts are excluded from the CRM by the sync adapter,
 * which owns that list; with a bare boolean the admin client could not tell
 * "excluded" from "sent" and kept its OWN copy of the excluded-role list to
 * answer the question client-side. Two copies of a rule about who may appear
 * in a marketing consent database, in two repositories, is one copy too
 * many. The server decides, and says which.
 */
export type HubspotSyncResult = {
  __typename?: 'HubspotSyncResult'
  /**
   * Why nothing was sent. Null whenever `synced` is true, and non-null
   * whenever it is false — there is no third state, because a failure to
   * reach HubSpot is raised as an error rather than returned here.
   */
  skippedReason?: Maybe<HubspotSyncSkipReason>
  /** True only when HubSpot accepted the submission. */
  synced: Scalars['Boolean']
}

/** Why a sync sent nothing. All three are successes; they are different facts. */
export enum HubspotSyncSkipReason {
  /**
   * The address is a HeadBox staff one, so the account is deliberately
   * kept out of the CRM — a colleague is not a customer contact, whatever
   * roles the account happens to hold. A PROPERTY OF THE ADDRESS:
   * permanent, correct, and retrying will never change it. Show it as an
   * explanation, never as an error to resolve.
   */
  ExcludedDomain = 'EXCLUDED_DOMAIN',
  /**
   * The account holds a staff role, so it is deliberately kept out of the
   * CRM — colleagues in a marketing consent database are both a
   * data-protection problem and a reporting one. A PROPERTY OF THE
   * ACCOUNT: permanent, correct, and retrying will not change it. Show it
   * as an explanation, never as an error to resolve.
   */
  ExcludedRole = 'EXCLUDED_ROLE',
  /**
   * The sync is switched off for this deployment — staging shares its
   * portals with production, so a test account must not create a real CRM
   * contact. A PROPERTY OF THE ENVIRONMENT, saying nothing about this
   * account: the same user would sync on production.
   */
  SyncDisabled = 'SYNC_DISABLED',
}

/**
 * A started impersonation. The token is returned exactly once, at mint —
 * only its digest is stored, so it cannot be read back.
 */
export type ImpersonationHandle = {
  __typename?: 'ImpersonationHandle'
  /** When the session dies on its own, ISO 8601. */
  expiresAt: Scalars['String']
  /** Who the caller is about to become, for the confirmation copy. */
  subjectName: Scalars['String']
  /** Goes into the refresh cookie. Treat as a bearer credential. */
  token: Scalars['String']
}

export type Invitation = {
  __typename?: 'Invitation'
  ID: Scalars['Int']
  activityLog: Array<InvitationActivityLogEntry>
  /** The booking (brief) this invitation is for */
  booking?: Maybe<Booking>
  bookingId: Scalars['Int']
  createdAt: Scalars['String']
  declinedAt?: Maybe<Scalars['String']>
  declinedReason?: Maybe<InvitationDeclinedReason>
  declinedReasonDetails?: Maybe<Scalars['String']>
  dueDate?: Maybe<Scalars['String']>
  event: Event
  isReadByRecipient: Scalars['Boolean']
  lapsedAt?: Maybe<Scalars['String']>
  proposals?: Maybe<Array<Proposal>>
  recipient?: Maybe<ServiceProvider>
  recipientId: Scalars['Int']
  recipientType: ServiceProviderType
  reminders: Array<InvitationReminder>
  space?: Maybe<SelfServeSpace>
  status: InvitationStatus
  unmetRequirementKeys?: Maybe<Array<Scalars['String']>>
  venue?: Maybe<SelfServeVenue>
}

export type InvitationActivityLogEntry = {
  __typename?: 'InvitationActivityLogEntry'
  ID: Scalars['Int']
  actorId?: Maybe<Scalars['Int']>
  actorType: Scalars['String']
  createdAt: Scalars['String']
  invitationID: Scalars['Int']
  metadata?: Maybe<Scalars['String']>
  type: InvitationActivityType
}

export enum InvitationActivityType {
  DueDateChanged = 'DueDateChanged',
  InvitationDeclined = 'InvitationDeclined',
  InvitationLapsed = 'InvitationLapsed',
  InvitationUndeclined = 'InvitationUndeclined',
  InvitationUnlapsed = 'InvitationUnlapsed',
  NudgeCancelled = 'NudgeCancelled',
  NudgeFailed = 'NudgeFailed',
  NudgeScheduled = 'NudgeScheduled',
  NudgeSent = 'NudgeSent',
  NudgeSuppressed = 'NudgeSuppressed',
  ProposalSubmitted = 'ProposalSubmitted',
  ScheduleOverridden = 'ScheduleOverridden',
}

export enum InvitationDeclinedReason {
  CateringRequirements = 'CateringRequirements',
  FacilitiesRequirements = 'FacilitiesRequirements',
  LowBudget = 'LowBudget',
  NoAvailability = 'NoAvailability',
  Other = 'Other',
}

export enum InvitationFilterDeclined {
  Any = 'Any',
  DeclinedOnly = 'DeclinedOnly',
  UndeclinedOnly = 'UndeclinedOnly',
}

export type InvitationReminder = {
  __typename?: 'InvitationReminder'
  ID: Scalars['Int']
  invitationID: Scalars['Int']
  isOverride: Scalars['Boolean']
  scheduledAt: Scalars['String']
  sentAt?: Maybe<Scalars['String']>
  sequencePosition: Scalars['Int']
  status: InvitationReminderStatus
}

export type InvitationReminderOverrideInput = {
  offsetWorkingDays?: InputMaybe<Scalars['Int']>
  scheduledAt: Scalars['String']
}

export enum InvitationReminderStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Scheduled = 'Scheduled',
  Sent = 'Sent',
  Suppressed = 'Suppressed',
}

export enum InvitationStatus {
  AwaitingResponse = 'AwaitingResponse',
  /**
   * The enquiry was released or concluded (cancelled, booked elsewhere,
   * completed) while this invitation was still open. The venue can no
   * longer respond.
   */
  Closed = 'Closed',
  Declined = 'Declined',
  Lapsed = 'Lapsed',
  Responded = 'Responded',
}

export type InvitationsFilter = {
  ignoreInvitationsWithProposals?: InputMaybe<Scalars['Boolean']>
  invitationStatusFilter?: InputMaybe<InvitationFilterDeclined>
  restrictToUser?: InputMaybe<Scalars['Boolean']>
}

export type InvitationsForSpacesPage = {
  __typename?: 'InvitationsForSpacesPage'
  rows: Array<Invitation>
  total: Scalars['Int']
}

export type InviteVenueGroupMemberInput = {
  capabilities?: InputMaybe<Array<VenueGroupCapability>>
  email: Scalars['String']
  /** Required when the address has no HeadBox account yet. */
  firstName?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  role: VenueGroupMembershipRole
  /** Omit or null for all venues. */
  venueIds?: InputMaybe<Array<Scalars['Int']>>
}

export enum KanbanStatus {
  BackfilledFromHubSpot = 'BackfilledFromHubSpot',
  Complete = 'Complete',
  Contracting = 'Contracting',
  FastTracked = 'FastTracked',
  NewEvent = 'NewEvent',
  ProposalReview = 'ProposalReview',
  ProposalsSent = 'ProposalsSent',
  Released = 'Released',
  RequestedToBook = 'RequestedToBook',
  Sourcing = 'Sourcing',
  Takeover = 'Takeover',
}

export type LeadsPage = {
  __typename?: 'LeadsPage'
  /** Infomation of this current page. */
  pages: Page
  /** Rows of AM leads. */
  rows: Array<Brief>
  /** Total number of pages. */
  totalPages: Scalars['Int']
  /** Totla number of AM leads. */
  totalRows: Scalars['Int']
}

export enum LifecycleStage {
  AwaitingDecision = 'AwaitingDecision',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Completed = 'Completed',
  Created = 'Created',
  HostsInvited = 'HostsInvited',
  Lost = 'Lost',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoInvitations = 'NoInvitations',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponseChosen = 'NoResponseChosen',
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  NoResponses = 'NoResponses',
  ProposalsReceived = 'ProposalsReceived',
  ProposalsSent = 'ProposalsSent',
  RequestedToBook = 'RequestedToBook',
}

export type Listing = {
  __typename?: 'Listing'
  additionalContacts: Array<AdditionalContact>
  address: Scalars['String']
  commissionDetails?: Maybe<Scalars['String']>
  country: Scalars['String']
  createdAt: Scalars['String']
  deletedAt?: Maybe<Scalars['String']>
  description: Scalars['String']
  id: Scalars['Int']
  latitude: Scalars['Float']
  listingDocuments: Array<ListingDocument>
  listingImages: Array<ListingImage>
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: ListingSupplierType
  sustainabilityIds: Array<Scalars['Int']>
  updatedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  user: User
  userId: Scalars['Int']
  websiteUrl: Scalars['String']
}

export type ListingDocument = {
  __typename?: 'ListingDocument'
  deletedAt?: Maybe<Scalars['String']>
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  id: Scalars['Int']
  listingId: Scalars['Int']
  order: Scalars['Int']
  updatedAt: Scalars['String']
  uploadedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  url: Scalars['String']
  userId: Scalars['Int']
  uuid: Scalars['String']
}

export type ListingDocumentInput = {
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  order: Scalars['Int']
  userId: Scalars['Int']
}

export type ListingFilter = {
  capacity?: InputMaybe<Scalars['Int']>
  latitude?: InputMaybe<Scalars['Float']>
  listingId?: InputMaybe<Scalars['Int']>
  listingIds?: InputMaybe<Array<Scalars['Int']>>
  longitude?: InputMaybe<Scalars['Float']>
  name?: InputMaybe<Scalars['String']>
  radius?: InputMaybe<Scalars['Int']>
  supplierType?: InputMaybe<ListingSupplierType>
  sustainabilityIds?: InputMaybe<Array<Scalars['Int']>>
  userId?: InputMaybe<Scalars['Int']>
  userIds?: InputMaybe<Array<Scalars['Int']>>
}

export type ListingImage = {
  __typename?: 'ListingImage'
  deletedAt?: Maybe<Scalars['String']>
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  id: Scalars['Int']
  listingId: Scalars['Int']
  order: Scalars['Int']
  updatedAt: Scalars['String']
  uploadedAt: Scalars['String']
  uploadedBy: Scalars['Int']
  url: Scalars['String']
  userId: Scalars['Int']
  uuid: Scalars['String']
}

export type ListingImageInput = {
  fileExtension: Scalars['String']
  fileName: Scalars['String']
  fileSize: Scalars['Int']
  order: Scalars['Int']
  userId: Scalars['Int']
}

export type ListingImageOrder = {
  imageId: Scalars['Int']
  order: Scalars['Int']
}

export enum ListingSupplierType {
  Accommodation = 'Accommodation',
  Activity = 'Activity',
  AdditionalSpend = 'Additional_spend',
  AudioVisual = 'Audio_visual',
  Branding = 'Branding',
  Catering = 'Catering',
  CorporateGifting = 'Corporate_gifting',
  Entertainment = 'Entertainment',
  EventManagement = 'Event_management',
  EventStaff = 'Event_staff',
  Florist = 'Florist',
  Furniture = 'Furniture',
  Merchandise = 'Merchandise',
  Photographers = 'Photographers',
  Props = 'Props',
  Sustainability = 'Sustainability',
  Travel = 'Travel',
}

export type LockAccountInput = {
  /**
   * Free-text cause recorded alongside the lock, for whoever has to
   * explain it later. Never shown to the locked user.
   */
  reason?: InputMaybe<Scalars['String']>
  userID: Scalars['Int']
}

export type LogoutInput = {
  /**
   * The caller's refreshToken (user_auth cookie value), if it holds one.
   * Optional: the access token in the request header is revoked either
   * way, but a client that keeps a refresh token must send it too or that
   * token could be exchanged for a fresh JWT immediately after logout.
   */
  refreshToken?: InputMaybe<Scalars['String']>
}

export enum ManagementStatus {
  Booked = 'Booked',
  Live = 'Live',
  PastEvent = 'PastEvent',
  Released = 'Released',
}

export type MarkBookingAsSupplierInput = {
  bookingUuid: Scalars['ID']
  supplierType: SupplierType
}

/** A brief (booking) for Market Insights: where, what, and what happened. */
export type MarketBrief = {
  __typename?: 'MarketBrief'
  attendees?: Maybe<Scalars['Int']>
  /** The venue in the latest confirmation, when confirmed and not a ghost */
  bookedVenueID?: Maybe<Scalars['Int']>
  bookingID: Scalars['Int']
  budget?: Maybe<Scalars['Float']>
  /** HubSpot's amount in the company's currency */
  closedAmountCompanyCurrency?: Maybe<Scalars['Float']>
  closedAt?: Maybe<Scalars['String']>
  company?: Maybe<Scalars['String']>
  companyID?: Maybe<Scalars['Int']>
  country?: Maybe<Scalars['String']>
  currency?: Maybe<Scalars['String']>
  eventID: Scalars['Int']
  eventLat?: Maybe<Scalars['Float']>
  /** The event's location, for bookings without their own */
  eventLocation?: Maybe<Scalars['String']>
  eventLon?: Maybe<Scalars['Float']>
  eventRadiusKm?: Maybe<Scalars['Float']>
  eventTypeID?: Maybe<Scalars['Int']>
  firstInvitedAt: Scalars['String']
  fromDateTime?: Maybe<Scalars['String']>
  invitations: Array<MarketBriefInvitation>
  lat?: Maybe<Scalars['Float']>
  lifecycleStage?: Maybe<Scalars['String']>
  /** The booking's location (kept current by the events team) */
  location?: Maybe<Scalars['String']>
  lon?: Maybe<Scalars['Float']>
  lostAt?: Maybe<Scalars['String']>
  lostReason?: Maybe<Scalars['String']>
  /** The drawn area as EventHQ stores it: a JSON array of {lat, lng} */
  polygon?: Maybe<Scalars['String']>
  radiusKm?: Maybe<Scalars['Float']>
  toDateTime?: Maybe<Scalars['String']>
}

/** A space invitation on a brief, with that space's first proposal. */
export type MarketBriefInvitation = {
  __typename?: 'MarketBriefInvitation'
  invitedAt: Scalars['String']
  /** The proposal's base cost in minor units */
  proposalCostMinor?: Maybe<Scalars['Float']>
  proposedAt?: Maybe<Scalars['String']>
  spaceID: Scalars['Int']
}

export type MarketBriefsInput = {
  /** Keyset paging: booking ids after this one. */
  afterBookingID?: InputMaybe<Scalars['Int']>
  /** The brief's own country, two-letter codes, e.g. GB and IE. */
  countries: Array<Scalars['String']>
  /** Briefs whose first space invitation went out on or after this, ISO 8601. */
  from: Scalars['String']
  /** At most 1000. */
  limit: Scalars['Int']
  /** ...and before this, ISO 8601. At most 25 months. */
  to: Scalars['String']
}

/** A venue the signed-in user can read Market Insights for. */
export type MarketInsightVenue = {
  __typename?: 'MarketInsightVenue'
  /** The latest published report; null until the first is published. */
  latest?: Maybe<MarketReportIssue>
  name: Scalars['String']
  venueId: Scalars['Int']
}

/** Whether a venue has the data for a report, and which kind. */
export type MarketReadiness = {
  __typename?: 'MarketReadiness'
  /** Venues invited alongside it. */
  competitors: Scalars['Int']
  /** Briefs in the last year that went to venues it competes with. */
  destinationBriefs: Scalars['Int']
  /** Briefs in the last year within 5 km. */
  localBriefs: Scalars['Int']
  /** local or destination */
  mode: Scalars['String']
  radiusKm: Scalars['Float']
  ready: Scalars['Boolean']
  reasons: Array<Scalars['String']>
}

/** A generated Market Insights report for a venue and month. Each generation is a new version. */
export type MarketReport = {
  __typename?: 'MarketReport'
  /** The written story: headlines, paragraphs, actions (only on marketReport). */
  copy?: Maybe<Scalars['JSON']>
  createdAt: Scalars['DateTime']
  /** The report data the page computes from (only on marketReport). */
  data?: Maybe<Scalars['JSON']>
  /** Whether the venue had DemandGen (Search Boost) in the period, which changes the wording. */
  demandGen?: Maybe<Scalars['Boolean']>
  error?: Maybe<Scalars['String']>
  /** What the checks found on each failed attempt. */
  failedAttempts: Array<Array<Scalars['String']>>
  generatedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  /** local or destination */
  mode?: Maybe<Scalars['String']>
  model?: Maybe<Scalars['String']>
  /** model (Claude wrote it) or fallback (template text after the model failed the checks twice) */
  narrativeSource?: Maybe<Scalars['String']>
  /** The last day of the month the report covers. */
  periodEnd: Scalars['Date']
  /** What the checks found on the final text (empty when it passed). */
  problems: Array<Scalars['String']>
  publishedAt?: Maybe<Scalars['DateTime']>
  readiness?: Maybe<MarketReadiness>
  requestedByUserId?: Maybe<Scalars['Int']>
  reviewedAt?: Maybe<Scalars['DateTime']>
  reviewedByUserId?: Maybe<Scalars['Int']>
  /** queued, generating, needs_review, published or failed */
  status: Scalars['String']
  /** assigned (first report), monthly, or manual (staff) */
  trigger: Scalars['String']
  venueId: Scalars['Int']
  venueName?: Maybe<Scalars['String']>
  version: Scalars['Int']
}

/** A published month of a venue's Market Insights. */
export type MarketReportIssue = {
  __typename?: 'MarketReportIssue'
  id: Scalars['ID']
  /** local or destination */
  mode?: Maybe<Scalars['String']>
  /** The last day of the month the report covers. */
  periodEnd: Scalars['Date']
  publishedAt?: Maybe<Scalars['DateTime']>
}

export type MergeVenueGroupsInput = {
  /** Soft-delete sources left with no venues, contracts or live seats. */
  deleteEmptied: Scalars['Boolean']
  /** Source owner seats to keep as owners; every other source owner becomes a member scoped to their former venues. */
  keepAsOwnerMembershipIds?: InputMaybe<Array<Scalars['Int']>>
  sourceIds: Array<Scalars['Int']>
  targetId: Scalars['Int']
}

export type MergeVenueGroupsResult = {
  __typename?: 'MergeVenueGroupsResult'
  addedMarkets: Array<VenueGroupMarket>
  deletedVenueGroupIds: Array<Scalars['Int']>
  membershipIds: Array<Scalars['Int']>
  movedContractIds: Array<Scalars['Int']>
  movedVenueIds: Array<Scalars['Int']>
  venueGroup: VenueGroup
}

export type MoveBookingInput = {
  bookingId: Scalars['Int']
  parentFolderId?: InputMaybe<Scalars['Int']>
  position: Scalars['Int']
}

export type MoveBookingsFolderInput = {
  bookingsFolderId: Scalars['Int']
  parentFolderId?: InputMaybe<Scalars['Int']>
  position: Scalars['Int']
}

export type MoveVenuesResult = {
  __typename?: 'MoveVenuesResult'
  deletedVenueGroupIds: Array<Scalars['Int']>
  movedVenueIds: Array<Scalars['Int']>
  venueGroup: VenueGroup
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Activate every seat waiting for the signed-in user. Also happens implicitly on myVenueGroups. */
  AcceptVenueGroupInvitations: Array<VenueGroupMembership>
  AddVenueGroupAttachment: VenueGroupAttachment
  ArchiveProductPackage: ProductPackage
  /** Moves venues; refused for venues in a venue group with a contract unless confirmMove is true. */
  AttachVenuesToVenueGroup: VenueGroup
  /**
   * Links a given `twilioConsentUUID` to a specific `User`. This  is required for the `validationUuids`,
   * `hasValidatedEmail`, `hasValidatedPhone` and `consentedToTwilioTermsAndConditionsAt` fields on
   * the `User` object
   */
  ClaimTwilioConsentUUID?: Maybe<User>
  CreateFastTrackVenueAndSpace: Venue
  CreateFullListing: CreatedListing
  CreateListing: Listing
  CreateListingDocument: UploadedDocumentResponse
  CreateListingImage: UploadedImageResponse
  CreateProductCategory: ProductCategory
  CreateProductFeature: ProductFeature
  CreateProductPackage: ProductPackage
  CreateSpaceSummary?: Maybe<Space>
  CreateVenue?: Maybe<Venue>
  CreateVenueContract: VenueContract
  CreateVenueGroup: VenueGroup
  CreateVenueGroupNote: VenueGroupNote
  DeleteAdditionalContact: AdditionalContact
  DeleteListing: Listing
  DeleteListingDocument: ListingDocument
  DeleteListingImage: ListingImage
  DeleteListingsForUser: DeleteListingsForUserResult
  DeleteSpace?: Maybe<Space>
  DeleteSpaceDocument?: Maybe<S3DeletedResponse>
  DeleteSpacePhoto?: Maybe<S3DeletedResponse>
  DeleteVenue?: Maybe<Venue>
  DeleteVenueGroupNote: VenueGroupNote
  DuplicateSpace?: Maybe<Space>
  InviteVenueGroupMember: VenueGroupMembership
  /** Fold whole venue groups into a target (venues, contracts, seats). Staff only. */
  MergeVenueGroups: MergeVenueGroupsResult
  MoveSpace?: Maybe<Space>
  /** Move venues into a venue group, optionally deleting sources this empties. Staff only. */
  MoveVenuesToVenueGroup: MoveVenuesResult
  PublishSpace?: Maybe<Space>
  ReactivateVenueGroupMember: VenueGroupMembership
  /**
   * Records that a visitor, including unregistered users, has
   * consented to Twilios terms and condition. Returns a "Validation UUID",
   * which is required to call mutations which intergrate with Twilio
   */
  RecordTwilioConsent: Scalars['String']
  RejectSpace?: Maybe<Space>
  RemoveVenueGroupAttachment: VenueGroupAttachment
  /**
   * Sends an email confirmation code to an email address.
   * A Validation UUID, aquired from the `RecordTwilioConsent` mutation or
   * the `validationUuid` field on `User`s, is required to ensure the visitor has
   * consented to the terms and conditions
   */
  RequestEmailValidationCode?: Maybe<Scalars['Boolean']>
  /**
   * Sends a phone number validation code to a phone number.
   * A Validation UUID, acquired from the `RecordTwilioConsent` mutation or
   * the `validationUuids` field on `User`s, is required to ensure the visitor has
   * consented to the terms and conditions.
   */
  RequestPhoneNumberValidationCode?: Maybe<Scalars['Boolean']>
  ResendVenueGroupInvitation: VenueGroupMembership
  RestoreProductPackage: ProductPackage
  RevokeVenueGroupInvitation: VenueGroupMembership
  /** Save a batch of assignment changes with one effective date. Returns conflicts instead of saving when a same-category replace is not confirmed. */
  SaveVenueAllocations: SaveVenueAllocationsResult
  /** Tick or clear Reviewed by CS. Saving a contract also ticks it. Does not create a contract version. */
  SetVenueContractReviewed: VenueContract
  SetVenueContractSignedPdf: VenueContract
  /** Hide one briefing item for the signed-in person until tomorrow. */
  SkipBriefingItem: Scalars['Boolean']
  SubmitSpaceToReview?: Maybe<Space>
  SuspendVenueGroupMember: VenueGroupMembership
  TransferOwnership: Venue
  TriggerBotCandidateJob: BotCandidateJobResponse
  TriggerBotResearchJob: BotResearchJobResponse
  UnpublishSpace?: Maybe<Space>
  UpdateCollections?: Maybe<Space>
  UpdateIsPrivate?: Maybe<Space>
  UpdateListing: Listing
  UpdateListingImagesOrder: Array<ListingImage>
  UpdateProductCategory: ProductCategory
  UpdateProductFeature: ProductFeature
  UpdateProductPackage: ProductPackage
  UpdateSpaceDocuments?: Maybe<Space>
  UpdateSpaceFacilities?: Maybe<Space>
  UpdateSpacePhotos?: Maybe<Space>
  UpdateSpaceStyles?: Maybe<Space>
  UpdateSpaceSummary?: Maybe<Space>
  UpdateSpatialConfiguration?: Maybe<Space>
  UpdateTour3dUrl?: Maybe<Space>
  UpdateVenue?: Maybe<Venue>
  /** Every save is a new version. See UpdateVenueContractInput for active-contract semantics. */
  UpdateVenueContract: VenueContract
  /** Move the renewal along or set the next action. Does not create a contract version. */
  UpdateVenueContractRenewal: VenueContract
  UpdateVenueGroup: VenueGroup
  UpdateVenueGroupMember: VenueGroupMembership
  UpdateVenueGroupNote: VenueGroupNote
  UpdateVenueLeadFeedEnabledStatus: Venue
  /**
   * Verifies the `code` matches the code sent to the email address corresponding to the `twilioConsentUUID`.
   * This mutation returns true if the code is valid and false otherwise.
   * An error is thrown if the `twilioConsentUUID` is invalid or has not been used to request an email
   * validation code.
   */
  ValidateEmail?: Maybe<Scalars['Boolean']>
  /**
   * Verifies the `code` matches the code sent to the phone number corresponding to the `twilioConsentUUID`.
   * This mutation returns true if the code is valid and false otherwise.
   * An error is thrown if the `twilioConsentUUID` is invalid or has not been used to request a phone number
   * validation code.
   */
  ValidatePhoneNumber?: Maybe<Scalars['Boolean']>
  /** Signed PUT URL to upload the signed PDF; then call SetVenueContractSignedPdf. */
  VenueContractSignedPdfUploadInfo: VenueContractSignedPdfUploadInfo
  /** Signed PUT for a private upload; then AddVenueGroupAttachment. */
  VenueGroupAttachmentUploadInfo: VenueGroupAttachmentUploadInfo
  _?: Maybe<Scalars['Boolean']>
  addContractDocument: ContractDocument
  /** Post a staff reply on a proposal thread. */
  addProposalComment: ProposalComment
  /** Leave a HeadBox-internal note on a venue. */
  addStaffVenueNote: StaffVenueNote
  /**
   * Add people to a team.
   *
   * Refusals are reported, not thrown — a row for somebody who has left the
   * company does not cost the rest of the file its team assignment. Genuine
   * faults still throw and roll the whole call back.
   */
  addUsersToTeam: Array<TeamMembershipResult>
  adjudicateAgentDecision: AgentDecision
  anonymiseAccount: Scalars['Boolean']
  archiveVenueAsset: VenueAsset
  assignUserToCompany: CompanyUser
  assignUserToRole: CompanyUser
  assignUsersToCompany: Array<Maybe<CompanyUser>>
  authenticateGuest: Session
  authenticateWithMagicLink: Session
  beginSsoLogin: SsoLoginStart
  /** Create a new brief by BriefAttributes. */
  brief?: Maybe<Brief>
  cancelBooking: Booking
  cancelEvent: Event
  changeEventBooker: Event
  changeKanbanColumn: Event
  /** Claim a brief by ID. */
  claimBrief?: Maybe<Brief>
  completeBooking: Booking
  /** @deprecated complete event now deprecated on complex events model */
  completeEvent: Event
  completeSsoLogin: SsoSession
  confirmBookingVenue: Booking
  confirmBookingVenues: Array<Booking>
  createAdditionalSpendBooking: Booking
  createBookerNote: BookerNote
  createBooking: Booking
  createBookingsFolder: BookingsFolder
  createBusinessGuestAccount: Session
  createCompany: Company
  createContractDocumentUpload: ContractDocumentUpload
  createEvent: Event
  createEventNote: EventNote
  createHostAccount: Session
  /**
   * Create an INVITED business guest (P9 — staff bulk import).
   *
   * The account exists and cannot be signed into until they redeem a
   * sign-in link: no password is set, and the stored hash is random and
   * unguessable. Sending the link is a SEPARATE call, deliberately — a
   * membership failure between the two must not leave someone invited to
   * a company they are not in.
   *
   * Staff only, and the new user's country must sit inside the caller's
   * own reach: creating someone you would then be unable to see is a way
   * of losing people.
   *
   * Returns the created user. No session is minted — the operator is
   * creating somebody else's account, not their own.
   */
  createInvitedGuest: AdminUser
  createProposal: Proposal
  createProposalOnBehalf: Proposal
  createStandardGuestAccount: Session
  createSupplier: Supplier
  createSupplierAccount: Session
  createSupplierDeal: SupplierDeal
  /**
   * Create a team and its first manager, in one transaction.
   *
   * Name must be unique within the company. ⚠️ That is a RedBox validation
   * with no database constraint behind it, so it is enforced here rather
   * than by the schema — two simultaneous creates could still both land.
   */
  createTeam: CompanyTeam
  /**
   * Create a user from the admin.
   *
   * ⚠️ Gated by exactly the rules that gate updateUser, through the same
   * function: you may not grant a role ranked above your own, nor regions
   * covering countries you cannot reach, nor create a user in a country
   * outside your own reach. Creating a user holding a role and editing one
   * to hold it are the same grant, so they share one gate.
   *
   * The account is always PASSWORDLESS — there is no field for a password
   * and there must not be. It exists and cannot be signed into until a
   * sign-in link is redeemed.
   */
  createUser: AdminUser
  createVenueAsset: VenueAsset
  declineInvitation: Invitation
  declineProposal: Proposal
  declineProposals: Array<Proposal>
  deleteBookerNote: BookerNote
  deleteBookingsFolder: BookingsFolder
  deleteEventNote: EventNote
  /** Staff only. Delete a report (a test, or one that shouldn't be kept). Not while it's being written. */
  deleteMarketReport: Scalars['Boolean']
  /** Delete your own note. False when the note isn't yours or no longer exists. */
  deleteStaffVenueNote: Scalars['Boolean']
  deleteSupplier: Supplier
  deleteSupplierDeal: SupplierDeal
  /** Disqualify a brief by ID. */
  disqualifyBrief?: Maybe<Brief>
  editCompany: Company
  forceInvitationReminder: Invitation
  /** Staff only. Generate a venue's report now (a new version of that month's; last month's by default). Runs in the background. */
  generateMarketReport: MarketReport
  getProposalDocumentUrl: ProposalSignedUrlData
  getSupplierDealAttachmentUrl: SupplierDealAttachmentSignedUrlData
  getVenueAssetUploadUrl: VenueAssetUploadInfo
  /**
   * Begin impersonating a user (P6 / T6). Returns a handle the caller
   * writes into the refresh cookie in place of their own.
   *
   * NOT a JWT, and the difference matters. Every app in this estate
   * bootstraps from the refresh cookie and treats a missing one as signed
   * out, so a JWT-only impersonation would be invisible rather than
   * short-lived. The handle is backed by a row with a hard expiry that is
   * re-checked on every session exchange, which is what makes the hour
   * real and the session revocable — neither of which a bare JWT can
   * offer, since it carries no jti.
   *
   * Admins may impersonate anyone including other admins; that is parity
   * with RedBox today and is defensible only because of the audit row this
   * writes. Everyone else is additionally limited to accounts holding a
   * host, supplier or business role.
   *
   * The caller's own session is replaced, not stashed. Ending the
   * impersonation signs them out rather than restoring them.
   */
  impersonateUser: ImpersonationHandle
  lockAccount: Scalars['Boolean']
  logout: Scalars['Boolean']
  markAllNotificationsSeen: Scalars['Int']
  markBookingAsSupplier: Booking
  markBookingVenueAsGhost: Booking
  /** Move the caller's read cursor to now. False when there's no conversation yet. */
  markEventConversationRead: Scalars['Boolean']
  markHoldWakeSeen: Event
  markInvitationRead: Invitation
  markNotificationSeen: Notification
  markUserAsHostById: User
  moveBooking: Booking
  moveBookingsFolder: BookingsFolder
  overrideInvitationReminderSchedule: Invitation
  /** Staff only. Publish a report waiting for review, so the venue sees it. */
  publishMarketReport: MarketReport
  publishNotification: Notification
  putEventOnHold: Event
  reconcileHubSpot: HubSpotReconciliationReport
  /** Release a brief by ID. */
  releaseBrief?: Maybe<Brief>
  releaseProposals: Array<Proposal>
  removeContractDocument: Scalars['Boolean']
  removeEventDeliveryDate: Event
  removeUserFromCompany: CompanyUser
  /**
   * Remove one person from a team.
   *
   * Refuses to remove the last member or the last manager. Those are
   * invariants RedBox validates when a TEAM is saved, so breaking one here
   * surfaces later as an unsaveable team in the customer's own edit form,
   * with nothing pointing back to this call.
   */
  removeUserFromTeam: Scalars['Boolean']
  /**
   * Rename a team. The only editable field offered: budgets, payment
   * details, booking thresholds and finance contacts stay in RedBox's
   * customer UI until deliberately ported.
   */
  renameTeam: CompanyTeam
  requestToBook: Proposal
  /** Resend the brief confirmatio to guest email by ID. */
  resendBriefConfirmation?: Maybe<Brief>
  /** Resend the claimed brief infomation to Hubspot again by ID. */
  resendBriefToHubspot?: Maybe<Brief>
  resetPassword: Scalars['Boolean']
  resumeEvent: Event
  /**
   * Undo an accidental request to book: the requested proposal returns to SentToGuest,
   * proposals the request rejected are restored and the booking returns to ProposalsSent.
   */
  rollbackRequestToBook: Booking
  /**
   * Post to the event's conversation as the calling staff member. Emails the
   * booker's side and, when someone other than the event's manager posts, the
   * manager and the shared M&E mailbox. Starts the conversation if needed.
   */
  sendEventConversationMessage: EventConversationMessage
  sendInvitations: Array<Invitation>
  /**
   * Send a sign-in link AS STAFF (P9).
   *
   * Not to be confused with triggerMagicLink, which is the public
   * passwordless-login mutation: unauthenticated, keyed by email, and
   * always true whatever happens, so that it cannot be used to enumerate
   * accounts. This one is staff-gated, keyed by user id, and ANSWERS
   * TRUTHFULLY — an operator told "sent" while nothing was sent will wait
   * for a reply that never comes.
   *
   * Refuses locked and erased accounts outright, and reports the rate
   * limit rather than hiding it.
   */
  sendMagicLink: Scalars['Boolean']
  /**
   * Send a password reset AS STAFF (P3 / T4).
   *
   * Not to be confused with triggerPasswordReset, which is the public
   * forgotten-password mutation: unauthenticated, gated by nothing, and
   * always true whatever happens, so that it cannot be used to enumerate
   * accounts. That is right for a login page and wrong for an operator —
   * it has no gate, no user id to audit against, and it reports success
   * for a locked account where nothing was sent.
   *
   * This one is staff-gated, reach-checked, refuses locked and erased
   * accounts outright, and writes an audit row.
   */
  sendPasswordReset: Scalars['Boolean']
  setAgentShadowPaused: AgentPanelStatus
  setEventDeliveryDate: Event
  setHoldReminderDate: Event
  /**
   * Promote or demote somebody already in the team.
   *
   * Needed because addUsersToTeam sets manager on INSERT only, so the sole
   * way to change who ran a team was remove-and-re-add — which trips the
   * last-manager guard in the wrong order and made the operation
   * unreachable rather than merely awkward.
   *
   * Idempotent. Refuses to demote the last manager, and refuses to promote
   * somebody who is not an active member of the company; demotion carries
   * no such check, so a team whose only manager was suspended can still be
   * handed over.
   */
  setTeamManager: Scalars['Boolean']
  /**
   * End the impersonation the caller is currently inside.
   *
   * Takes the handle rather than a user id, because the caller making this
   * request IS the impersonated session. Idempotent.
   */
  stopImpersonating: Scalars['Boolean']
  /**
   * Push an existing user to the HubSpot CRM (P9).
   *
   * ⚠️ ONE MUTATION, TWO CALLERS. It is the RETRY CONTROL on the user
   * detail page — createUser reports a sync failure rather than hiding
   * it, and re-running createUser is not a fix because the email now
   * answers CONFLICT — and it is the FINAL STEP OF THE BULK IMPORT, run
   * after the account is created and the company attached. Syncing any
   * earlier in an import would record the wrong lawful basis, because the
   * company that supplies it is not attached yet.
   *
   * Staff only, and only on a user you may act on. An erased account is
   * refused: its address is redacted, and syncing it would write that
   * redaction into the CRM as a new contact.
   *
   * Safe to repeat. The write is an upsert keyed on email and the consent
   * properties are withheld from a contact that already exists, so a
   * second run cannot overwrite what HubSpot holds about someone's
   * consent.
   *
   * ⚠️ SUCCESS IS NOT THE SAME AS SENT. Returning nothing to send is a
   * success — an excluded staff account, or the sync switched off for
   * this deployment — so the result reports WHICH happened rather than
   * collapsing both into true. A failure to reach HubSpot is an error,
   * not a result.
   *
   * Only a genuine send is written to the audit trail. A skip did nothing
   * to the account and is recorded nowhere; this result is the only
   * account of it.
   */
  syncUserToHubspot: HubspotSyncResult
  transferHostProposals: TransferHostProposalsResult
  triggerMagicLink: Scalars['Boolean']
  triggerPasswordReset: Scalars['Boolean']
  undeclineInvitation: Invitation
  undeclineProposal: Proposal
  unlockAccount: Scalars['Boolean']
  updateBookerNote: BookerNote
  updateBooking: Booking
  updateBookingFromHubSpot: Booking
  updateBookingsFolder: BookingsFolder
  updateEvent: Event
  updateEventFromHubSpot: Booking
  updateEventNote: EventNote
  updateHost: HostInfo
  updateInvitationsDueDate: Array<Invitation>
  updatePreferredVenuesForCompany: Array<SelfServeVenue>
  updateProposal: Proposal
  updateProposalBaseDetails: Proposal
  /** Edit your own note. Errors when the note isn't yours or no longer exists. */
  updateStaffVenueNote: StaffVenueNote
  updateSupplier: Supplier
  updateSupplierDeal: SupplierDeal
  updateUser: AdminUser
  updateUserPhoneNumber: User
  updateUserStatus: CompanyUser
  updateVenueAsset: VenueAsset
}

export type MutationAddVenueGroupAttachmentArgs = {
  input: VenueGroupAttachmentInput
  noteId: Scalars['Int']
}

export type MutationArchiveProductPackageArgs = {
  id: Scalars['Int']
}

export type MutationAttachVenuesToVenueGroupArgs = {
  confirmMove?: InputMaybe<Scalars['Boolean']>
  venueGroupId: Scalars['Int']
  venueIds: Array<Scalars['Int']>
}

export type MutationClaimTwilioConsentUuidArgs = {
  twilioConsentUUID: Scalars['String']
  userId: Scalars['Int']
}

export type MutationCreateFastTrackVenueAndSpaceArgs = {
  input: FastTrackVenueInput
}

export type MutationCreateFullListingArgs = {
  input: CreateFullListingInput
}

export type MutationCreateListingArgs = {
  input: CreateListingInput
}

export type MutationCreateListingDocumentArgs = {
  input?: InputMaybe<ListingDocumentInput>
  listingId: Scalars['Int']
}

export type MutationCreateListingImageArgs = {
  input?: InputMaybe<ListingImageInput>
  listingId: Scalars['Int']
}

export type MutationCreateProductCategoryArgs = {
  input: ProductCategoryInput
}

export type MutationCreateProductFeatureArgs = {
  input: ProductFeatureInput
}

export type MutationCreateProductPackageArgs = {
  input: ProductPackageInput
}

export type MutationCreateSpaceSummaryArgs = {
  spaceSummary: SpaceSummaryInput
  venueId: Scalars['Int']
}

export type MutationCreateVenueArgs = {
  venue: VenueInput
}

export type MutationCreateVenueContractArgs = {
  input: CreateVenueContractInput
  venueGroupId: Scalars['Int']
}

export type MutationCreateVenueGroupArgs = {
  input: CreateVenueGroupInput
}

export type MutationCreateVenueGroupNoteArgs = {
  input: VenueGroupNoteInput
  venueGroupId: Scalars['Int']
}

export type MutationDeleteAdditionalContactArgs = {
  contactId: Scalars['Int']
  listingId: Scalars['Int']
}

export type MutationDeleteListingArgs = {
  listingId: Scalars['Int']
}

export type MutationDeleteListingDocumentArgs = {
  documentId: Scalars['Int']
  listingId: Scalars['Int']
}

export type MutationDeleteListingImageArgs = {
  imageId: Scalars['Int']
  listingId: Scalars['Int']
}

export type MutationDeleteListingsForUserArgs = {
  userId: Scalars['Int']
}

export type MutationDeleteSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationDeleteSpaceDocumentArgs = {
  s3Key: Scalars['String']
  spaceId: Scalars['Int']
}

export type MutationDeleteSpacePhotoArgs = {
  s3Key: Scalars['String']
  spaceId: Scalars['Int']
}

export type MutationDeleteVenueArgs = {
  id: Scalars['Int']
}

export type MutationDeleteVenueGroupNoteArgs = {
  noteId: Scalars['Int']
}

export type MutationDuplicateSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationInviteVenueGroupMemberArgs = {
  input: InviteVenueGroupMemberInput
  venueGroupId: Scalars['Int']
}

export type MutationMergeVenueGroupsArgs = {
  input: MergeVenueGroupsInput
}

export type MutationMoveSpaceArgs = {
  newVenueId: Scalars['Int']
  spaceId: Scalars['Int']
}

export type MutationMoveVenuesToVenueGroupArgs = {
  confirmMove?: InputMaybe<Scalars['Boolean']>
  deleteEmptiedSources: Scalars['Boolean']
  venueGroupId: Scalars['Int']
  venueIds: Array<Scalars['Int']>
}

export type MutationPublishSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationReactivateVenueGroupMemberArgs = {
  membershipId: Scalars['Int']
}

export type MutationRejectSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationRemoveVenueGroupAttachmentArgs = {
  attachmentId: Scalars['Int']
}

export type MutationRequestEmailValidationCodeArgs = {
  email: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationRequestPhoneNumberValidationCodeArgs = {
  phoneNumber: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationResendVenueGroupInvitationArgs = {
  membershipId: Scalars['Int']
}

export type MutationRestoreProductPackageArgs = {
  id: Scalars['Int']
}

export type MutationRevokeVenueGroupInvitationArgs = {
  membershipId: Scalars['Int']
}

export type MutationSaveVenueAllocationsArgs = {
  changes: Array<VenueAllocationChangeInput>
  effectiveFrom: Scalars['Date']
  venueGroupId: Scalars['Int']
}

export type MutationSetVenueContractReviewedArgs = {
  contractId: Scalars['Int']
  reviewed: Scalars['Boolean']
}

export type MutationSetVenueContractSignedPdfArgs = {
  contractId: Scalars['Int']
  filename: Scalars['String']
  s3Key: Scalars['String']
}

export type MutationSkipBriefingItemArgs = {
  key: Scalars['String']
}

export type MutationSubmitSpaceToReviewArgs = {
  spaceId: Scalars['Int']
}

export type MutationSuspendVenueGroupMemberArgs = {
  membershipId: Scalars['Int']
}

export type MutationTransferOwnershipArgs = {
  newUserId: Scalars['Int']
  venueId: Scalars['Int']
}

export type MutationTriggerBotCandidateJobArgs = {
  address: Scalars['String']
  id: Scalars['String']
  name: Scalars['String']
  website?: InputMaybe<Scalars['String']>
}

export type MutationTriggerBotResearchJobArgs = {
  venueId: Scalars['Int']
}

export type MutationUnpublishSpaceArgs = {
  spaceId: Scalars['Int']
}

export type MutationUpdateCollectionsArgs = {
  collectionIds: Array<InputMaybe<Scalars['Int']>>
  spaceId: Scalars['Int']
}

export type MutationUpdateIsPrivateArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']>
  spaceId: Scalars['Int']
}

export type MutationUpdateListingArgs = {
  input: UpdateListingInput
  listingId: Scalars['Int']
}

export type MutationUpdateListingImagesOrderArgs = {
  listingId: Scalars['Int']
  orders: Array<ListingImageOrder>
}

export type MutationUpdateProductCategoryArgs = {
  input: UpdateProductCategoryInput
  key: Scalars['String']
}

export type MutationUpdateProductFeatureArgs = {
  input: UpdateProductFeatureInput
  key: Scalars['String']
}

export type MutationUpdateProductPackageArgs = {
  id: Scalars['Int']
  input: ProductPackageInput
}

export type MutationUpdateSpaceDocumentsArgs = {
  spaceDocuments: Array<InputMaybe<SpaceDocumentInput>>
  spaceId: Scalars['Int']
}

export type MutationUpdateSpaceFacilitiesArgs = {
  spaceFacilityIds: Array<InputMaybe<Scalars['Int']>>
  spaceId: Scalars['Int']
}

export type MutationUpdateSpacePhotosArgs = {
  spaceId: Scalars['Int']
  spacePhotos: Array<InputMaybe<SpacePhotoInput>>
}

export type MutationUpdateSpaceStylesArgs = {
  spaceId: Scalars['Int']
  styleIds: Array<InputMaybe<StyleId>>
}

export type MutationUpdateSpaceSummaryArgs = {
  spaceId: Scalars['Int']
  spaceSummary: SpaceSummaryInput
}

export type MutationUpdateSpatialConfigurationArgs = {
  spaceId: Scalars['Int']
  spatialConfigurations: Array<InputMaybe<SpaceSpatialConfigurationInput>>
}

export type MutationUpdateTour3dUrlArgs = {
  spaceId: Scalars['Int']
  tour3dUrl?: InputMaybe<Scalars['String']>
}

export type MutationUpdateVenueArgs = {
  id: Scalars['Int']
  venue: VenueInput
}

export type MutationUpdateVenueContractArgs = {
  id: Scalars['Int']
  input: UpdateVenueContractInput
}

export type MutationUpdateVenueContractRenewalArgs = {
  contractId: Scalars['Int']
  input: VenueContractRenewalInput
}

export type MutationUpdateVenueGroupArgs = {
  id: Scalars['Int']
  input: UpdateVenueGroupInput
}

export type MutationUpdateVenueGroupMemberArgs = {
  input: UpdateVenueGroupMemberInput
  membershipId: Scalars['Int']
}

export type MutationUpdateVenueGroupNoteArgs = {
  input: UpdateVenueGroupNoteInput
  noteId: Scalars['Int']
}

export type MutationUpdateVenueLeadFeedEnabledStatusArgs = {
  id: Scalars['Int']
  leadFeedEnabledStatus: Scalars['Boolean']
}

export type MutationValidateEmailArgs = {
  code: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationValidatePhoneNumberArgs = {
  code: Scalars['String']
  twilioConsentUUID: Scalars['String']
}

export type MutationVenueContractSignedPdfUploadInfoArgs = {
  contractId: Scalars['Int']
  filename: Scalars['String']
}

export type MutationVenueGroupAttachmentUploadInfoArgs = {
  contentType?: InputMaybe<Scalars['String']>
  filename: Scalars['String']
  venueGroupId: Scalars['Int']
}

export type MutationAddContractDocumentArgs = {
  input: AddContractDocumentInput
}

export type MutationAddProposalCommentArgs = {
  input: AddProposalCommentInput
}

export type MutationAddStaffVenueNoteArgs = {
  input: AddStaffVenueNoteInput
}

export type MutationAddUsersToTeamArgs = {
  input: AddUsersToTeamInput
}

export type MutationAdjudicateAgentDecisionArgs = {
  adjudication?: InputMaybe<Scalars['String']>
  decisionID: Scalars['Int']
  note?: InputMaybe<Scalars['String']>
  reasons?: InputMaybe<Array<Scalars['String']>>
}

export type MutationAnonymiseAccountArgs = {
  userID: Scalars['Int']
}

export type MutationArchiveVenueAssetArgs = {
  id: Scalars['Int']
}

export type MutationAssignUserToCompanyArgs = {
  input: AssignUserToCompanyInput
}

export type MutationAssignUserToRoleArgs = {
  input: AssignUserToRoleInput
}

export type MutationAssignUsersToCompanyArgs = {
  input: Array<InputMaybe<AssignUserToCompanyInput>>
}

export type MutationAuthenticateGuestArgs = {
  input: AuthenticateGuestInput
}

export type MutationAuthenticateWithMagicLinkArgs = {
  input: AuthenticateWithMagicLinkInput
}

export type MutationBeginSsoLoginArgs = {
  input: BeginSsoLoginInput
}

export type MutationBriefArgs = {
  params: BriefAttributes
}

export type MutationCancelBookingArgs = {
  bookingUuid: Scalars['ID']
  releaseReason: EventReleaseReason
}

export type MutationCancelEventArgs = {
  UUID: Scalars['ID']
  releaseReason: EventReleaseReason
}

export type MutationChangeEventBookerArgs = {
  UUID: Scalars['ID']
  bookerID: Scalars['Int']
}

export type MutationChangeKanbanColumnArgs = {
  UUID: Scalars['ID']
  newKanbanColumn: Scalars['String']
}

export type MutationClaimBriefArgs = {
  id: Scalars['Int']
}

export type MutationCompleteBookingArgs = {
  bookingUuid: Scalars['ID']
}

export type MutationCompleteEventArgs = {
  UUID: Scalars['ID']
}

export type MutationCompleteSsoLoginArgs = {
  input: CompleteSsoLoginInput
}

export type MutationConfirmBookingVenueArgs = {
  input: ConfirmBookingVenueInput
}

export type MutationConfirmBookingVenuesArgs = {
  bookingUuids: Array<Scalars['ID']>
}

export type MutationCreateAdditionalSpendBookingArgs = {
  input: CreateAdditionalSpendInput
}

export type MutationCreateBookerNoteArgs = {
  input: CreateBookerNoteInput
}

export type MutationCreateBookingArgs = {
  input: CreateBookingInput
}

export type MutationCreateBookingsFolderArgs = {
  input: CreateBookingsFolderInput
}

export type MutationCreateBusinessGuestAccountArgs = {
  input: CreateBusinessGuestAccountInput
}

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput
}

export type MutationCreateContractDocumentUploadArgs = {
  input: CreateContractDocumentUploadInput
}

export type MutationCreateEventArgs = {
  input: CreateEventInput
}

export type MutationCreateEventNoteArgs = {
  input: CreateEventNoteInput
}

export type MutationCreateHostAccountArgs = {
  input: CreateHostAccountInput
}

export type MutationCreateInvitedGuestArgs = {
  input: CreateInvitedGuestInput
}

export type MutationCreateProposalArgs = {
  input: CreateProposalInput
}

export type MutationCreateProposalOnBehalfArgs = {
  input: CreateProposalOnBehalfInput
}

export type MutationCreateStandardGuestAccountArgs = {
  input: CreateStandardGuestAccountInput
}

export type MutationCreateSupplierArgs = {
  input: CreateSupplierInput
}

export type MutationCreateSupplierAccountArgs = {
  input: CreateSupplierAccountInput
}

export type MutationCreateSupplierDealArgs = {
  input: CreateSupplierDealInput
}

export type MutationCreateTeamArgs = {
  input: CreateTeamInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateVenueAssetArgs = {
  input: VenueAssetIn
}

export type MutationDeclineInvitationArgs = {
  ID: Scalars['Int']
  reason: InvitationDeclinedReason
  reasonDetails?: InputMaybe<Scalars['String']>
  unmetRequirementKeys?: InputMaybe<Array<Scalars['String']>>
}

export type MutationDeclineProposalArgs = {
  proposalId: Scalars['Int']
}

export type MutationDeclineProposalsArgs = {
  input: DeclineProposalsInput
}

export type MutationDeleteBookerNoteArgs = {
  input: DeleteBookerNoteInput
}

export type MutationDeleteBookingsFolderArgs = {
  bookingsFolderId: Scalars['Int']
}

export type MutationDeleteEventNoteArgs = {
  input: DeleteEventNoteInput
}

export type MutationDeleteMarketReportArgs = {
  id: Scalars['ID']
}

export type MutationDeleteStaffVenueNoteArgs = {
  id: Scalars['ID']
}

export type MutationDeleteSupplierArgs = {
  input: DeleteSupplierInput
}

export type MutationDeleteSupplierDealArgs = {
  input: DeleteSupplierDealInput
}

export type MutationDisqualifyBriefArgs = {
  id: Scalars['Int']
}

export type MutationEditCompanyArgs = {
  input: EditCompanyInput
}

export type MutationForceInvitationReminderArgs = {
  reminderID: Scalars['Int']
}

export type MutationGenerateMarketReportArgs = {
  periodEnd?: InputMaybe<Scalars['Date']>
  venueId: Scalars['Int']
}

export type MutationGetProposalDocumentUrlArgs = {
  eventID: Scalars['Int']
  filename: Scalars['String']
}

export type MutationGetSupplierDealAttachmentUrlArgs = {
  eventID: Scalars['Int']
  filename: Scalars['String']
}

export type MutationGetVenueAssetUploadUrlArgs = {
  filename: Scalars['String']
  venueId: Scalars['Int']
}

export type MutationImpersonateUserArgs = {
  userID: Scalars['Int']
}

export type MutationLockAccountArgs = {
  input: LockAccountInput
}

export type MutationLogoutArgs = {
  input?: InputMaybe<LogoutInput>
}

export type MutationMarkBookingAsSupplierArgs = {
  input: MarkBookingAsSupplierInput
}

export type MutationMarkBookingVenueAsGhostArgs = {
  bookingUuid: Scalars['ID']
}

export type MutationMarkEventConversationReadArgs = {
  eventUuid: Scalars['ID']
}

export type MutationMarkHoldWakeSeenArgs = {
  UUID: Scalars['ID']
}

export type MutationMarkInvitationReadArgs = {
  ID: Scalars['Int']
}

export type MutationMarkNotificationSeenArgs = {
  ID: Scalars['Int']
}

export type MutationMarkUserAsHostByIdArgs = {
  id: Scalars['Int']
}

export type MutationMoveBookingArgs = {
  input: MoveBookingInput
}

export type MutationMoveBookingsFolderArgs = {
  input: MoveBookingsFolderInput
}

export type MutationOverrideInvitationReminderScheduleArgs = {
  invitationID: Scalars['Int']
  reminders: Array<InvitationReminderOverrideInput>
}

export type MutationPublishMarketReportArgs = {
  id: Scalars['ID']
}

export type MutationPublishNotificationArgs = {
  input: PublishNotificationInput
}

export type MutationPutEventOnHoldArgs = {
  UUID: Scalars['ID']
  note?: InputMaybe<Scalars['String']>
  reason: HoldReason
  remindOn: Scalars['String']
}

export type MutationReconcileHubSpotArgs = {
  input?: InputMaybe<ReconcileHubSpotInput>
}

export type MutationReleaseBriefArgs = {
  id: Scalars['Int']
}

export type MutationReleaseProposalsArgs = {
  IDs: Array<Scalars['Int']>
}

export type MutationRemoveContractDocumentArgs = {
  ID: Scalars['Int']
}

export type MutationRemoveEventDeliveryDateArgs = {
  UUID: Scalars['ID']
}

export type MutationRemoveUserFromCompanyArgs = {
  input: RemoveUserFromCompanyInput
}

export type MutationRemoveUserFromTeamArgs = {
  input: RemoveUserFromTeamInput
}

export type MutationRenameTeamArgs = {
  input: RenameTeamInput
}

export type MutationRequestToBookArgs = {
  input: ReqToBookIn
}

export type MutationResendBriefConfirmationArgs = {
  id: Scalars['Int']
}

export type MutationResendBriefToHubspotArgs = {
  id: Scalars['Int']
}

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput
}

export type MutationResumeEventArgs = {
  UUID: Scalars['ID']
}

export type MutationRollbackRequestToBookArgs = {
  bookingUuid: Scalars['ID']
  reason?: InputMaybe<Scalars['String']>
}

export type MutationSendEventConversationMessageArgs = {
  input: SendEventConversationMessageInput
}

export type MutationSendInvitationsArgs = {
  bookingId?: InputMaybe<Scalars['Int']>
  eventID: Scalars['Int']
  recipientIds: Array<Scalars['Int']>
  recipientType: ServiceProviderType
}

export type MutationSendMagicLinkArgs = {
  accountJustCreated?: InputMaybe<Scalars['Boolean']>
  userID: Scalars['Int']
}

export type MutationSendPasswordResetArgs = {
  userID: Scalars['Int']
}

export type MutationSetAgentShadowPausedArgs = {
  paused: Scalars['Boolean']
}

export type MutationSetEventDeliveryDateArgs = {
  UUID: Scalars['ID']
  clientInformed: Scalars['Boolean']
  deliveryAt: Scalars['DateTime']
  deliveryType: DeliveryCommitmentType
  note?: InputMaybe<Scalars['String']>
}

export type MutationSetHoldReminderDateArgs = {
  UUID: Scalars['ID']
  remindOn: Scalars['String']
}

export type MutationSetTeamManagerArgs = {
  input: SetTeamManagerInput
}

export type MutationStopImpersonatingArgs = {
  token: Scalars['String']
}

export type MutationSyncUserToHubspotArgs = {
  userID: Scalars['Int']
}

export type MutationTransferHostProposalsArgs = {
  fromUserId: Scalars['Int']
  toUserId: Scalars['Int']
  venueId: Scalars['Int']
}

export type MutationTriggerMagicLinkArgs = {
  input: TriggerMagicLinkInput
}

export type MutationTriggerPasswordResetArgs = {
  input: TriggerPasswordResetInput
}

export type MutationUndeclineInvitationArgs = {
  ID: Scalars['Int']
}

export type MutationUndeclineProposalArgs = {
  proposalId: Scalars['Int']
}

export type MutationUnlockAccountArgs = {
  userID: Scalars['Int']
}

export type MutationUpdateBookerNoteArgs = {
  input: UpdateBookerNoteInput
}

export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput
}

export type MutationUpdateBookingFromHubSpotArgs = {
  input?: InputMaybe<UpdateEventOrBookingFromHubSpotInput>
}

export type MutationUpdateBookingsFolderArgs = {
  input: UpdateBookingsFolderInput
}

export type MutationUpdateEventArgs = {
  input?: InputMaybe<UpdateEventInput>
}

export type MutationUpdateEventFromHubSpotArgs = {
  input?: InputMaybe<UpdateEventOrBookingFromHubSpotInput>
}

export type MutationUpdateEventNoteArgs = {
  input: UpdateEventNoteInput
}

export type MutationUpdateHostArgs = {
  args: UpdateHostArgs
}

export type MutationUpdateInvitationsDueDateArgs = {
  bookingId: Scalars['Int']
  dueDate: Scalars['String']
}

export type MutationUpdatePreferredVenuesForCompanyArgs = {
  companyID: Scalars['Int']
  venueIDs: Array<Scalars['Int']>
}

export type MutationUpdateProposalArgs = {
  input: UpdateProposalInput
}

export type MutationUpdateProposalBaseDetailsArgs = {
  input: UpdateProposalBaseDetailsInput
}

export type MutationUpdateStaffVenueNoteArgs = {
  input: UpdateStaffVenueNoteInput
}

export type MutationUpdateSupplierArgs = {
  input: UpdateSupplierInput
}

export type MutationUpdateSupplierDealArgs = {
  input: UpdateSupplierDealInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserPhoneNumberArgs = {
  phoneNumber: Scalars['String']
  userID: Scalars['Int']
}

export type MutationUpdateUserStatusArgs = {
  input: UpdateUserStatusInput
}

export type MutationUpdateVenueAssetArgs = {
  id: Scalars['Int']
  input: VenueAssetIn
}

export type NearestTransit = {
  __typename?: 'NearestTransit'
  distanceKm?: Maybe<Scalars['Float']>
  station?: Maybe<Scalars['String']>
  transitType?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type Notification = {
  __typename?: 'Notification'
  ID: Scalars['Int']
  booking?: Maybe<Booking>
  event?: Maybe<Event>
  kind: NotificationKind
  occurredAt: Scalars['DateTime']
  payload: Scalars['JSON']
  resolvedAt?: Maybe<Scalars['DateTime']>
  seenAt?: Maybe<Scalars['DateTime']>
}

/**
 * Add a value here for each new kind of notification. Producers inside
 * self-serve call notifications.publish; other services call the
 * publishNotification mutation with the backend token.
 */
export enum NotificationKind {
  BookerComment = 'BookerComment',
  BookerMessage = 'BookerMessage',
  DeliveryDue = 'DeliveryDue',
  DeliveryOverdue = 'DeliveryOverdue',
  HoldWake = 'HoldWake',
  VenueConfirmationDue = 'VenueConfirmationDue',
}

export type NotificationRecipientInput = {
  ownerOfBookingUUID?: InputMaybe<Scalars['ID']>
  ownerOfEventUUID?: InputMaybe<Scalars['ID']>
  userId?: InputMaybe<Scalars['Int']>
}

export type Page = {
  __typename?: 'Page'
  hasNextPage: Scalars['Boolean']
  number: Scalars['Int']
  size: Scalars['Int']
}

export type PageInput = {
  number: Scalars['Int']
  size: Scalars['Int']
}

/** Whether to sort paginated records in ascending or descending order of the sort column */
export enum PaginationOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type PreferredVenuesByCompany = {
  __typename?: 'PreferredVenuesByCompany'
  company: Company
  preferredVenues: Array<SelfServeVenue>
}

/** A package/feature category, managed in the catalogue. The key is the stable identifier the one-package-per-category rule uses. */
export type ProductCategory = {
  __typename?: 'ProductCategory'
  key: Scalars['String']
  name: Scalars['String']
  position: Scalars['Int']
}

export type ProductCategoryInput = {
  key: Scalars['String']
  name: Scalars['String']
  position?: InputMaybe<Scalars['Int']>
}

/** Atomic flag a venue receives, e.g. search_boost or 3d_tour. */
export type ProductFeature = {
  __typename?: 'ProductFeature'
  category: Scalars['String']
  /** One sentence in the customer's words. */
  customerBenefit: Scalars['String']
  /** What the flag does and where it takes effect. For staff. */
  description: Scalars['String']
  key: Scalars['String']
  name: Scalars['String']
  /** Key of the feature this one depends on, if any. */
  requiresKey?: Maybe<Scalars['String']>
}

export type ProductFeatureInput = {
  category: Scalars['String']
  customerBenefit?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  key: Scalars['String']
  name: Scalars['String']
  requiresKey?: InputMaybe<Scalars['String']>
}

/** Sellable product in the catalogue; grants its features to assigned venues. */
export type ProductPackage = {
  __typename?: 'ProductPackage'
  category: Scalars['String']
  /** What the bundle is for. */
  description: Scalars['String']
  featureKeys: Array<Scalars['String']>
  features: Array<ProductFeature>
  id: Scalars['Int']
  name: Scalars['String']
  status: ProductPackageStatus
}

export type ProductPackageInput = {
  category: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  featureKeys: Array<Scalars['String']>
  name: Scalars['String']
}

export enum ProductPackageStatus {
  Active = 'active',
  Archived = 'archived',
}

export type Proposal = {
  __typename?: 'Proposal'
  ID: Scalars['Int']
  UUID: Scalars['ID']
  attendees: Scalars['Int']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  booking: Booking
  bookingId: Scalars['Int']
  /**
   * Live comments, oldest first. Nullable on purpose: a workspace or auth
   * failure must not null out the whole proposal in the gateway's merged
   * response — the client treats null as "unavailable", not "none".
   */
  comments?: Maybe<Array<ProposalComment>>
  convertedBaseCostTotal: ConvertedBaseCostTotal
  /** Null when the booking has no typed requirements */
  coverage?: Maybe<ProposalCoverage>
  createdAt: Scalars['String']
  createdBy?: Maybe<Scalars['Int']>
  currency: SupportedCurrencyCode
  dateOffers?: Maybe<Array<DateOffer>>
  declinedAt?: Maybe<Scalars['String']>
  declinedBy?: Maybe<Scalars['Int']>
  declinedMessage?: Maybe<Scalars['String']>
  declinedReason?: Maybe<Array<ProposalDeclinedReason>>
  documents?: Maybe<Array<ProposalDocument>>
  event: Event
  eventID: Scalars['Int']
  extraCostItems?: Maybe<Array<ExtraCostItem>>
  fromDateTime: Scalars['String']
  hasPreferredVenue: Scalars['Boolean']
  hostID: Scalars['Int']
  invitation: Invitation
  invitationID: Scalars['Int']
  message?: Maybe<Scalars['String']>
  moreProposalsFromSameBooking?: Maybe<Array<Proposal>>
  /**
   * Structured pricing (ProposalPricing-shaped: model, lines, tax, service
   * charge, total, budgetFit). Null on legacy proposals.
   */
  pricing?: Maybe<Scalars['JSON']>
  proposerId: Scalars['Int']
  /** Read-side detection of legacy template scaffolding and placeholders */
  qualityFlags: Array<Scalars['String']>
  requirementResponses?: Maybe<Array<RequirementResponse>>
  /** Non-null when this proposal was rejected by a request to book and a rollback would restore it */
  rtbRejectedAt?: Maybe<Scalars['String']>
  selectedPhotos: Array<SelectedServiceProviderPhoto>
  sentToGuestAt?: Maybe<Scalars['String']>
  service?: Maybe<ServiceProvider>
  serviceId: Scalars['Int']
  serviceType: ServiceProviderType
  space?: Maybe<SelfServeSpace>
  /** spaceEmissionRate at the point in time that the Proposal was created */
  spaceEmissionRate?: Maybe<Scalars['Float']>
  /** spaceEpcRating at the point in time that the Proposal was created */
  spaceEpcRating?: Maybe<EpcRating>
  /** spaceEpcScore at the point in time that the Proposal was created */
  spaceEpcScore?: Maybe<Scalars['Int']>
  spaceID?: Maybe<Scalars['Int']>
  status: ProposalStatus
  toDateTime: Scalars['String']
  tourCoverUrl?: Maybe<Scalars['String']>
  tourUrl?: Maybe<Scalars['String']>
  venueName?: Maybe<Scalars['String']>
  withdrawn: Scalars['Boolean']
}

export type ProposalConvertedBaseCostTotalArgs = {
  inCompanyCurrency?: InputMaybe<Scalars['Boolean']>
  inEventCurrency?: InputMaybe<Scalars['Boolean']>
  targetCurrency?: InputMaybe<SupportedCurrencyCode>
}

export type ProposalMoreProposalsFromSameBookingArgs = {
  proposalUuid?: InputMaybe<Scalars['ID']>
}

export type ProposalComment = {
  __typename?: 'ProposalComment'
  authorId: Scalars['Int']
  authorName?: Maybe<Scalars['String']>
  /** GUEST = written by the booker's team; STAFF = written from Event HQ. */
  authorRole: ProposalCommentAuthorRole
  body: Scalars['String']
  /** ISO 8601. */
  createdAt: Scalars['String']
  eventUuid: Scalars['String']
  id: Scalars['ID']
  proposalUuid: Scalars['String']
}

export enum ProposalCommentAuthorRole {
  Guest = 'GUEST',
  Staff = 'STAFF',
}

/** How completely this proposal answers the booking's typed requirements */
export type ProposalCoverage = {
  __typename?: 'ProposalCoverage'
  answered: Scalars['Int']
  /** Requirement keys marked MUST that are unanswered or cannotMeet */
  mustUnmet: Array<Scalars['String']>
  total: Scalars['Int']
}

export enum ProposalDeclinedReason {
  BriefChanged = 'BriefChanged',
  Budget = 'Budget',
  DatesAreNotSuitable = 'DatesAreNotSuitable',
  DoesNotMeetRequirements = 'DoesNotMeetRequirements',
  LocationChanged = 'LocationChanged',
}

export type ProposalDocument = {
  __typename?: 'ProposalDocument'
  ID: Scalars['Int']
  URL: Scalars['String']
  filename: Scalars['String']
  s3Key: Scalars['String']
}

export type ProposalDocumentInput = {
  URL?: InputMaybe<Scalars['String']>
  caption?: InputMaybe<Scalars['String']>
  filename: Scalars['String']
  s3Key: Scalars['String']
}

export type ProposalSignedUrlData = {
  __typename?: 'ProposalSignedUrlData'
  URL: Scalars['String']
  s3Key: Scalars['String']
}

export enum ProposalStatus {
  /** @deprecated GATEWAY_EXCLUDED No longer used in biz platform */
  AwaitingDecision = 'AwaitingDecision',
  Created = 'Created',
  Declined = 'Declined',
  Expired = 'Expired',
  Rejected = 'Rejected',
  RequestedToBook = 'RequestedToBook',
  SentToGuest = 'SentToGuest',
}

export type ProposalsFilter = {
  bookingUuid?: InputMaybe<Scalars['String']>
  invitationStatusFilter?: InputMaybe<InvitationFilterDeclined>
  restrictToUser?: InputMaybe<Scalars['Boolean']>
  status?: InputMaybe<ProposalStatus>
}

export type ProposalsForSpacesPage = {
  __typename?: 'ProposalsForSpacesPage'
  rows: Array<Proposal>
  total: Scalars['Int']
}

export type PublishNotificationInput = {
  dedupeKey: Scalars['String']
  kind: NotificationKind
  occurredAt?: InputMaybe<Scalars['DateTime']>
  payload: Scalars['JSON']
  recipient: NotificationRecipientInput
}

export type Query = {
  __typename?: 'Query'
  AdditionalContact: AdditionalContact
  AdditionalContacts: Array<AdditionalContact>
  BBBE_collections: Array<Bbbe_Collection>
  BBBE_spaces: SpaceSearch
  Listing: Listing
  ListingDocument: ListingDocument
  ListingDocuments: Array<ListingDocument>
  ListingImage: ListingImage
  ListingImages: Array<ListingImage>
  Listings: Array<Listing>
  SustainabilityInitiatives: Array<SustainabilityInitiatives>
  _?: Maybe<Scalars['Boolean']>
  /**
   * Ids of the live venues the signed-in user may act on with the capability:
   * venues they own, every venue in a group they own, and a member's venues
   * when they hold the capability. Omit the capability for any seat. For other
   * services scoping host data (e.g. self-serve's confirmed bookings).
   */
  accessibleVenueIds: Array<Scalars['Int']>
  /**
   * What staff have done to this user, newest first, bounded at 50.
   *
   * Scoped through the subject rather than gated on its own: a subject
   * outside the caller's reach yields an EMPTY LIST, not an error, because
   * an error would confirm the account exists.
   */
  adminAudit: Array<AdminAuditEntry>
  /**
   * One user for the detail view. Scoped exactly as the list is: a user
   * outside the caller's reach comes back null rather than forbidden, so
   * the response cannot be used to confirm that an account exists.
   */
  adminUser?: Maybe<AdminUser>
  /**
   * How many users a filter matches. Same staff gate, same country
   * scoping and the same filter semantics as adminUsers.
   *
   * ⚠️ A SEPARATE QUERY RATHER THAN A TOTAL ON AdminUsersPage, and that is
   * the point. The page deliberately reports only whether another one
   * exists, because an exact count re-runs the predicate across the table
   * on every page load and the list exists so a few staff can find one
   * person. A client that actually wants the number asks for it here, when
   * it wants it, and pays for it knowingly.
   *
   * No pagination argument: the count of a page is the page size.
   */
  adminUserCount: Scalars['Int']
  adminUsers: AdminUsersPage
  agentDecisions: Array<AgentDecision>
  agentPanelStatus: AgentPanelStatus
  /** Query for AM Leads list table.  */
  amLeadsPage: LeadsPage
  /** Query for archived leads list table.  */
  archivedLeadsPage: LeadsPage
  /**
   * Regions the CALLER may assign, in display order.
   *
   * Caller-aware on purpose: a GB manager cannot grant APAC, so offering it
   * would be offering a choice the mutation will refuse. Also stops any
   * client hard-coding the set — every hand-maintained copy of a country or
   * region list in this estate has drifted from the data behind it.
   */
  assignableRegions: Array<Scalars['String']>
  /**
   * Roles the CALLER may grant: everything ranked at or below their own,
   * minus guest.
   *
   * Guest is excluded because it is set on every account unconditionally —
   * offering it as a choice implies it means something, and unticking it
   * would produce a user no code path could have created. The server adds it
   * back on every write regardless.
   */
  assignableRoles: Array<Scalars['String']>
  bookerNotes: Array<BookerNote>
  bookerProfile?: Maybe<BookerProfile>
  bookings: Array<Booking>
  bookingsAwaitingVenueConfirmationCount: Scalars['Int']
  /** Query for Brief by ID.  */
  brief: Brief
  /** Query for whether a Brief qualifies for automation.  */
  briefIsAutomatable: BriefIsAutomatableResponse
  collection: Bbbe_Collection
  collections: Array<Collection>
  /**
   * ⚠️ The pagination argument is OPTIONAL and the return type is
   * unchanged, on purpose. hb-companies-mgmt-web consumes this query and
   * fetches the whole list; turning the result into a page object would
   * break it. Omitting the argument therefore behaves exactly as before.
   *
   * There is no hasMore field for the same reason — a caller that wants
   * one asks for limit + 1 and discards the extra, which is the same trick
   * auth-system's admin user list plays server-side.
   */
  companies: Array<Company>
  /**
   * Which of the given venues a company has booked before, with the bookings.
   * Venues with no history are omitted. HeadBox staff (admin / account
   * manager) only. `excludeEventId` leaves the current event out of its own
   * history.
   */
  companyVenueBookings: Array<CompanyVenueBookings>
  /** One confirmed booking, with the same access rules. Null when not visible. */
  confirmedBooking?: Maybe<ConfirmedBooking>
  /**
   * Bookings confirmed at venues, soonest event first. Staff get the venueIDs
   * they pass. Anyone else gets the venues host-listing says they may respond
   * to enquiries at, narrowed to venueIDs when given; venues they can't see
   * are dropped, not refused.
   */
  confirmedBookingsByVenueIDs: Array<ConfirmedBooking>
  contractDocumentDownloadUrl: Scalars['String']
  /** Staff only. Pass accountManagerUserId to scope to one person's accounts. */
  dashboard: Dashboard
  /** Staff only. Of these briefs, the ones a DemandGen venue could have met: within the brief's radius x 1.5 (or its drawn area plus half its equivalent radius), listed for the event type, big enough, DemandGen that day. At most 20,000. */
  demandGenBriefMatches: Array<DemandGenBriefMatch>
  /** HeadBox staff only (VenueHQ). DemandGen (formerly PowerHost) invites and bookings by month; at most 25 months. */
  demandGenReport: DemandGenReport
  /** Staff only. Venues that were DemandGen at some point between from and to (inclusive), with when. */
  demandGenVenues: Array<DemandGenVenue>
  domainInUse?: Maybe<Company>
  emissionsByPeriod: Array<EmissionsByPeriod>
  /** The event's conversation, or null when nobody has written on it yet. Staff only. */
  eventConversation?: Maybe<EventConversation>
  /** A short-lived download link for a message attachment. Staff only. */
  eventConversationAttachmentUrl: EventConversationAttachmentDownload
  /** Who collaborates on the event (shares + pending invites). Staff only. */
  eventPeople: EventPeople
  /**
   * The new, de-facto events query. Additional filters, such as UUID, user and host, in order to
   * replace the legacy getEventByX queries, are still to be added.
   */
  events: Array<Event>
  exchangeRates: Array<ExchangeRate>
  getAllHostsInfo: Array<HostInfo>
  /** @deprecated Use `companies` instead */
  getCompanies: Array<Company>
  getCompany: Company
  /**
   * Which countries a set of regions grants access to — the grant half of
   * the region taxonomy (Application/Model/Regions.ts).
   *
   * This exists so consumers stop keeping their own copy of the mapping.
   * Every hand-maintained list in the estate has drifted from the country
   * data behind it (NZ missing from RedBox's, JP missing here, IT orphaned
   * in self-serve's), and those copies **silently drop** a region name they
   * do not recognise rather than refusing it — which is how a user granted
   * EMEA ended up seeing nothing at all in self-serve's events query.
   *
   * Two behaviours callers depend on:
   *   - Aliases are expanded, so a GB grant contains both GB and UK. The
   *     result is matched against *stored* country values, which may hold
   *     either.
   *   - Implications are applied: GB grants all of EMEA, AU all of APAC.
   *
   * Unrecognised codes are dropped, so a typo grants nothing rather than
   * something that matches nothing.
   */
  getCountriesByRegions: Array<Scalars['String']>
  getEvent: Event
  getEventByUUID: Event
  /** @deprecated Use `events` query instead */
  getEvents?: Maybe<Array<Maybe<Event>>>
  /**
   * Events the signed-in host's spaces were invited to, newest event date first.
   * `offset` and `limit` page the result; pair with `getEventsByHostCount` to
   * know when the last page has been reached.
   */
  getEventsByHost: Array<Event>
  /**
   * Total number of events `getEventsByHost` would return for the same
   * `archived` / `bucket` arguments, ignoring `offset` and `limit`.
   */
  getEventsByHostCount: Scalars['Int']
  getEventsByUser: Array<Event>
  getEventsByUsersTeams?: Maybe<Array<Maybe<Event>>>
  getGuestType: GuestType
  getHostInfo: HostInfo
  getInvitationDeclinedReasons: Array<InvitationDeclinedReason>
  getJwt?: Maybe<Scalars['String']>
  getPreferredVenuesByCompanyID: Array<SelfServeVenue>
  getPreferredVenuesByCompanyIDs: Array<PreferredVenuesByCompany>
  getProposalsByIDs: Array<Proposal>
  getProposalsByUUIDs: Array<Proposal>
  getRegionByCountry: Scalars['String']
  getRegionsByCountries: Array<Scalars['String']>
  getSession?: Maybe<Session>
  getSpaceDocumentSignedInfo?: Maybe<SpaceDocumentSignedInfo>
  getSpaceDocumentUrlFromS3Key?: Maybe<Scalars['String']>
  getSpacePhotoSignedInfo?: Maybe<SpacePhotoSignedInfo>
  getSpacePhotoUrlFromS3Key?: Maybe<Scalars['String']>
  getStyles: Array<Style>
  getSupplierTypes: Array<SupplierType>
  getSuppliers?: Maybe<Array<Supplier>>
  /** Get the Sustainability Initiatives for a Venue. */
  getSustainabilityInitiativesForVenue: Array<SustainabilityInitiative>
  getTeam: CompanyTeam
  /**
   * Requests (space invitations) to these spaces, newest first. HeadBox staff
   * only. from/to filter on when the request was sent. unansweredOnly keeps
   * those with no proposal that the venue hasn't declined.
   */
  invitationsForSpaces: InvitationsForSpacesPage
  /** Query for Leads with status.  */
  leads: Array<Brief>
  /** HeadBox staff or backend calls. Brief-level records for Market Insights, keyset-paged by booking id. */
  marketBriefs: Array<MarketBrief>
  /** Staff only. Whether a venue has the data for a Market Insights report. Fetches the country's briefs, so it takes a few seconds. */
  marketReadiness: MarketReadiness
  /** Staff only. One report with its text and data, for the preview. */
  marketReport: MarketReport
  /** Staff only. A venue's Market Insights reports, newest first. */
  marketReports: Array<MarketReport>
  /** Staff only. Reports waiting for review, and failed ones. */
  marketReportsToReview: Array<MarketReport>
  me?: Maybe<User>
  /** The venues the signed-in user can read Market Insights for: they can see the venue's reports, and it has the package today. */
  myMarketInsightVenues: Array<MarketInsightVenue>
  /** A venue's published Market Insights report: the latest, or the one asked for. Null until one is published. */
  myMarketReport?: Maybe<HostMarketReport>
  myNotifications: Array<Notification>
  myUnseenNotificationCount: Scalars['Int']
  /** Venue groups the signed-in user holds an active seat in. */
  myVenueGroups: Array<VenueGroup>
  /** Which of these user ids are Power Hosts right now. */
  powerHostIds: Array<Scalars['Int']>
  productCategories: Array<ProductCategory>
  productFeatures: Array<ProductFeature>
  productPackages: Array<ProductPackage>
  /** Batch lookup used by the gateway's type merge. Preserves input order; unknown UUIDs return an empty thread. */
  proposalsByUUIDs: Array<Proposal>
  /**
   * Proposals sent from these spaces, newest first. HeadBox staff only.
   * from/to filter on when the proposal was created.
   */
  proposalsForSpaces: ProposalsForSpacesPage
  /** Returns a selection of ranked and filtered spaces according to passed input criteria */
  rankedSpaces: Array<Maybe<RankedSpace>>
  recentBookings: Array<Booking>
  /**
   * Which of these email addresses already have an account (P9).
   *
   * Returns the SUBSET that are taken — no ids, no names, nothing about
   * who they are. The import's question is "will a create succeed", which
   * is global; "who is this person" is scoped, and is a different query.
   * Answering only the first means this needs no reach parameter and
   * reveals nothing that attempting the create would not.
   *
   * Staff only, and capped at 500 addresses per call.
   */
  registeredEmails: Array<Scalars['String']>
  /** One event type's registry resolved for a region; null when the typeKey is unknown or not offered in the region */
  requirementRegistry?: Maybe<RequirementRegistrySchema>
  /** Every registry resolved for a region */
  requirementRegistryAll: Array<RequirementRegistrySchema>
  searchUsers: Array<SearchUser>
  searchUsersByEmail: Array<SearchUser>
  searchUsersByName: Array<SearchUser>
  /**
   * HeadBox staff and backend services only (VenueHQ, the venue group health
   * score). At most 2,000 windows, answered together in a few queries.
   */
  spaceActivities: Array<SpaceActivity>
  spaceById?: Maybe<Space>
  spaceFacilities?: Maybe<Array<Maybe<SpaceFacility>>>
  spaceFacility?: Maybe<SpaceFacility>
  spaces: Array<Space>
  spacesPage?: Maybe<SpacesPage>
  spatialConfigurationTypes?: Maybe<Array<Maybe<Scalars['String']>>>
  ssoProviderForEmail?: Maybe<SsoProvider>
  supportedCurrencies: Array<Currency>
  sustainabilityInitiatives?: Maybe<Array<Maybe<SustainabilityInitiative>>>
  user: User
  userByEmail: User
  userId: Scalars['Int']
  userSpaceById?: Maybe<Space>
  userVenueById?: Maybe<Venue>
  userVenues?: Maybe<Array<Maybe<Venue>>>
  userVenuesByUserIdForAdmin?: Maybe<Array<Maybe<Venue>>>
  users: Array<User>
  venueAssets: Array<VenueAsset>
  venueById?: Maybe<Venue>
  venueCandidate?: Maybe<VenueCandidate>
  venueClaimBookingStatuses: Array<VenueClaimBookingStatus>
  /** Staff, or an owner of the contract's venue group. */
  venueContract?: Maybe<VenueContract>
  /** Staff only. */
  venueContracts: VenueContractsPage
  /** Feature keys a venue is entitled to on a date (default today in its market). */
  venueEntitlements: Array<Scalars['String']>
  /** Same for a batch of venues in one call, e.g. a page of search results. Venues without assignments come back with an empty list. */
  venueEntitlementsForVenues: Array<VenueEntitlements>
  /** Staff, or a member of the venue group. */
  venueGroup?: Maybe<VenueGroup>
  /** Every allocation on the venue group's contracts (staff, or a member). */
  venueGroupAllocations: Array<VenueAllocation>
  /** Staff (all) or an owner (their venue group). */
  venueGroupAuditLog: VenueGroupAuditEntriesPage
  /** Staff see all; an owner of the venue group sees shared notes only. Pinned first, newest first. */
  venueGroupNotes: Array<VenueGroupNote>
  /** Staff only. Paginated, searchable list of venue groups. */
  venueGroups: VenueGroupsPage
  venueLibraryHealth: VenueLibraryHealth
  /**
   * Per-venue booker signals for the Event HQ Recommendations tab. Venues with
   * nothing to show are omitted. Staff only.
   */
  venueSignals: Array<VenueSignals>
  venues?: Maybe<Array<Maybe<Venue>>>
  verifyToken?: Maybe<Scalars['Boolean']>
  versionInformation: VersionInformation
}

export type QueryAdditionalContactArgs = {
  id: Scalars['Int']
}

export type QueryAdditionalContactsArgs = {
  ids: Array<Scalars['Int']>
}

export type QueryBbbe_SpacesArgs = {
  page?: InputMaybe<Scalars['Int']>
  params: SearchParamsInput
}

export type QueryListingArgs = {
  filter: ListingFilter
}

export type QueryListingDocumentArgs = {
  documentId: Scalars['Int']
}

export type QueryListingDocumentsArgs = {
  documentIds: Array<Scalars['Int']>
}

export type QueryListingImageArgs = {
  imageId: Scalars['Int']
}

export type QueryListingImagesArgs = {
  imageIds: Array<Scalars['Int']>
}

export type QueryListingsArgs = {
  filter: ListingFilter
}

export type QueryAccessibleVenueIdsArgs = {
  capability?: InputMaybe<VenueGroupCapability>
}

export type QueryAdminAuditArgs = {
  subjectID: Scalars['Int']
}

export type QueryAdminUserArgs = {
  id: Scalars['Int']
}

export type QueryAdminUserCountArgs = {
  filter?: InputMaybe<AdminUsersFilter>
}

export type QueryAdminUsersArgs = {
  filter?: InputMaybe<AdminUsersFilter>
  pagination?: InputMaybe<AdminUsersPagination>
}

export type QueryAgentDecisionsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  stage?: InputMaybe<Scalars['String']>
}

export type QueryAmLeadsPageArgs = {
  filter: AmLeadsFilter
  number: Scalars['Int']
  size: Scalars['Int']
}

export type QueryArchivedLeadsPageArgs = {
  number: Scalars['Int']
  size: Scalars['Int']
}

export type QueryBookerNotesArgs = {
  bookerId: Scalars['Int']
}

export type QueryBookerProfileArgs = {
  bookerId: Scalars['Int']
}

export type QueryBookingsArgs = {
  filter: BookingsFilter
}

export type QueryBookingsAwaitingVenueConfirmationCountArgs = {
  filter?: InputMaybe<EventsFilter>
}

export type QueryBriefArgs = {
  id: Scalars['ID']
}

export type QueryBriefIsAutomatableArgs = {
  briefParams: BriefAttributes
}

export type QueryCollectionArgs = {
  id: Scalars['String']
}

export type QueryCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilter>
  pagination?: InputMaybe<CompaniesPagination>
}

export type QueryCompanyVenueBookingsArgs = {
  companyId: Scalars['Int']
  excludeEventId?: InputMaybe<Scalars['Int']>
  venueIds: Array<Scalars['Int']>
}

export type QueryConfirmedBookingArgs = {
  uuid: Scalars['ID']
}

export type QueryConfirmedBookingsByVenueIDsArgs = {
  venueIDs?: InputMaybe<Array<Scalars['Int']>>
}

export type QueryContractDocumentDownloadUrlArgs = {
  ID: Scalars['Int']
}

export type QueryDashboardArgs = {
  accountManagerUserId?: InputMaybe<Scalars['Int']>
  market?: InputMaybe<VenueGroupMarket>
}

export type QueryDemandGenBriefMatchesArgs = {
  briefs: Array<DemandGenBriefInput>
}

export type QueryDemandGenReportArgs = {
  input: DemandGenReportInput
}

export type QueryDemandGenVenuesArgs = {
  from: Scalars['Date']
  to: Scalars['Date']
}

export type QueryDomainInUseArgs = {
  country?: InputMaybe<Scalars['String']>
  domain?: InputMaybe<Scalars['String']>
}

export type QueryEmissionsByPeriodArgs = {
  filter?: InputMaybe<EmissionsFilter>
}

export type QueryEventConversationArgs = {
  eventUuid: Scalars['ID']
}

export type QueryEventConversationAttachmentUrlArgs = {
  attachmentId: Scalars['ID']
}

export type QueryEventPeopleArgs = {
  eventUuid: Scalars['ID']
}

export type QueryEventsArgs = {
  filter?: InputMaybe<EventsFilter>
  pagination?: InputMaybe<EventsPagination>
  search?: InputMaybe<Scalars['String']>
}

export type QueryGetAllHostsInfoArgs = {
  args?: InputMaybe<GetAllHostsInfoArgs>
}

export type QueryGetCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilter>
}

export type QueryGetCompanyArgs = {
  ID: Scalars['Int']
}

export type QueryGetCountriesByRegionsArgs = {
  regions: Array<Scalars['String']>
}

export type QueryGetEventArgs = {
  ID: Scalars['Int']
}

export type QueryGetEventByUuidArgs = {
  UUID: Scalars['ID']
}

export type QueryGetEventsArgs = {
  filter?: InputMaybe<EventsFilter>
}

export type QueryGetEventsByHostArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
  bucket?: InputMaybe<EventBucketFilterHost>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type QueryGetEventsByHostCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>
  bucket?: InputMaybe<EventBucketFilterHost>
}

export type QueryGetEventsByUserArgs = {
  active?: InputMaybe<EventActiveArg>
  sort?: InputMaybe<EventSortArg>
}

export type QueryGetGuestTypeArgs = {
  country?: InputMaybe<Scalars['String']>
  email: Scalars['String']
}

export type QueryGetHostInfoArgs = {
  hostID: Scalars['Int']
}

export type QueryGetJwtArgs = {
  token?: InputMaybe<Scalars['String']>
}

export type QueryGetPreferredVenuesByCompanyIdArgs = {
  companyID: Scalars['Int']
}

export type QueryGetPreferredVenuesByCompanyIDsArgs = {
  companyIDs: Array<Scalars['Int']>
}

export type QueryGetProposalsByIDsArgs = {
  IDs: Array<Scalars['Int']>
}

export type QueryGetProposalsByUuiDsArgs = {
  UUIDs: Array<Scalars['ID']>
}

export type QueryGetRegionByCountryArgs = {
  country: Scalars['String']
}

export type QueryGetRegionsByCountriesArgs = {
  countries: Array<Scalars['String']>
}

export type QueryGetSessionArgs = {
  token?: InputMaybe<Scalars['String']>
}

export type QueryGetSpaceDocumentSignedInfoArgs = {
  filename: Scalars['String']
  spaceId: Scalars['Int']
}

export type QueryGetSpaceDocumentUrlFromS3KeyArgs = {
  s3Key: Scalars['String']
}

export type QueryGetSpacePhotoSignedInfoArgs = {
  filename: Scalars['String']
  spaceId: Scalars['Int']
}

export type QueryGetSpacePhotoUrlFromS3KeyArgs = {
  s3Key: Scalars['String']
}

export type QueryGetStylesArgs = {
  filter?: InputMaybe<StylesFiltersInput>
}

export type QueryGetSustainabilityInitiativesForVenueArgs = {
  input: GetSustainabilityInitiativesForVenueInput
}

export type QueryGetTeamArgs = {
  ID: Scalars['Int']
}

export type QueryInvitationsForSpacesArgs = {
  from?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset: Scalars['Int']
  spaceIDs: Array<Scalars['Int']>
  to?: InputMaybe<Scalars['String']>
  unansweredOnly?: InputMaybe<Scalars['Boolean']>
}

export type QueryLeadsArgs = {
  status?: InputMaybe<Scalars['String']>
}

export type QueryMarketBriefsArgs = {
  input: MarketBriefsInput
}

export type QueryMarketReadinessArgs = {
  venueId: Scalars['Int']
}

export type QueryMarketReportArgs = {
  id: Scalars['ID']
}

export type QueryMarketReportsArgs = {
  venueId: Scalars['Int']
}

export type QueryMyMarketReportArgs = {
  id?: InputMaybe<Scalars['ID']>
  venueId: Scalars['Int']
}

export type QueryMyNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  unseenOnly?: InputMaybe<Scalars['Boolean']>
}

export type QueryPowerHostIdsArgs = {
  ids: Array<Scalars['Int']>
}

export type QueryProductPackagesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>
}

export type QueryProposalsByUuiDsArgs = {
  UUIDs: Array<Scalars['ID']>
}

export type QueryProposalsForSpacesArgs = {
  from?: InputMaybe<Scalars['String']>
  limit: Scalars['Int']
  offset: Scalars['Int']
  spaceIDs: Array<Scalars['Int']>
  to?: InputMaybe<Scalars['String']>
}

export type QueryRankedSpacesArgs = {
  input?: InputMaybe<RankedSpacesInput>
}

export type QueryRecentBookingsArgs = {
  pagination?: InputMaybe<BookingsPagination>
}

export type QueryRegisteredEmailsArgs = {
  emails: Array<Scalars['String']>
}

export type QueryRequirementRegistryArgs = {
  region: RequirementRegion
  typeKey: Scalars['String']
}

export type QueryRequirementRegistryAllArgs = {
  region: RequirementRegion
}

export type QuerySearchUsersArgs = {
  contractCountry?: InputMaybe<Scalars['String']>
  email: Scalars['String']
}

export type QuerySearchUsersByEmailArgs = {
  email: Scalars['String']
}

export type QuerySearchUsersByNameArgs = {
  name: Scalars['String']
}

export type QuerySpaceActivitiesArgs = {
  windows: Array<SpaceActivityWindowInput>
}

export type QuerySpaceByIdArgs = {
  id: Scalars['Int']
}

export type QuerySpaceFacilityArgs = {
  id: Scalars['Int']
}

export type QuerySpacesArgs = {
  filter?: InputMaybe<SpaceFiltersInput>
}

export type QuerySpacesPageArgs = {
  filter?: InputMaybe<SpaceFiltersInput>
  page?: InputMaybe<PageInput>
  sort?: InputMaybe<SpaceSortInput>
}

export type QuerySsoProviderForEmailArgs = {
  email: Scalars['String']
}

export type QueryUserArgs = {
  id: Scalars['Int']
}

export type QueryUserByEmailArgs = {
  email: Scalars['String']
}

export type QueryUserSpaceByIdArgs = {
  id: Scalars['Int']
}

export type QueryUserVenueByIdArgs = {
  id: Scalars['Int']
}

export type QueryUserVenuesByUserIdForAdminArgs = {
  userId: Scalars['Int']
}

export type QueryUsersArgs = {
  ids: Array<Scalars['Int']>
}

export type QueryVenueAssetsArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']>
  venueId: Scalars['Int']
}

export type QueryVenueByIdArgs = {
  id: Scalars['Int']
}

export type QueryVenueCandidateArgs = {
  id: Scalars['String']
}

export type QueryVenueClaimBookingStatusesArgs = {
  bookingIds: Array<Scalars['Int']>
}

export type QueryVenueContractArgs = {
  id: Scalars['Int']
}

export type QueryVenueContractsArgs = {
  filter?: InputMaybe<VenueContractFiltersInput>
  page?: InputMaybe<PageInput>
}

export type QueryVenueEntitlementsArgs = {
  on?: InputMaybe<Scalars['Date']>
  venueId: Scalars['Int']
}

export type QueryVenueEntitlementsForVenuesArgs = {
  on?: InputMaybe<Scalars['Date']>
  venueIds: Array<Scalars['Int']>
}

export type QueryVenueGroupArgs = {
  id: Scalars['Int']
}

export type QueryVenueGroupAllocationsArgs = {
  venueGroupId: Scalars['Int']
}

export type QueryVenueGroupAuditLogArgs = {
  page?: InputMaybe<PageInput>
  venueGroupId?: InputMaybe<Scalars['Int']>
}

export type QueryVenueGroupNotesArgs = {
  venueGroupId: Scalars['Int']
}

export type QueryVenueGroupsArgs = {
  filter?: InputMaybe<VenueGroupFiltersInput>
  page?: InputMaybe<PageInput>
  sort?: InputMaybe<VenueGroupSortInput>
}

export type QueryVenueLibraryHealthArgs = {
  venueId: Scalars['Int']
}

export type QueryVenueSignalsArgs = {
  bookerUserId: Scalars['Int']
  companyId: Scalars['Int']
  venueIds: Array<Scalars['Int']>
}

export type QueryVenuesArgs = {
  filter?: InputMaybe<VenueFiltersInput>
}

export type QueryVerifyTokenArgs = {
  token?: InputMaybe<Scalars['String']>
}

export type RankedSpace = {
  __typename?: 'RankedSpace'
  /** The distance between the brief pin and the space in metres */
  distanceToBriefMetres: Scalars['Int']
  /** Details of which rankings were applied and the points assigned or removed by those rankings */
  rankingResult: Array<Maybe<RankedSpacesResult>>
  /** Details of the ranked space */
  space: Space
  /** Cumulative points after all rankings */
  totalPoints: Scalars['Int']
}

/** Capacity filter to use when filtering spaces. */
export type RankedSpacesCapacityFilter = {
  /**
   * The (minimum) attendees that a space must be able to hold, otherwise the space will be filtered out.
   *
   * When 'layoutId' is provided with a valid input that should not be ignored (see the 'layoutId' property), a space will be filtered
   * based on the attendees and the layout ID. If a space does not hold a number of attendees equal or exceeding
   * the input 'attendees' OR that dooes not support the specified layout (based on the input layout ID), it will be filtered out.
   *
   * When 'layoutId' is not provided with a valid input, or is provided with an input that should be ignored, a space will be filtered
   * based on the attendees only. If a space does not hold a number of attendees equal or exceeding the input 'attendees' (in any of its
   * layouts), it will be filtered out.
   */
  attendees: Scalars['Int']
  /**
   * The ID of a layout that a space must have, otherwise the space will be filtered out. If an invalid layout ID is provided,
   * it will be ignored.
   *
   * If a layout ID is not ignored, it is used in combination with 'attendees' (see the property). If a layout ID is
   * ignored, only attendees are used to filter a space.
   */
  layoutId: Scalars['String']
}

/** Filters out any Spaces which cannot host the requested event type(s) */
export type RankedSpacesEventTypeFilter = {
  /** The event type ID that a space must be able to host */
  eventTypeId: Scalars['Int']
  /** True to only return Smart Book spaces */
  smartBookOnly?: InputMaybe<Scalars['Boolean']>
}

export type RankedSpacesFilters = {
  capacity?: InputMaybe<RankedSpacesCapacityFilter>
  eventType?: InputMaybe<RankedSpacesEventTypeFilter>
  location?: InputMaybe<RankedSpacesLocationFilter>
}

/**
 * Input criteria include filters (remove spaces from consideration)
 * and rankings (assign or remove points to/from spaces);
 * after ranking the array is sorted by net ranking points,
 * where points are tied spaces are sorted by distance (closer to brief is higher)
 */
export type RankedSpacesInput = {
  /** Brief latitude and longitude */
  briefLatLon: BriefLatLon
  /** Filters remove spaces, removed spaces are not ranked or sorted. Filters are optional but highly recommended for speed and cost purposes */
  filters?: InputMaybe<RankedSpacesFilters>
  /** The number of spaces to be returned, the highest ranked */
  numberOfResults: Scalars['Int']
  /** Rankings assign or remove points to/from spaces */
  rankings: RankedSpacesRankings
}

/** Filters out any Spaces which are beyond the radius supplied */
export type RankedSpacesLocationFilter = {
  /**
   * Radius from the brief location in metres,
   * any spaces beyond this radius are filtered out
   */
  maximumRadiusMetres: Scalars['Int']
}

export type RankedSpacesRankings = {
  /** Assigns points to a space if it has some facilities matching those that were requested */
  spaceFacilities?: InputMaybe<SpaceFacilitiesRanking>
  /** Assigns points to a space if it is within a specified distance from a location */
  withinRadius?: InputMaybe<WithinRadiusRanking>
}

export type RankedSpacesResult = {
  __typename?: 'RankedSpacesResult'
  /** Additional details of how the points were awarded or subtracted */
  details?: Maybe<Array<Maybe<RankedSpacesResultDetails>>>
  /** Negative points removed by the ranking (note: these are not yet implemented) */
  negativePoints?: Maybe<Scalars['Int']>
  /** Cumulative points after ranking */
  netPoints: Scalars['Int']
  /** Positive points assigned by the ranking */
  positivePoints?: Maybe<Scalars['Int']>
  /** The name of the ranking applied */
  rankingName: Scalars['String']
}

export type RankedSpacesResultDetails = SpaceFacilitiesRankingResultDetails

export enum RebateBasis {
  CommissionableSpend = 'COMMISSIONABLE_SPEND',
  HeadboxCommission = 'HEADBOX_COMMISSION',
}

export type RebateModelRow = {
  __typename?: 'RebateModelRow'
  maxSpend?: Maybe<Scalars['Int']>
  minSpend?: Maybe<Scalars['Int']>
  rebateBasis: RebateBasis
  rebatePercentage?: Maybe<Scalars['Float']>
}

export type RebateModelRowInput = {
  maxSpend?: InputMaybe<Scalars['Int']>
  rebateBasis: RebateBasis
  rebatePercentage?: InputMaybe<Scalars['Float']>
}

export type ReconcileHubSpotInput = {
  /** Optional list of DB company IDs to reconcile. Omit to run for all configured companies. */
  companyIds?: InputMaybe<Array<Scalars['Int']>>
}

export type RemoveUserFromCompanyInput = {
  ID: Scalars['Int']
}

export type RemoveUserFromTeamInput = {
  companyID: Scalars['Int']
  teamID: Scalars['Int']
  userID: Scalars['Int']
}

export type RenameTeamInput = {
  companyID: Scalars['Int']
  name: Scalars['String']
  teamID: Scalars['Int']
}

export type ReqToBookIn = {
  costItems: Array<CostItemQtyIn>
  proposalID: Scalars['Int']
}

export enum RequirementAutoAnswerSource {
  LibraryPackages = 'libraryPackages',
  ListingFacilities = 'listingFacilities',
  SpaceAttributes = 'spaceAttributes',
  SpatialConfigurations = 'spatialConfigurations',
  VenueAddress = 'venueAddress',
}

export type RequirementField = {
  __typename?: 'RequirementField'
  /** Booker-facing question copy, resolved for the requested region */
  askCopy: Scalars['String']
  /** Host-side hook: which held data can auto-answer this requirement */
  autoAnswerSource?: Maybe<RequirementAutoAnswerSource>
  key: Scalars['String']
  kind: RequirementFieldKind
  /** Whether the booker may mark this requirement as a MUST */
  mustCapable: Scalars['Boolean']
  options?: Maybe<Array<RequirementFieldOption>>
  /** Compact label for dense booker views (e.g. Tech, Room set) */
  shortLabel?: Maybe<Scalars['String']>
  /** Why-we-ask microcopy shown beside the question */
  whyCopy?: Maybe<Scalars['String']>
}

export enum RequirementFieldKind {
  Choice = 'choice',
  Counter = 'counter',
  DateOptions = 'dateOptions',
  Money = 'money',
  MultiChoice = 'multiChoice',
  Structured = 'structured',
  Text = 'text',
}

export type RequirementFieldOption = {
  __typename?: 'RequirementFieldOption'
  key: Scalars['String']
  label: Scalars['String']
}

export type RequirementModule = {
  __typename?: 'RequirementModule'
  fields: Array<RequirementField>
  key: Scalars['String']
  /** Multi-part briefs repeat non-spine modules per session */
  repeatsPerSession: Scalars['Boolean']
  /** Spine modules exist for every event type */
  spine: Scalars['Boolean']
  title: Scalars['String']
}

/** A pricing model the composer offers, with region-resolved label and helper copy */
export type RequirementPricingModel = {
  __typename?: 'RequirementPricingModel'
  helper: Scalars['String']
  key: Scalars['String']
  label: Scalars['String']
}

/**
 * The requirement schema registry: versioned JSON owned by this service
 * (registry/ directory), resolved per region at query time. Drives the
 * event-type-specific brief, invite and proposal surfaces.
 */
export enum RequirementRegion {
  Au = 'AU',
  Gb = 'GB',
  Us = 'US',
}

export type RequirementRegistrySchema = {
  __typename?: 'RequirementRegistrySchema'
  /** The pricing model the host composer should default to in this region */
  defaultPricingModel: Scalars['String']
  modules: Array<RequirementModule>
  pricingModels: Array<RequirementPricingModel>
  /** The region this resolution was produced for */
  region: RequirementRegion
  regions: Array<RequirementRegion>
  /** live registries are routed in product; draft ones exist for authoring */
  status: Scalars['String']
  typeKey: Scalars['String']
  version: Scalars['Int']
}

/** A point-by-point answer to one requirement on the booking's typed brief */
export type RequirementResponse = {
  __typename?: 'RequirementResponse'
  /** Set when the answer came from held data rather than the host */
  autoSource?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  requirementKey: Scalars['String']
  status: RequirementResponseStatus
}

export type RequirementResponseIn = {
  autoSource?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  requirementKey: Scalars['String']
  status: RequirementResponseStatus
}

export enum RequirementResponseStatus {
  Alternative = 'alternative',
  AutoConfirmed = 'autoConfirmed',
  CanMeet = 'canMeet',
  CannotMeet = 'cannotMeet',
}

export type ResetPasswordInput = {
  email: Scalars['String']
  password: Scalars['String']
  resetPasswordToken: Scalars['String']
}

export type S3DeletedResponse = {
  __typename?: 'S3DeletedResponse'
  deleted: Scalars['Boolean']
  spaceId: Scalars['Int']
}

export type SaveVenueAllocationsResult = {
  __typename?: 'SaveVenueAllocationsResult'
  conflicts: Array<VenueAllocationConflict>
  /** False when conflicts need confirming; nothing was written. */
  saved: Scalars['Boolean']
  /** Venues whose assignments changed. */
  venueIds: Array<Scalars['Int']>
}

export type SearchParamsInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  budget: Scalars['Int']
  capacities: Scalars['Int']
  catering?: InputMaybe<Array<Scalars['String']>>
  collection?: InputMaybe<Scalars['String']>
  collectionName?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  currency?: InputMaybe<Scalars['String']>
  eventName?: InputMaybe<Scalars['String']>
  facilities?: InputMaybe<Array<Scalars['String']>>
  flexibleDates?: InputMaybe<Scalars['Boolean']>
  fromDate?: InputMaybe<Scalars['String']>
  fromTime?: InputMaybe<Scalars['String']>
  hostId?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['Int']>
  lat: Scalars['String']
  layouts?: InputMaybe<Scalars['String']>
  location: Scalars['String']
  lon: Scalars['String']
  public?: InputMaybe<Scalars['Boolean']>
  radius?: InputMaybe<Scalars['Int']>
  spaceId?: InputMaybe<Scalars['String']>
  toDate?: InputMaybe<Scalars['String']>
  toTime?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['Int']>
}

export type SearchUser = {
  __typename?: 'SearchUser'
  ID: Scalars['Int']
  companyID?: Maybe<Scalars['Int']>
  companyName?: Maybe<Scalars['String']>
  country: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  id: Scalars['Int']
  lastName: Scalars['String']
  regions: Array<Scalars['String']>
  roles: Array<Maybe<Scalars['String']>>
}

export enum SeatingLayout {
  Boardroom = 'boardroom',
  Cabaret = 'cabaret',
  Classroom = 'classroom',
  DinnerRounds = 'dinnerRounds',
  NotSure = 'notSure',
  Seating = 'seating',
  Standing = 'standing',
  Theatre = 'theatre',
  UShaped = 'uShaped',
}

export type SelectedServiceProviderPhoto = {
  __typename?: 'SelectedServiceProviderPhoto'
  id: Scalars['Int']
  url: Scalars['String']
}

export type SelfServeSpace = {
  __typename?: 'SelfServeSpace'
  ID?: Maybe<Scalars['Int']>
  description?: Maybe<Scalars['String']>
  hostContact: HostContact
  isGhost?: Maybe<Scalars['Boolean']>
  spaceDocuments?: Maybe<Array<Maybe<SpaceDocument>>>
  spaceFeatures?: Maybe<Array<SelfServeSpaceFeature>>
  spaceName?: Maybe<Scalars['String']>
  spacePhotos?: Maybe<Array<SelfServeSpacePhoto>>
  spatialConfigurations?: Maybe<Array<SelfServeSpatialConfiguration>>
  tour3dUrl?: Maybe<Scalars['String']>
  user?: Maybe<User>
  venue?: Maybe<SelfServeVenue>
}

export type SelfServeSpaceFeature = {
  __typename?: 'SelfServeSpaceFeature'
  ID?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export type SelfServeSpacePhoto = {
  __typename?: 'SelfServeSpacePhoto'
  id?: Maybe<Scalars['Int']>
  position?: Maybe<Scalars['Int']>
  url?: Maybe<Scalars['String']>
}

export type SelfServeSpatialConfiguration = {
  __typename?: 'SelfServeSpatialConfiguration'
  ID?: Maybe<Scalars['Int']>
  capacity?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export type SelfServeVenue = {
  __typename?: 'SelfServeVenue'
  ID?: Maybe<Scalars['Int']>
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  googlePlaceID?: Maybe<Scalars['String']>
  latitude?: Maybe<Scalars['Float']>
  longitude?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
  nearestTransit?: Maybe<NearestTransit>
  postalCode?: Maybe<Scalars['String']>
}

export type SendEventConversationMessageInput = {
  attachments?: InputMaybe<Array<EventConversationAttachmentInput>>
  /** May be empty when attachments are sent. */
  body: Scalars['String']
  eventUuid: Scalars['ID']
}

export type ServiceProvider = SelfServeSpace | SupplierListing

export enum ServiceProviderType {
  Space = 'space',
  Supplier = 'supplier',
}

export type Session = {
  __typename?: 'Session'
  jwt: Scalars['String']
  refreshToken?: Maybe<Scalars['String']>
  user: User
}

export type SetTeamManagerInput = {
  companyID: Scalars['Int']
  /**
   * Whether this person should run the team from now on.
   *
   * NOT the manager bitmask role, which is company-wide. This is
   * team_users.manager — approves the team's bookings, holds its payment
   * details.
   */
  manager: Scalars['Boolean']
  teamID: Scalars['Int']
  userID: Scalars['Int']
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Space = {
  __typename?: 'Space'
  city: Scalars['String']
  collectionIds?: Maybe<Array<Scalars['Int']>>
  collections: Array<Maybe<Scalars['Int']>>
  coordinates: SpaceCoordinates
  country: Scalars['String']
  dateVenueCreated: Scalars['String']
  deleted?: Maybe<Scalars['Boolean']>
  deletedAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  energyPerformance?: Maybe<SpaceEnergyPerformance>
  floorArea?: Maybe<Scalars['Float']>
  host: Host
  id: Scalars['Int']
  isGhost?: Maybe<Scalars['Boolean']>
  isPrivate?: Maybe<Scalars['Boolean']>
  lastDigitalProposalProposalDate: Scalars['String']
  latitude: Scalars['Float']
  location?: Maybe<Scalars['String']>
  longitude: Scalars['Float']
  map?: Maybe<Array<SpaceMap>>
  maximumSpaceCapacity: Scalars['Int']
  minimumSpaceCapacity: Scalars['Int']
  name: Scalars['String']
  numberOfDigitalProposalsInvites: Scalars['Int']
  numberOfDigitalProposalsProposals: Scalars['Int']
  numberOfSmartBookInvites: Scalars['Int']
  preferredCompanies: Array<Maybe<Scalars['String']>>
  publishedAt?: Maybe<Scalars['DateTime']>
  publishedBy?: Maybe<User>
  publishedById?: Maybe<Scalars['Int']>
  rejectedAt?: Maybe<Scalars['DateTime']>
  rejectedBy?: Maybe<User>
  rejectedById?: Maybe<Scalars['Int']>
  smartBookEventTypes: Array<Maybe<Scalars['Int']>>
  spaceDocuments?: Maybe<Array<SpaceDocument>>
  spaceFacilities: Array<Maybe<SpaceFacility>>
  spaceName?: Maybe<Scalars['String']>
  spacePhotos: Array<SpacePhoto>
  spatialConfigurations?: Maybe<Array<SpatialConfiguration>>
  status?: Maybe<SpaceStatus>
  styleIds: Array<StyleId>
  styles: Array<Maybe<Scalars['Int']>>
  submittedAt?: Maybe<Scalars['DateTime']>
  tour3dUrl?: Maybe<Scalars['String']>
  user?: Maybe<User>
  userId: Scalars['Int']
  venue: Venue
  venueId?: Maybe<Scalars['Int']>
  venueName?: Maybe<Scalars['String']>
}

/**
 * Requests, answers and bookings for one window. The funnel counts
 * (requestsReceived to confirmed) follow the requests received in the window,
 * so each is a subset of the one before. bookingsConfirmed and bookedTotals
 * count every booking that closed at the venues in the window (by the
 * booking's closed date, not when the venue was confirmed), including ones
 * HeadBox booked without the venue's proposal. Booked means closed, with no
 * loss recorded, and not cancelled.
 */
export type SpaceActivity = {
  __typename?: 'SpaceActivity'
  /** Value of bookingsConfirmed per currency; currencies are never added together */
  bookedTotals: Array<SpaceActivityMoney>
  bookingsConfirmed: Scalars['Int']
  /** Booked at one of the venues: closed, no loss recorded, not cancelled */
  confirmed: Scalars['Int']
  from: Scalars['String']
  key: Scalars['String']
  /** Of proposalsSent, those the booker asked to book (not declined or withdrawn) */
  proposalsRequestedToBook: Scalars['Int']
  /** Proposals sent from the spaces in the window, as proposalsForSpaces lists them */
  proposalsSent: Scalars['Int']
  /** The budgets behind requestsReceived (each booking once), per currency */
  requestedBudgets: Array<SpaceActivityMoney>
  /** The booker asked to book (or it was confirmed) */
  requestedToBook: Scalars['Int']
  requestsReceived: Scalars['Int']
  /** Answered with a proposal */
  responded: Scalars['Int']
  to: Scalars['String']
  /** No proposal and not declined: still open, lapsed, or closed */
  unanswered: Scalars['Int']
  /** Monday-start weeks across the window */
  weeks: Array<SpaceActivityWeek>
}

export type SpaceActivityMoney = {
  __typename?: 'SpaceActivityMoney'
  amount: Scalars['Float']
  currency: Scalars['String']
}

export type SpaceActivityWeek = {
  __typename?: 'SpaceActivityWeek'
  /** Bookings that closed that week */
  bookings: Scalars['Int']
  requests: Scalars['Int']
  /** The Monday, YYYY-MM-DD */
  weekStart: Scalars['String']
}

/**
 * A period to report business through HeadBox for: a venue group's spaces
 * (requests and proposals are addressed to spaces) and its venues (bookings
 * are confirmed at venues). Dates are ISO 8601; from is inclusive, to exclusive.
 */
export type SpaceActivityWindowInput = {
  from: Scalars['String']
  /** Return the weekly series (the costly part). Default true; pass false when not charting. */
  includeWeeks?: InputMaybe<Scalars['Boolean']>
  /** The caller's label for this window, echoed back (e.g. a venue group id) */
  key: Scalars['String']
  spaceIDs: Array<Scalars['Int']>
  to: Scalars['String']
  venueIDs: Array<Scalars['Int']>
}

export type SpaceCoordinates = {
  __typename?: 'SpaceCoordinates'
  lat: Scalars['Float']
  lng: Scalars['Float']
}

/** A document for a space, such as a floorplan. This type is shared across applications. */
export type SpaceDocument = {
  __typename?: 'SpaceDocument'
  caption?: Maybe<Scalars['String']>
  /** @deprecated SpaceDocumentType is deprecated. Use 'SpaceDocumentTag' instead. */
  documentType?: Maybe<SpaceDocumentType>
  filename?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  position?: Maybe<Scalars['Int']>
  s3Key?: Maybe<Scalars['String']>
  tag?: Maybe<SpaceDocumentTag>
  url?: Maybe<Scalars['String']>
}

export type SpaceDocumentInput = {
  caption?: InputMaybe<Scalars['String']>
  documentType?: InputMaybe<SpaceDocumentType>
  filename: Scalars['String']
  s3Key: Scalars['String']
  tag?: InputMaybe<SpaceDocumentTag>
}

export type SpaceDocumentSignedInfo = {
  __typename?: 'SpaceDocumentSignedInfo'
  s3Key?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

/**
 * A tag for a space document that defines the specific HeadBox "type" of a document, for example a floorplan.
 * This enum is shared across applications.
 */
export enum SpaceDocumentTag {
  Floorplan = 'FLOORPLAN',
  Menu = 'MENU',
  Specifications = 'SPECIFICATIONS',
  SustainabilityDocumentation = 'SUSTAINABILITY_DOCUMENTATION',
}

/**
 * DEPRECATED
 * The type of the document.
 * This enum is shared across applications.
 */
export enum SpaceDocumentType {
  Facilities = 'facilities',
  FloorPlans = 'floor_plans',
  Generic = 'generic',
  Menu = 'menu',
  TermsAndConditions = 'terms_and_conditions',
}

/**
 * Warning!!!
 *
 * This can seriously slow down queries for large numbers of spaces.
 *
 * It has been limited and will throw an error on querys for more than 200 spaces.
 */
export type SpaceEnergyPerformance = {
  __typename?: 'SpaceEnergyPerformance'
  /** kg of CO2 per hour */
  emissionRate?: Maybe<Scalars['Float']>
  rating?: Maybe<Scalars['String']>
  score?: Maybe<Scalars['Int']>
}

export type SpaceFacilitiesRanking = {
  /** Number of positive points to be assigned if a space has a matching facility */
  positivePoints: Scalars['Int']
  /** Space facility IDs to be ranked */
  spaceFacilityIds: Array<Scalars['Int']>
}

export type SpaceFacilitiesRankingResultDetails = {
  __typename?: 'SpaceFacilitiesRankingResultDetails'
  /** Number of positive points awarded as a result of matching */
  positivePoints: Scalars['Int']
  /** Space facility which matched */
  spaceFacility: SpaceFacility
}

/** Full type merged into the schema in the gateway */
export type SpaceFacility = {
  __typename?: 'SpaceFacility'
  facilityCategory?: Maybe<FacilityCategory>
  facilityCategoryId?: Maybe<Scalars['Int']>
  icon?: Maybe<Scalars['String']>
  id: Scalars['Int']
  name: Scalars['String']
  position?: Maybe<Scalars['Int']>
}

export type SpaceFeature = {
  __typename?: 'SpaceFeature'
  featureCategory?: Maybe<FeatureCategory>
  featureCategoryId?: Maybe<Scalars['Int']>
  icon?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
  position?: Maybe<Scalars['Int']>
}

export type SpaceFiltersInput = {
  collectionIds?: InputMaybe<Array<Scalars['Int']>>
  countries?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  deleted?: InputMaybe<Scalars['Boolean']>
  geolocation?: InputMaybe<GeolocationFilterInput>
  ids?: InputMaybe<Array<Scalars['Int']>>
  isPrivate?: InputMaybe<Scalars['Boolean']>
  published?: InputMaybe<Scalars['Boolean']>
  rejected?: InputMaybe<Scalars['Boolean']>
  searchTerms?: InputMaybe<Scalars['String']>
  submitted?: InputMaybe<Scalars['Boolean']>
  userId?: InputMaybe<Scalars['Int']>
  userIds?: InputMaybe<Array<Scalars['Int']>>
}

export type SpaceMap = {
  __typename?: 'SpaceMap'
  coordinates: SpaceCoordinates
  id: Scalars['ID']
  location?: Maybe<Scalars['String']>
  onPage: Scalars['Boolean']
}

export type SpacePhoto = {
  __typename?: 'SpacePhoto'
  detail: Scalars['String']
  eventTypeTags: Array<Collection>
  filename?: Maybe<Scalars['String']>
  filenameProcessing?: Maybe<Scalars['Boolean']>
  id: Scalars['ID']
  layoutTagKeys: Array<Scalars['String']>
  listings: Scalars['String']
  position: Scalars['Int']
  s3Key?: Maybe<Scalars['String']>
  squareThumb: Scalars['String']
  thumb: Scalars['String']
  url: Scalars['String']
}

export type SpacePhotoInput = {
  eventTypeTagIds: Array<Scalars['Int']>
  filename: Scalars['String']
  layoutTagKeys: Array<Scalars['String']>
  s3Key: Scalars['String']
}

export type SpacePhotoSignedInfo = {
  __typename?: 'SpacePhotoSignedInfo'
  s3Key?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type SpaceSearch = {
  __typename?: 'SpaceSearch'
  listView: Array<Space>
  mapView: Array<SpaceMap>
}

export enum SpaceSortField {
  Id = 'id',
  PublishedAt = 'publishedAt',
  RejectedAt = 'rejectedAt',
  SubmittedAt = 'submittedAt',
}

export type SpaceSortInput = {
  direction: SortDirection
  field: SpaceSortField
}

export type SpaceSpatialConfigurationInput = {
  capacity: Scalars['Int']
  name: Scalars['String']
}

export enum SpaceStatus {
  Complete = 'complete',
  Overview = 'overview',
  Published = 'published',
  Reviewed = 'reviewed',
  UnderReview = 'under_review',
}

export type SpaceSummaryInput = {
  description: Scalars['String']
  floorArea?: InputMaybe<Scalars['Float']>
  name: Scalars['String']
}

export type SpacesPage = {
  __typename?: 'SpacesPage'
  page?: Maybe<Page>
  rows?: Maybe<Array<Space>>
  totalPages?: Maybe<Scalars['Int']>
  totalRows?: Maybe<Scalars['Int']>
}

export type SpatialConfiguration = {
  __typename?: 'SpatialConfiguration'
  capacity?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export type SsoLoginStart = {
  __typename?: 'SsoLoginStart'
  authorizeUrl: Scalars['String']
}

export type SsoProvider = {
  __typename?: 'SsoProvider'
  displayName: Scalars['String']
  key: Scalars['String']
}

export type SsoSession = {
  __typename?: 'SsoSession'
  /**
   * The redirect_to the login page handed to beginSsoLogin, returned only
   * if its hostname is headbox.com or a subdomain.
   */
  redirectTo?: Maybe<Scalars['String']>
  session: Session
}

/**
 * A HeadBox-internal note on a venue. Venue-scoped: follows the venue across
 * every client. Never surfaced to bookers.
 */
export type StaffVenueNote = {
  __typename?: 'StaffVenueNote'
  authorName?: Maybe<Scalars['String']>
  authorUserId: Scalars['Int']
  body: Scalars['String']
  /** ISO 8601. */
  createdAt: Scalars['String']
  id: Scalars['ID']
  /** The caller wrote it, so may edit or delete it. */
  mine: Scalars['Boolean']
  /** ISO 8601; equals createdAt until edited. */
  updatedAt: Scalars['String']
  venueId: Scalars['Int']
}

/** Full type merged into the schema in the gateway */
export type Style = {
  __typename?: 'Style'
  emoji?: Maybe<Scalars['String']>
  id: Scalars['String']
  label?: Maybe<Scalars['String']>
}

export enum StyleId {
  BlankCanvas = 'blank_canvas',
  Casual = 'casual',
  Formal = 'formal',
  Fun = 'fun',
  Industrial = 'industrial',
  Lively = 'lively',
  Luxury = 'luxury',
  Modern = 'modern',
  Professional = 'professional',
  Quiet = 'quiet',
  Quirky = 'quirky',
  Simple = 'simple',
  Social = 'social',
  Traditional = 'traditional',
}

export type StylesFiltersInput = {
  id?: InputMaybe<StyleId>
  ids?: InputMaybe<Array<InputMaybe<StyleId>>>
}

export type Supplier = {
  __typename?: 'Supplier'
  ID: Scalars['Int']
  email: Scalars['String']
  name: Scalars['String']
  type: SupplierType
}

export type SupplierDeal = {
  __typename?: 'SupplierDeal'
  ID: Scalars['Int']
  attachments?: Maybe<Array<SupplierDealAttachment>>
  cost?: Maybe<Scalars['Int']>
  createdAt: Scalars['String']
  currency: Scalars['String']
  event: Event
  message?: Maybe<Scalars['String']>
  supplier: Supplier
  updatedAt: Scalars['String']
}

export type SupplierDealAttachment = {
  __typename?: 'SupplierDealAttachment'
  ID: Scalars['Int']
  URL: Scalars['String']
  caption?: Maybe<Scalars['String']>
  filename: Scalars['String']
  s3Key: Scalars['String']
}

export type SupplierDealAttachmentSignedUrlData = {
  __typename?: 'SupplierDealAttachmentSignedUrlData'
  URL: Scalars['String']
  s3Key: Scalars['String']
}

export type SupplierListing = {
  __typename?: 'SupplierListing'
  additionalContacts?: Maybe<Array<Maybe<AdditionalContact>>>
  address: Scalars['String']
  commissionDetails?: Maybe<Scalars['String']>
  country: Scalars['String']
  description?: Maybe<Scalars['String']>
  id: Scalars['Int']
  latitude: Scalars['Float']
  listingDocuments: Array<ListingDocument>
  listingImages: Array<ListingImage>
  longitude: Scalars['Float']
  maxEventCapacity: Scalars['Int']
  name: Scalars['String']
  serviceArea: Scalars['Int']
  supplierType: SupplierType
  sustainabilityIds: Array<Scalars['Int']>
  user?: Maybe<User>
  websiteUrl: Scalars['String']
}

export enum SupplierType {
  /** @deprecated Move to Event type */
  Accommodation = 'Accommodation',
  Activity = 'Activity',
  AdditionalSpend = 'AdditionalSpend',
  /** @deprecated Use 'AdditionalSpend'. */
  AdditionalSpent = 'AdditionalSpent',
  AudioVisual = 'AudioVisual',
  Branding = 'Branding',
  Catering = 'Catering',
  CorporateGifting = 'CorporateGifting',
  Entertainment = 'Entertainment',
  EventManagement = 'EventManagement',
  EventStaff = 'EventStaff',
  Florist = 'Florist',
  Furniture = 'Furniture',
  Merchandise = 'Merchandise',
  Photographers = 'Photographers',
  Props = 'Props',
  Sustainability = 'Sustainability',
  Travel = 'Travel',
  Venue = 'venue',
}

/** The order of these enums are important, please ensure correct order when adding new currency */
export enum SupportedCurrencyCode {
  Aud = 'AUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Idr = 'IDR',
  Jpy = 'JPY',
  Nzd = 'NZD',
  Php = 'PHP',
  Sgd = 'SGD',
  Thb = 'THB',
  Usd = 'USD',
}

export type SustainabilityInitiative = {
  __typename?: 'SustainabilityInitiative'
  category: Scalars['String']
  id: Scalars['Int']
  label: Scalars['String']
}

export enum SustainabilityInitiativeCategory {
  Catering = 'CATERING',
  DiversityAndInclusion = 'DIVERSITY_AND_INCLUSION',
  Energy = 'ENERGY',
  PoliciesAndCredentials = 'POLICIES_AND_CREDENTIALS',
  Purchasing = 'PURCHASING',
  Travel = 'TRAVEL',
  WasteAndRecycling = 'WASTE_AND_RECYCLING',
  Water = 'WATER',
}

export type SustainabilityInitiatives = {
  __typename?: 'SustainabilityInitiatives'
  category: Scalars['String']
  initiatives: Array<SustainabilityInitiative>
}

export type Team = {
  __typename?: 'Team'
  ID: Scalars['Int']
  id: Scalars['Int']
  name: Scalars['String']
}

/** One person's membership of one team. */
export type TeamMember = {
  __typename?: 'TeamMember'
  /**
   * Runs this team — approves its bookings, holds its payment details.
   *
   * ⚠️ NOT the manager bitmask role, which is company-wide. Somebody can be
   * a business member across the company and the manager of one team, or a
   * business manager who runs no team at all. Neither implies the other.
   *
   * The underlying column is nullable and NULL means false; that is
   * flattened here so a row RedBox wrote years ago does not fail a
   * non-nullable field.
   */
  manager: Scalars['Boolean']
  user: User
}

/** One person to put in a team. */
export type TeamMemberInput = {
  /**
   * Runs the team — approves its bookings and holds its payment details.
   *
   * NOT the manager bitmask role, which is company-wide. Somebody can be a
   * business member across the company and the manager of one team. The two
   * are set independently and neither implies the other.
   */
  manager: Scalars['Boolean']
  userID: Scalars['Int']
}

/**
 * What happened to one row of an addUsersToTeam call.
 *
 * Per user rather than a single boolean because this serves a bulk import: a
 * run where three of fifty were already in the team is a normal outcome that
 * an operator needs itemised, not an error.
 */
export type TeamMembershipResult = {
  __typename?: 'TeamMembershipResult'
  added: Scalars['Boolean']
  /** Why not, when added is false. Null on success. */
  reason?: Maybe<Scalars['String']>
  userID: Scalars['Int']
}

export type TransferHostProposalsResult = {
  __typename?: 'TransferHostProposalsResult'
  proposals: Scalars['Int']
}

export type TriggerMagicLinkInput = {
  email: Scalars['String']
}

export type TriggerPasswordResetInput = {
  email: Scalars['String']
}

export type UpdateBookerNoteInput = {
  category?: InputMaybe<BookerNoteCategory>
  note: Scalars['String']
  noteId: Scalars['Int']
}

export type UpdateBookingInput = {
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees?: InputMaybe<Scalars['Int']>
  bookingFolderId?: InputMaybe<Scalars['Int']>
  bookingRequestedAt?: InputMaybe<Scalars['String']>
  bookingRequestedBy?: InputMaybe<Scalars['Int']>
  budget?: InputMaybe<Scalars['Int']>
  cateringNeeds?: InputMaybe<Scalars['String']>
  closedAmount?: InputMaybe<Scalars['Int']>
  closedAmountCompanyCurrency?: InputMaybe<Scalars['Int']>
  closedAmountExTax?: InputMaybe<Scalars['Int']>
  closedAt?: InputMaybe<Scalars['String']>
  commissionPercentage?: InputMaybe<Scalars['Float']>
  commissionableAmount?: InputMaybe<Scalars['Int']>
  completedAt?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  currency?: InputMaybe<Scalars['String']>
  decisionDate?: InputMaybe<Scalars['String']>
  eventTypeId?: InputMaybe<Scalars['Int']>
  fastTrackSupplierEmail?: InputMaybe<Scalars['String']>
  fastTrackSupplierName?: InputMaybe<Scalars['String']>
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDateTime?: InputMaybe<Scalars['String']>
  fxRate?: InputMaybe<Scalars['Float']>
  hubspotID?: InputMaybe<Scalars['String']>
  id: Scalars['Int']
  isAdditionalSpendBooking?: InputMaybe<Scalars['Boolean']>
  isCommisionable?: InputMaybe<Scalars['Boolean']>
  isFlexibleWithDates?: InputMaybe<Scalars['Boolean']>
  lat?: InputMaybe<Scalars['Float']>
  layoutId?: InputMaybe<Scalars['String']>
  lifecycleStage?: InputMaybe<LifecycleStage>
  location?: InputMaybe<Scalars['String']>
  locationPolygon?: InputMaybe<Scalars['String']>
  lon?: InputMaybe<Scalars['Float']>
  lostAt?: InputMaybe<Scalars['String']>
  lostReason?: InputMaybe<Scalars['String']>
  marketPrice?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  parentBookingId?: InputMaybe<Scalars['Int']>
  paymentsInvoiceReference?: InputMaybe<Scalars['String']>
  positionIndex?: InputMaybe<Scalars['Int']>
  processingFeePercentage?: InputMaybe<Scalars['Float']>
  radius?: InputMaybe<Scalars['Float']>
  releaseReason?: InputMaybe<EventReleaseReason>
  requestedToBookAt?: InputMaybe<Scalars['String']>
  requirements?: InputMaybe<Scalars['JSON']>
  solutionsInvoiceReference?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIds?: InputMaybe<Array<Scalars['Int']>>
  styleIds?: InputMaybe<Array<Scalars['String']>>
  submittedBy?: InputMaybe<Scalars['Int']>
  supplierType?: InputMaybe<Scalars['String']>
  takeOver?: InputMaybe<Scalars['Boolean']>
  takeOverFee?: InputMaybe<Scalars['Int']>
  takeOverFeePercentage?: InputMaybe<Scalars['Float']>
  toDateTime?: InputMaybe<Scalars['String']>
}

export type UpdateBookingsFolderInput = {
  budget?: InputMaybe<Scalars['Int']>
  eventTypeId?: InputMaybe<Scalars['Int']>
  id: Scalars['Int']
  name?: InputMaybe<Scalars['String']>
  notes?: InputMaybe<Scalars['String']>
  parentFolderId?: InputMaybe<Scalars['Int']>
  position?: InputMaybe<Scalars['Int']>
}

export type UpdateEventInput = {
  UUID: Scalars['ID']
  actualEventMgmtFee?: InputMaybe<Scalars['Int']>
  additionalNotes?: InputMaybe<Scalars['String']>
  attendees: Scalars['Int']
  /** EventHQ qualification: typed, spine complete, no unconfirmed AI guesses */
  automatedInvitationsQualified?: InputMaybe<Scalars['Boolean']>
  budget: Scalars['Int']
  cateringNeeds?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  currency: Scalars['String']
  decisionDate?: InputMaybe<Scalars['String']>
  estimatedEventMgmtFee?: InputMaybe<Scalars['Int']>
  eventTypeID: Scalars['Int']
  flexibleDatesNote?: InputMaybe<Scalars['String']>
  fromDateTime: Scalars['String']
  isFlexibleWithDates?: InputMaybe<Scalars['Boolean']>
  lat: Scalars['String']
  layoutID: Scalars['String']
  location: Scalars['String']
  locationPolygon?: InputMaybe<Scalars['String']>
  lon: Scalars['String']
  name: Scalars['String']
  ownerId?: InputMaybe<Scalars['Int']>
  radius?: InputMaybe<Scalars['String']>
  requirements?: InputMaybe<Scalars['JSON']>
  source?: InputMaybe<Scalars['String']>
  spaceFacilityIDs: Array<Scalars['Int']>
  styleIDs?: InputMaybe<Array<Scalars['String']>>
  team?: InputMaybe<Scalars['Int']>
  toDateTime: Scalars['String']
}

export type UpdateEventNoteInput = {
  note: Scalars['String']
  noteId: Scalars['Int']
}

export type UpdateEventOrBookingFromHubSpotInput = {
  country: Scalars['String']
  hubspotID: Scalars['String']
}

export type UpdateHostArgs = {
  addEventTypeIDs: Array<Scalars['Int']>
  hostID: Scalars['Int']
  removeEventTypeIDs: Array<Scalars['Int']>
}

export type UpdateListingInput = {
  address?: InputMaybe<Scalars['String']>
  commissionDetails?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  existingAdditionalContacts?: InputMaybe<Array<AdditionalContactUpdateInput>>
  latitude?: InputMaybe<Scalars['Float']>
  longitude?: InputMaybe<Scalars['Float']>
  maxEventCapacity?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  newAdditionalContacts?: InputMaybe<Array<AdditionalContactInput>>
  serviceArea?: InputMaybe<Scalars['Int']>
  supplierType?: InputMaybe<ListingSupplierType>
  sustainabilityIds?: InputMaybe<Array<Scalars['Int']>>
  websiteUrl?: InputMaybe<Scalars['String']>
}

export type UpdateProductCategoryInput = {
  name: Scalars['String']
  position?: InputMaybe<Scalars['Int']>
}

export type UpdateProductFeatureInput = {
  customerBenefit?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  name: Scalars['String']
  requiresKey?: InputMaybe<Scalars['String']>
}

export type UpdateProposalBaseDetailsInput = {
  UUID: Scalars['ID']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  currency: Scalars['String']
  documentFilePaths?: InputMaybe<Array<Scalars['String']>>
  message?: InputMaybe<Scalars['String']>
  selectedPhotos?: InputMaybe<Array<Scalars['Int']>>
}

export type UpdateProposalInput = {
  UUID: Scalars['ID']
  attendees: Scalars['Int']
  baseCostDescription: Scalars['String']
  baseCostTotal: Scalars['Int']
  currency: Scalars['String']
  documentFilePaths?: InputMaybe<Array<Scalars['String']>>
  documents?: InputMaybe<Array<ProposalDocumentInput>>
  extraCostItems?: InputMaybe<Array<ExtraCostItemInput>>
  fromDateTime: Scalars['String']
  message?: InputMaybe<Scalars['String']>
  selectedPhotos?: InputMaybe<Array<Scalars['Int']>>
  toDateTime: Scalars['String']
}

export type UpdateStaffVenueNoteInput = {
  body: Scalars['String']
  id: Scalars['ID']
}

export type UpdateSupplierDealInput = {
  ID: Scalars['Int']
  attachmentFilePaths?: InputMaybe<Array<Scalars['String']>>
  cost?: InputMaybe<Scalars['Int']>
  currency?: InputMaybe<Scalars['String']>
  message?: InputMaybe<Scalars['String']>
  supplierID?: InputMaybe<Scalars['Int']>
}

export type UpdateSupplierInput = {
  ID: Scalars['Int']
  email?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  type?: InputMaybe<SupplierType>
}

export type UpdateUserInput = {
  country?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  /**
   * Every field below is optional and only written when present. Omitting a
   * field leaves it alone; sending null clears it. Those are different.
   */
  firstName?: InputMaybe<Scalars['String']>
  jobTitle?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  /**
   * Marketing EMAIL opt-in, written across every consent_* notification
   * preference the account has. Omit it and the current consent is left
   * exactly as it stands — only a present value is acted on.
   *
   * ⚠️ Writes the email column and nothing else. The txt consent on those
   * same rows is a separate permission this screen never asks about, and
   * rows created here to hold a new opt-in are created with txt withheld.
   */
  marketingEmailConsent?: InputMaybe<Scalars['Boolean']>
  phoneNumber?: InputMaybe<Scalars['String']>
  /**
   * Regions, replacing the current set. You may not grant reach you do not
   * have yourself, so a manager can only assign regions inside their own.
   */
  regions?: InputMaybe<Array<Scalars['String']>>
  /**
   * Role NAMES, replacing the current set. You may not grant a role ranked
   * above your own — see Application/Model/Roles.ts. The guest bit is added
   * back regardless: every account in the estate carries it.
   */
  roles?: InputMaybe<Array<Scalars['String']>>
  userID: Scalars['Int']
}

export type UpdateUserStatusInput = {
  ID: Scalars['Int']
  status: CompanyUserStatus
}

export type UpdateVenueContractInput = {
  /** Active contracts: date changed lines take effect; the old line ends the day before. Default today. */
  applyFrom?: InputMaybe<Scalars['Date']>
  currency?: InputMaybe<Scalars['String']>
  ends?: InputMaybe<Scalars['Date']>
  internalNotes?: InputMaybe<Scalars['String']>
  /** The full desired set of lines; omitted lines are removed (or end-dated on an active contract). */
  lines?: InputMaybe<Array<VenueContractLineInput>>
  /** Draft contracts only. */
  market?: InputMaybe<VenueGroupMarket>
  reference?: InputMaybe<Scalars['String']>
  /** Draft contracts only. */
  starts?: InputMaybe<Scalars['Date']>
  /** draft → active, or active → cancelled. */
  status?: InputMaybe<VenueContractStatus>
  /** Value of the whole term. Null clears it. */
  totalValue?: InputMaybe<Scalars['Float']>
}

export type UpdateVenueGroupInput = {
  accountManagerUserId?: InputMaybe<Scalars['Int']>
  markets?: InputMaybe<Array<VenueGroupMarket>>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateVenueGroupMemberInput = {
  /** Set true to clear an explicit venue list (all venues). */
  allVenues?: InputMaybe<Scalars['Boolean']>
  capabilities?: InputMaybe<Array<VenueGroupCapability>>
  role?: InputMaybe<VenueGroupMembershipRole>
  venueIds?: InputMaybe<Array<Scalars['Int']>>
}

export type UpdateVenueGroupNoteInput = {
  body?: InputMaybe<Scalars['String']>
  notifyOwners?: InputMaybe<Scalars['Boolean']>
  pinned?: InputMaybe<Scalars['Boolean']>
  title?: InputMaybe<Scalars['String']>
  visibility?: InputMaybe<VenueGroupNoteVisibility>
}

export type UploadedDocumentResponse = {
  __typename?: 'UploadedDocumentResponse'
  s3Url: Scalars['String']
}

export type UploadedImageResponse = {
  __typename?: 'UploadedImageResponse'
  s3Url: Scalars['String']
}

export type User = {
  __typename?: 'User'
  ID: Scalars['Int']
  avatar?: Maybe<Scalars['String']>
  avatars: Avatars
  company?: Maybe<Company>
  companyCountry?: Maybe<Scalars['String']>
  companyID?: Maybe<Scalars['Int']>
  companyId: Scalars['Int']
  companyLogo?: Maybe<Scalars['String']>
  companyLogoUrl?: Maybe<Scalars['String']>
  companyName?: Maybe<Scalars['String']>
  consentedToTwilioTermsAndCondition: Scalars['Boolean']
  contactNumber?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  countryPermissions: Array<Maybe<Scalars['String']>>
  currency: Scalars['String']
  email: Scalars['String']
  firstName: Scalars['String']
  /**
   * Indicates if the user has validated their phone number.
   * Parameter `phoneNumber` is optional and can be used to check validation for a specific number.
   * If not provided, it checks the user's `contactNumber`.
   */
  hasValidatedPhoneNumber: Scalars['Boolean']
  id: Scalars['Int']
  isDirectEnquiryEnabled: Scalars['Boolean']
  isPowerHost: Scalars['Boolean']
  jobTitle?: Maybe<Scalars['String']>
  lastName: Scalars['String']
  mobileNumber?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  regions: Array<Scalars['String']>
  roles: Array<Scalars['String']>
  teams?: Maybe<Array<UserTeam>>
  twilioConsentUUID?: Maybe<Scalars['String']>
  widgetBacklinkMandatory?: Maybe<Scalars['Boolean']>
}

export type UserHasValidatedPhoneNumberArgs = {
  phoneNumber?: InputMaybe<Scalars['String']>
}

export type UserTeam = {
  __typename?: 'UserTeam'
  id: Scalars['Int']
  name: Scalars['String']
}

export type Venue = {
  __typename?: 'Venue'
  /** Paid features live today (union of the assigned packages' features), computed on read. */
  activeFeatureKeys?: Maybe<Array<Scalars['String']>>
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  country: Scalars['String']
  deleted?: Maybe<Scalars['Boolean']>
  deletedAt?: Maybe<Scalars['DateTime']>
  googleAddress?: Maybe<GoogleAddress>
  googleOpeningHours?: Maybe<Array<Maybe<Scalars['String']>>>
  googlePlaceID?: Maybe<Scalars['String']>
  googleRating?: Maybe<Scalars['Float']>
  googleReviewsEnabled?: Maybe<Scalars['Boolean']>
  googleTotalRatings?: Maybe<Scalars['Int']>
  hasPublishedSpaces?: Maybe<Scalars['Boolean']>
  id: Scalars['Int']
  lastResearchDate?: Maybe<Scalars['DateTime']>
  latitude?: Maybe<Scalars['Float']>
  leadFeedEnabled: Scalars['Boolean']
  longDesc?: Maybe<Scalars['String']>
  longitude?: Maybe<Scalars['Float']>
  /** Derived from country; null when the country maps to no HeadBox market. */
  market?: Maybe<VenueGroupMarket>
  name: Scalars['String']
  postalCode?: Maybe<Scalars['String']>
  region?: Maybe<Scalars['String']>
  researchData?: Maybe<Scalars['String']>
  shortDesc?: Maybe<Scalars['String']>
  spaces?: Maybe<Array<Space>>
  state?: Maybe<Scalars['String']>
  sustainabilityInitiativeIds?: Maybe<Array<Scalars['Int']>>
  sustainabilityInitiatives?: Maybe<Array<SustainabilityInitiative>>
  totalFloorArea?: Maybe<Scalars['Float']>
  user?: Maybe<User>
  userId: Scalars['Int']
  vectorData?: Maybe<Scalars['String']>
  venueGroup?: Maybe<VenueGroup>
  venueGroupId?: Maybe<Scalars['Int']>
}

/** A venue holding a purchased package for a date range (customer-facing: assigned to). */
export type VenueAllocation = {
  __typename?: 'VenueAllocation'
  effectiveFrom: Scalars['Date']
  /** Inclusive; null = open. */
  effectiveTo?: Maybe<Scalars['Date']>
  id: Scalars['Int']
  lineId: Scalars['Int']
  venue?: Maybe<Venue>
  venueId: Scalars['Int']
}

export enum VenueAllocationAction {
  Assign = 'assign',
  Unassign = 'unassign',
}

export type VenueAllocationChangeInput = {
  action: VenueAllocationAction
  lineId: Scalars['Int']
  /** Confirms end-dating any same-category package the venue already holds. */
  replace?: InputMaybe<Scalars['Boolean']>
  venueId: Scalars['Int']
}

/** A same-category clash that needs confirmation (replace: true) before saving. */
export type VenueAllocationConflict = {
  __typename?: 'VenueAllocationConflict'
  conflictingAllocationId: Scalars['Int']
  conflictingLineId: Scalars['Int']
  conflictingPackageName: Scalars['String']
  lineId: Scalars['Int']
  venueId: Scalars['Int']
}

export type VenueAsset = {
  __typename?: 'VenueAsset'
  archivedAt?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  fileRef?: Maybe<Scalars['String']>
  fileUrl?: Maybe<Scalars['String']>
  id: Scalars['Int']
  kind: VenueAssetKind
  spaceScope?: Maybe<Array<Scalars['Int']>>
  structured?: Maybe<Scalars['JSON']>
  title: Scalars['String']
  updatedAt: Scalars['String']
  validFrom?: Maybe<Scalars['String']>
  validUntil?: Maybe<Scalars['String']>
  venueId: Scalars['Int']
}

export type VenueAssetIn = {
  fileRef?: InputMaybe<Scalars['String']>
  kind: VenueAssetKind
  spaceScope?: InputMaybe<Array<Scalars['Int']>>
  structured?: InputMaybe<Scalars['JSON']>
  title: Scalars['String']
  validFrom?: InputMaybe<Scalars['String']>
  validUntil?: InputMaybe<Scalars['String']>
  venueId: Scalars['Int']
}

export enum VenueAssetKind {
  CopyBlock = 'copyBlock',
  DrinksList = 'drinksList',
  Menu = 'menu',
  Package = 'package',
  Rate = 'rate',
  Spec = 'spec',
  Terms = 'terms',
}

export type VenueAssetUploadInfo = {
  __typename?: 'VenueAssetUploadInfo'
  URL: Scalars['String']
  key: Scalars['String']
}

export type VenueCandidate = {
  __typename?: 'VenueCandidate'
  address: Scalars['String']
  createdAt: Scalars['String']
  fullDescription?: Maybe<Scalars['String']>
  id: Scalars['String']
  lastResearchedAt?: Maybe<Scalars['String']>
  name: Scalars['String']
  researchData?: Maybe<Scalars['String']>
  shortDescription?: Maybe<Scalars['String']>
  status: Scalars['String']
  updatedAt: Scalars['String']
  vectorData?: Maybe<Scalars['String']>
}

/** Booking lifecycle status as seen by hb-venue-claim's lead nudge sweep. */
export type VenueClaimBookingStatus = {
  __typename?: 'VenueClaimBookingStatus'
  bookingId: Scalars['Int']
  closed: Scalars['Boolean']
  lifecycleStage: EventStatus
  onHold: Scalars['Boolean']
}

export type VenueComment = {
  __typename?: 'VenueComment'
  authorName?: Maybe<Scalars['String']>
  authorUserId: Scalars['Int']
  body: Scalars['String']
  /** ISO 8601. */
  createdAt: Scalars['String']
  /** AVOID_FLAG only: the structured reasons picked in the flag dialog. */
  flagReasons?: Maybe<Array<Scalars['String']>>
  id: Scalars['ID']
  kind: VenueCommentKind
  /** Written by someone at the event's company, as opposed to another HeadBox client. */
  sameCompany: Scalars['Boolean']
  /** The author's own 1–5 rating of the venue, when they left one. */
  stars?: Maybe<Scalars['Int']>
}

export enum VenueCommentKind {
  AvoidFlag = 'AVOID_FLAG',
  Note = 'NOTE',
}

export enum VenueConfirmationConfidence {
  Assumed = 'Assumed',
  Confirmed = 'Confirmed',
}

export type VenueConfirmationMatch = {
  __typename?: 'VenueConfirmationMatch'
  countryVerified: Scalars['Boolean']
  matchType: VenueConfirmationMatchType
  matchedProposalID?: Maybe<Scalars['Int']>
  suggestedVenue?: Maybe<VenueConfirmationSuggestedVenue>
}

export enum VenueConfirmationMatchType {
  MatchesOtherProposal = 'MatchesOtherProposal',
  MatchesRequested = 'MatchesRequested',
  MatchesVenue = 'MatchesVenue',
  MatchesVenuePartial = 'MatchesVenuePartial',
  NoMatch = 'NoMatch',
}

export type VenueConfirmationSuggestedVenue = {
  __typename?: 'VenueConfirmationSuggestedVenue'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  venueID: Scalars['Int']
  venueName: Scalars['String']
}

export enum VenueConfirmationSwapReason {
  ClientPreferenceChanged = 'ClientPreferenceChanged',
  DataCorrection = 'DataCorrection',
  OriginalVenueUnavailable = 'OriginalVenueUnavailable',
  Other = 'Other',
  ResourcedDuringContracting = 'ResourcedDuringContracting',
}

/** Signed commercial agreement between a venue group and HeadBox. */
export type VenueContract = {
  __typename?: 'VenueContract'
  /** Lines live on the given date (default today): the purchased packages as the customer sees them. */
  activeLines: Array<VenueContractLine>
  /** Derived: monthlyValue × 12 (ARR for this contract). */
  annualValue?: Maybe<Scalars['Float']>
  createdAt: Scalars['DateTime']
  /** ISO 4217. Defaults from the market when a value is set. */
  currency?: Maybe<Scalars['String']>
  ends: Scalars['Date']
  id: Scalars['Int']
  /** Staff only; null for hosts. */
  internalNotes?: Maybe<Scalars['String']>
  lastSavedAt: Scalars['DateTime']
  /** Staff only; null for hosts. */
  lastSavedBy?: Maybe<User>
  /** All lines, including superseded and ended ones (history). */
  lines: Array<VenueContractLine>
  /** Locked once active; determines legal entity and currency. */
  market: VenueGroupMarket
  /** Derived: totalValue spread evenly over the term (MRR for this contract). */
  monthlyValue?: Maybe<Scalars['Float']>
  reference: Scalars['String']
  /** Staff only; null for hosts. */
  renewalNextAction?: Maybe<Scalars['String']>
  /** Staff only; null for hosts. */
  renewalNextActionOn?: Maybe<Scalars['Date']>
  /** Renewal pipeline: CRM state kept by the renewals team, separate from the contract's terms. Staff only; null for hosts. */
  renewalStage?: Maybe<VenueContractRenewalStage>
  /** When CS last checked the contract's terms, packages, venues and dates; null: not yet (e.g. imported). Staff only. */
  reviewedAt?: Maybe<Scalars['DateTime']>
  /** Staff only. */
  reviewedBy?: Maybe<User>
  signedPdfFilename?: Maybe<Scalars['String']>
  /** Download URL for the signed PDF, when uploaded. */
  signedPdfUrl?: Maybe<Scalars['String']>
  starts: Scalars['Date']
  /** Derived: an active contract past its end date reads as expired. */
  status: VenueContractStatus
  /** Optional value of the whole term, in currency: the number on the signed contract. */
  totalValue?: Maybe<Scalars['Float']>
  venueGroup: VenueGroup
  venueGroupId: Scalars['Int']
  version: Scalars['Int']
}

/** Signed commercial agreement between a venue group and HeadBox. */
export type VenueContractActiveLinesArgs = {
  on?: InputMaybe<Scalars['Date']>
}

export type VenueContractFiltersInput = {
  market?: InputMaybe<VenueGroupMarket>
  /** true: reviewed by CS; false: not yet reviewed. */
  reviewed?: InputMaybe<Scalars['Boolean']>
  /** Matches the reference. */
  search?: InputMaybe<Scalars['String']>
  status?: InputMaybe<VenueContractStatus>
  venueGroupId?: InputMaybe<Scalars['Int']>
}

/** Customer-facing: a purchased package on a contract. */
export type VenueContractLine = {
  __typename?: 'VenueContractLine'
  allocations: Array<VenueAllocation>
  /** Venues assigned today (phase 4; 0 until then). */
  assignedCount: Scalars['Int']
  contractId: Scalars['Int']
  /** Null = until the contract ends. */
  ends?: Maybe<Scalars['Date']>
  id: Scalars['Int']
  package: ProductPackage
  /** Maximum concurrent venue assignments. */
  quantity: Scalars['Int']
  starts: Scalars['Date']
  /** Set when an edit on an active contract replaced this line. */
  supersededByLineId?: Maybe<Scalars['Int']>
}

export type VenueContractLineInput = {
  /** Default: until the contract ends. */
  ends?: InputMaybe<Scalars['Date']>
  /** Present when editing an existing line. */
  id?: InputMaybe<Scalars['Int']>
  packageId: Scalars['Int']
  quantity: Scalars['Int']
  /** Default: the contract's start. */
  starts?: InputMaybe<Scalars['Date']>
}

export type VenueContractRenewalInput = {
  /** Short free text, e.g. Send proposal. Null clears it. */
  nextAction?: InputMaybe<Scalars['String']>
  /** Null clears it. */
  nextActionOn?: InputMaybe<Scalars['Date']>
  stage?: InputMaybe<VenueContractRenewalStage>
}

/** Where the renewal conversation has got to. signed and lost close it. */
export enum VenueContractRenewalStage {
  Contacted = 'contacted',
  Lost = 'lost',
  NotStarted = 'not_started',
  ProposalSent = 'proposal_sent',
  Signed = 'signed',
  VerbalYes = 'verbal_yes',
}

export type VenueContractSignedPdfUploadInfo = {
  __typename?: 'VenueContractSignedPdfUploadInfo'
  s3Key: Scalars['String']
  url: Scalars['String']
}

export enum VenueContractStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Draft = 'draft',
  Expired = 'expired',
}

export type VenueContractsPage = {
  __typename?: 'VenueContractsPage'
  page: Page
  rows: Array<VenueContract>
  totalPages: Scalars['Int']
  totalRows: Scalars['Int']
}

export type VenueEntitlements = {
  __typename?: 'VenueEntitlements'
  featureKeys: Array<Scalars['String']>
  venueId: Scalars['Int']
}

export type VenueFiltersInput = {
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  geolocation?: InputMaybe<GeolocationFilterInput>
  ids?: InputMaybe<Array<Scalars['Int']>>
  leadFeedEnabled?: InputMaybe<Scalars['Boolean']>
  publishedSpacesOnly?: InputMaybe<Scalars['Boolean']>
  userIds?: InputMaybe<Array<Scalars['Int']>>
  venueNameLike?: InputMaybe<Scalars['String']>
}

/** The customer account that owns venues, team seats and (phase 3) contracts. */
export type VenueGroup = {
  __typename?: 'VenueGroup'
  /** HeadBox staff member looking after the account (resolved from RedBox). Staff and active members; null for anyone else. */
  accountManager?: Maybe<User>
  accountManagerUserId?: Maybe<Scalars['Int']>
  /** Staff and owners; empty for anyone else. */
  contracts: Array<VenueContract>
  createdAt: Scalars['DateTime']
  /** Account health, computed on read. Staff only. Null when the group has no live contract. */
  health?: Maybe<VenueGroupHealth>
  id: Scalars['Int']
  markets: Array<VenueGroupMarket>
  /** Live seats (invited, active, suspended); revoked invitations are excluded. Staff and active members; empty for anyone else. */
  memberships: Array<VenueGroupMembership>
  name: Scalars['String']
  /** Staff and active members; empty for anyone else. */
  owners: Array<VenueGroupMembership>
  /** Whether the group has team management (any of its venues has the team_management feature today): its owners may then manage their own team. Staff always can. False for anyone who can't see the team. */
  teamManagement: Scalars['Boolean']
  venueCount: Scalars['Int']
  venues: Array<Venue>
}

export type VenueGroupAttachment = {
  __typename?: 'VenueGroupAttachment'
  contentType?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  /** Short-lived signed URL; request the note again for a fresh one. */
  downloadUrl: Scalars['String']
  filename: Scalars['String']
  id: Scalars['Int']
  sizeBytes?: Maybe<Scalars['Int']>
  uploadedBy?: Maybe<User>
}

export type VenueGroupAttachmentInput = {
  contentType?: InputMaybe<Scalars['String']>
  filename: Scalars['String']
  s3Key: Scalars['String']
  sizeBytes?: InputMaybe<Scalars['Int']>
}

export type VenueGroupAttachmentUploadInfo = {
  __typename?: 'VenueGroupAttachmentUploadInfo'
  s3Key: Scalars['String']
  url: Scalars['String']
}

export type VenueGroupAuditEntriesPage = {
  __typename?: 'VenueGroupAuditEntriesPage'
  page: Page
  rows: Array<VenueGroupAuditEntry>
  totalPages: Scalars['Int']
  totalRows: Scalars['Int']
}

/** One row of the venue group-domain audit trail. Prefixed: the gateway already stitches an unrelated AdminAuditEntry. */
export type VenueGroupAuditEntry = {
  __typename?: 'VenueGroupAuditEntry'
  action: Scalars['String']
  actor?: Maybe<User>
  actorUserId?: Maybe<Scalars['Int']>
  createdAt: Scalars['DateTime']
  /** JSON-encoded details of the change. */
  details?: Maybe<Scalars['String']>
  id: Scalars['Int']
  /** True when HeadBox staff acted on a customer's account. */
  onBehalfOf: Scalars['Boolean']
  targetId: Scalars['String']
  targetType: Scalars['String']
  venueGroupId?: Maybe<Scalars['Int']>
}

export enum VenueGroupCapability {
  ManageListings = 'manage_listings',
  RespondToEnquiries = 'respond_to_enquiries',
  ViewReports = 'view_reports',
}

export type VenueGroupFiltersInput = {
  /** Churned: a contract has ended (expired or cancelled) and none is active now or signed to start later. */
  churned?: InputMaybe<Scalars['Boolean']>
  /** Only venue groups with a contract in this status (expired is derived from the end date). */
  contractStatus?: InputMaybe<VenueContractStatus>
  /** Only venue groups with at least one contract. */
  hasContract?: InputMaybe<Scalars['Boolean']>
  ids?: InputMaybe<Array<Scalars['Int']>>
  market?: InputMaybe<VenueGroupMarket>
  /** Matches venue group name, venue name, or member email. */
  search?: InputMaybe<Scalars['String']>
}

/** Start at 100, minus points for each warning sign; reasons explain every deduction in plain English. */
export type VenueGroupHealth = {
  __typename?: 'VenueGroupHealth'
  level: VenueGroupHealthLevel
  /** What is going well. Not scored. */
  positives: Array<Scalars['String']>
  /** One plain sentence summing the account up. */
  read: Scalars['String']
  reasons: Array<Scalars['String']>
  score: Scalars['Int']
}

export enum VenueGroupHealthLevel {
  Amber = 'amber',
  Green = 'green',
  Red = 'red',
}

export enum VenueGroupMarket {
  Au = 'AU',
  Nz = 'NZ',
  Uk = 'UK',
  Us = 'US',
}

export type VenueGroupMembership = {
  __typename?: 'VenueGroupMembership'
  acceptedAt?: Maybe<Scalars['DateTime']>
  capabilities: Array<VenueGroupCapability>
  createdAt: Scalars['DateTime']
  /** Address the invitation went to; null for backfilled legacy owners (use user.email). */
  email?: Maybe<Scalars['String']>
  id: Scalars['Int']
  invitedAt?: Maybe<Scalars['DateTime']>
  invitedFirstName?: Maybe<Scalars['String']>
  invitedLastName?: Maybe<Scalars['String']>
  lastActiveAt?: Maybe<Scalars['DateTime']>
  role: VenueGroupMembershipRole
  status: VenueGroupMembershipStatus
  suspendedAt?: Maybe<Scalars['DateTime']>
  /** Resolved from RedBox when the seat is bound to a user. */
  user?: Maybe<User>
  userId?: Maybe<Scalars['Int']>
  venueGroup: VenueGroup
  venueGroupId: Scalars['Int']
  /** Null means every venue in the venue group. */
  venueIds?: Maybe<Array<Scalars['Int']>>
}

export enum VenueGroupMembershipRole {
  Member = 'member',
  Owner = 'owner',
}

export enum VenueGroupMembershipStatus {
  Active = 'active',
  Invited = 'invited',
  Revoked = 'revoked',
  Suspended = 'suspended',
}

export type VenueGroupNote = {
  __typename?: 'VenueGroupNote'
  attachments: Array<VenueGroupAttachment>
  author?: Maybe<User>
  /** Markdown. */
  body: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['Int']
  pinned: Scalars['Boolean']
  sharedAt?: Maybe<Scalars['DateTime']>
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  venueGroupId: Scalars['Int']
  visibility: VenueGroupNoteVisibility
}

export type VenueGroupNoteInput = {
  body: Scalars['String']
  /** Email the venue group's active owners. Only applies when sharing. */
  notifyOwners?: InputMaybe<Scalars['Boolean']>
  pinned?: InputMaybe<Scalars['Boolean']>
  title?: InputMaybe<Scalars['String']>
  visibility: VenueGroupNoteVisibility
}

export enum VenueGroupNoteVisibility {
  Internal = 'internal',
  Shared = 'shared',
}

export enum VenueGroupSortField {
  Created = 'created',
  Name = 'name',
  /** Earliest end date of a live contract; groups without one come last. */
  NextRenewal = 'nextRenewal',
  VenueCount = 'venueCount',
}

export type VenueGroupSortInput = {
  direction?: InputMaybe<SortDirection>
  field: VenueGroupSortField
}

export type VenueGroupsPage = {
  __typename?: 'VenueGroupsPage'
  page: Page
  rows: Array<VenueGroup>
  totalPages: Scalars['Int']
  totalRows: Scalars['Int']
}

export type VenueInput = {
  addressLine1: Scalars['String']
  addressLine2?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  country: Scalars['String']
  googlePlaceID?: InputMaybe<Scalars['String']>
  googleReviewsEnabled?: InputMaybe<Scalars['Boolean']>
  latitude: Scalars['Float']
  leadFeedEnabled?: InputMaybe<Scalars['Boolean']>
  longitude: Scalars['Float']
  name: Scalars['String']
  placeIDMigrated?: InputMaybe<Scalars['Boolean']>
  postalCode: Scalars['String']
  state?: InputMaybe<Scalars['String']>
  sustainabilityInitiativeIds?: InputMaybe<Array<Scalars['Int']>>
  totalFloorArea?: InputMaybe<Scalars['Float']>
}

/**
 * How much of the live registries' auto-answerable ask this venue covers with
 * no typing. The assets themselves live in host-listing; health stays here
 * because it is defined against the requirement registries.
 */
export type VenueLibraryHealth = {
  __typename?: 'VenueLibraryHealth'
  categories: Array<VenueLibraryHealthCategory>
  percent: Scalars['Int']
  suggestions: Array<Scalars['String']>
}

export type VenueLibraryHealthCategory = {
  __typename?: 'VenueLibraryHealthCategory'
  covered: Scalars['Int']
  key: Scalars['String']
  label: Scalars['String']
  total: Scalars['Int']
}

export type VenueRatingSummary = {
  __typename?: 'VenueRatingSummary'
  /** 1–5, one decimal. */
  average: Scalars['Float']
  count: Scalars['Int']
}

export type VenueRequest = {
  __typename?: 'VenueRequest'
  hostId?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  prompt?: Maybe<Scalars['String']>
  space?: Maybe<SelfServeSpace>
  spaceId: Scalars['Int']
}

export type VenueRequestInput = {
  hostId: Scalars['Int']
  prompt?: InputMaybe<Scalars['String']>
  spaceDescription?: InputMaybe<Scalars['String']>
  spaceFacilityNames?: InputMaybe<Array<Scalars['String']>>
  spaceId: Scalars['Int']
  spaceName?: InputMaybe<Scalars['String']>
}

/**
 * What the client's company knows about a venue: the booker-side ratings,
 * favourites and notes, aggregated for HeadBox staff. Staff only: this is the
 * one read that crosses the company boundary.
 */
export type VenueSignals = {
  __typename?: 'VenueSignals'
  /** The event's booker (not the company) has favourited the venue. */
  bookerFavourite: Scalars['Boolean']
  /** Newest first. Other companies' notes are included, flagged sameCompany = false. */
  comments: Array<VenueComment>
  /** Ratings from bookers at the event's company. */
  companyRating?: Maybe<VenueRatingSummary>
  /** Ratings from every HeadBox booker, this company included. */
  overallRating?: Maybe<VenueRatingSummary>
  /**
   * HeadBox-internal M&E notes on the venue, newest first. Visible to all
   * staff; editable and deletable by their author only.
   */
  staffNotes: Array<StaffVenueNote>
  venueId: Scalars['Int']
}

export type VersionInformation = {
  __typename?: 'VersionInformation'
  name: Scalars['String']
  semver: Scalars['String']
}

export type WithinRadiusRanking = {
  /** Number of positive points to be assigned if a space is within the specified radius */
  positivePoints: Scalars['Int']
  /** Distance from the brief location in metres */
  withinRadiusMetres: Scalars['Int']
}
